function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-coding:not(.animated) .animable {opacity: 0;}svg#freepik_stories-coding.animated\r\n        #freepik--Floor--inject-1--inject-13 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38)\r\n        fadeIn;animation-delay: 0s;}svg#freepik_stories-coding.animated #freepik--Shadow--inject-1--inject-13\r\n        {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay:\r\n        0s;}svg#freepik_stories-coding.animated #freepik--binary-code--inject-1--inject-13 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-coding.animated\r\n        #freepik--Server--inject-1--inject-13 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38)\r\n        zoomIn;animation-delay: 0s;}svg#freepik_stories-coding.animated #freepik--Plants--inject-1--inject-13\r\n        {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay:\r\n        0s;}svg#freepik_stories-coding.animated #freepik--Device--inject-1--inject-13 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-coding.animated\r\n        #freepik--Window--inject-1--inject-13 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38)\r\n        slideLeft;animation-delay: 0s;}svg#freepik_stories-coding.animated #freepik--Icons--inject-1--inject-13\r\n        {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay:\r\n        0s;}svg#freepik_stories-coding.animated #freepik--Character--inject-1--inject-13 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;} @keyframes fadeIn { 0% { opacity: 0; } 100% {\r\n        opacity: 1; } } @keyframes lightSpeedRight { from { transform: translate3d(50%, 0, 0) skewX(-20deg); opacity: 0;\r\n        } 60% { transform: skewX(10deg); opacity: 1; } 80% { transform: skewX(-2deg); } to { opacity: 1; transform:\r\n        translate3d(0, 0, 0); } } @keyframes zoomOut { 0% { opacity: 0; transform: scale(1.5); } 100% { opacity: 1;\r\n        transform: scale(1); } } @keyframes zoomIn { 0% { opacity: 0; transform: scale(0.5); } 100% { opacity: 1;\r\n        transform: scale(1); } } @keyframes slideDown { 0% { opacity: 0; transform: translateY(-30px); } 100% { opacity:\r\n        1; transform: translateY(0); } } @keyframes slideLeft { 0% { opacity: 0; transform: translateX(-30px); } 100% {\r\n        opacity: 1; transform: translateX(0); } }\r\n    ");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "active",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#32DFEC",
  floodOpacity: 1,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "hover",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff0000",
  floodOpacity: 0.5,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
})));

function SvgComingsoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-coding",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "249.53px 348.64px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1--inject-13",
    cx: 249.53,
    cy: 348.64,
    rx: 235.12,
    ry: 135.74,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "249.53px 348.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "242.834px 335.15px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-13",
    d: "M235.66,441.23,91.59,358.05c-.6-.34-.6-.9,0-1.25L312.83,229.07a2.37,2.37,0,0,1,2.17,0l144.07,83.18c.6.34.6.9,0,1.25L237.82,441.23A2.35,2.35,0,0,1,235.66,441.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.33px 335.15px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-13",
    d: "M26.59,343.82c-.59-.34-.59-.9,0-1.25l79.07-45.49a2.4,2.4,0,0,1,2.17,0l55,31.42a.65.65,0,0,1,0,1.24L82.4,376.18S34.44,348.37,26.59,343.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "94.7161px 336.5px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-1--inject-13",
    cx: 377.44,
    cy: 415.72,
    rx: 36.78,
    ry: 21.24,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "377.44px 415.72px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary-code--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "143.743px 169.458px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary-code--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "143.743px 169.458px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,135.73c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.27,5.27,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,57.5,135.73Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.2,2.2,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S53.48,140.31,53.5,140.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 138.65px"
    },
    id: "els1w692n3f8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.05,132c0,.19,0,.4,0,.64V134c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,7.22,7.22,0,0,1-.45,1.58,5.6,5.6,0,0,1-.82,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.79,12.79,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.12,1.12,0,0,1,.82.4,2.53,2.53,0,0,1,.45,1.06A8.46,8.46,0,0,1,64.05,132Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S60,136.53,60,136.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "61.375px 134.83px"
    },
    id: "eli9c36ousa3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,128.17c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,70.59,128.17Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.29.52.3,1,0a2.18,2.18,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.35-1.5c-.19-.29-.52-.31-1,0a2.2,2.2,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S66.57,132.75,66.58,133.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "67.915px 131.08px"
    },
    id: "elbln8at5toua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,127.13a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.52.52,0,0,1-.18.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51c-.06.11-.12.18-.19.2a.17.17,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.2749px 127.336px"
    },
    id: "elg5zkmuhalir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,121.74c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,81.73,121.74Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.34-1.5c-.19-.3-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S77.71,126.32,77.72,126.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.055px 124.65px"
    },
    id: "elw4bis2ftr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,120.7a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86L85,116a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.48.48,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.4049px 120.945px"
    },
    id: "elpp8tokc8m1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.87,115.31V118a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5.27,5.27,0,0,1-.81,1.35,4.56,4.56,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,8.52,8.52,0,0,1-.17-1.54q0-.57,0-1.32c0-.49,0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.46,8.46,0,0,1,92.87,115.31Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S88.85,119.89,88.86,120.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "90.195px 118.205px"
    },
    id: "els29cn3w1d6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.41,111.53c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6A5.69,5.69,0,0,1,95.5,110a4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.46,8.46,0,0,1,99.41,111.53Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S95.39,116.12,95.4,116.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "96.735px 114.47px"
    },
    id: "elhxkk274uia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,110.49a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.15.15,0,0,1-.19,0,.3.3,0,0,1-.08-.25v-7.56L101.13,111a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "102.095px 110.712px"
    },
    id: "eleu42hphsz9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,107.84a.38.38,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.51.51,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.648px 108.044px"
    },
    id: "elnu0j4tu6lti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,105.19a.41.41,0,0,1,0-.28.79.79,0,0,1,.1-.33l2.16-3.86c0-.1.11-.19.16-.28a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24V110a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "111.284px 105.423px"
    },
    id: "el0v24yen3c9tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,99.8c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a10.93,10.93,0,0,1-.17,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.32,5.32,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1,2.38,2.38,0,0,1,1.23-.39,1.08,1.08,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A7.81,7.81,0,0,1,119.73,99.8Zm-4,5a3,3,0,0,0,.34,1.51q.3.44,1,0a2.2,2.2,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.52-.3-1,0a2.28,2.28,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S115.71,104.38,115.73,104.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "117.06px 102.725px"
    },
    id: "eldydchm3eo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,98.76a.47.47,0,0,1-.06-.28,1,1,0,0,1,.11-.33l2.16-3.87c.05-.09.1-.18.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24V96.74l-1.42,2.51a.37.37,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "122.379px 98.9634px"
    },
    id: "elqhgko46ztp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.87,93.37c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.07,1.07,0,0,1-.82-.4,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.5,4.5,0,0,1,1.23-1,2.38,2.38,0,0,1,1.23-.39,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,130.87,93.37Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.29.43,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.19,2.19,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S126.85,98,126.86,98.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.195px 96.295px"
    },
    id: "elbmc000nhlxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75,92.33a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33L134,87.85l.17-.27a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V90.31l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.543px 92.5334px"
    },
    id: "elwhv1ffdp9vg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,86.94c0,.19,0,.4,0,.64V89c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.32,2.32,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.87,6.87,0,0,1,.45-1.6,5.89,5.89,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,142,86.94Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51q-.28-.44-1,0a2.18,2.18,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S138,91.52,138,91.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "139.325px 89.84px"
    },
    id: "el45b4kx8iejx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,85.9a.47.47,0,0,1,0-.28,1,1,0,0,1,.1-.33l2.16-3.87.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24v9.89a.83.83,0,0,1-.07.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V83.88l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "144.695px 86.095px"
    },
    id: "elkmjiod7oryb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,83.24a.42.42,0,0,1-.06-.27,1,1,0,0,1,.11-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24V88a.88.88,0,0,1-.08.34.5.5,0,0,1-.19.23L150,89a.14.14,0,0,1-.19,0,.3.3,0,0,1-.08-.25V81.22l-1.42,2.52a.35.35,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.249px 83.4316px"
    },
    id: "eltxtkcpqtb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07,80.59a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.52.52,0,0,1-.18.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25V78.57l-1.41,2.51c-.06.11-.12.18-.19.2a.17.17,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.885px 80.7956px"
    },
    id: "elqgm197fhqxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34,75.2c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,4.85,4.85,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1A9.53,9.53,0,0,1,157,81c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.06,1.06,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.46,8.46,0,0,1,162.34,75.2Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.34-1.5c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S158.32,79.78,158.33,80.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "159.67px 78.11px"
    },
    id: "eltn9fzr0q3ff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,74.16a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.49.49,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.41.41,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.36.36,0,0,1-.08-.25V72.14l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "164.983px 74.365px"
    },
    id: "eln0gvr9462zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,68.77c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,173.47,68.77Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S169.45,73.35,169.47,73.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.795px 71.68px"
    },
    id: "el4zlssr1muui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,67.73a.38.38,0,0,1,0-.27.7.7,0,0,1,.1-.34l2.16-3.86.16-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25V72.5a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.32.32,0,0,1-.08-.25V65.71l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "176.163px 67.923px"
    },
    id: "el74r2n2wczw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.61,62.34c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.39,2.39,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,184.61,62.34Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.53-.31-1,0a2.18,2.18,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S180.59,66.92,180.61,67.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "181.935px 65.275px"
    },
    id: "el8qb39qgwqeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.16,58.56v2.73A12.34,12.34,0,0,1,191,63a6.86,6.86,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.08,1.08,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34A12.64,12.64,0,0,1,186,60a7.25,7.25,0,0,1,.46-1.6,5.38,5.38,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4A2.32,2.32,0,0,1,191,57,8.46,8.46,0,0,1,191.16,58.56Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6,6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S187.14,63.15,187.15,63.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.495px 61.48px"
    },
    id: "elsn4e6byh1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,54.79c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.44,4.44,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,197.7,54.79Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.43-1,0a2.24,2.24,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S193.68,59.37,193.69,59.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.025px 57.685px"
    },
    id: "ell3nrw81ma8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57,53.75a.47.47,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V51.72l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "200.386px 53.9416px"
    },
    id: "el9wf5eu5qq1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,48.36c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.53,4.53,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,208.84,48.36Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.28,2.28,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S204.82,52.94,204.83,53.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.165px 51.265px"
    },
    id: "elgvpynkp7yv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,47.32a.41.41,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24V45.29l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.482px 47.5116px"
    },
    id: "el0y4k4m8oqk5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,41.93c0,.19,0,.4,0,.63V44c0,.24,0,.45,0,.65a12.36,12.36,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.53,4.53,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.36,2.36,0,0,1-.46-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.75,6.75,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A8.64,8.64,0,0,1,220,41.93Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.21,2.21,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S216,46.51,216,46.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.325px 44.835px"
    },
    id: "eljj782uqlcyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.85,40.89a.4.4,0,0,1-.06-.28.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.13.13,0,0,1-.18,0,.29.29,0,0,1-.08-.24V38.86l-1.42,2.52a.38.38,0,0,1-.19.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.618px 41.0811px"
    },
    id: "elbgink8r9lbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,35.5c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.34,4.34,0,0,1-1.22,1,2.33,2.33,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.37,2.37,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,231.11,35.5Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.22,2.22,0,0,0,1-1.17,6,6,0,0,0,.35-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S227.09,40.08,227.1,40.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "228.435px 38.43px"
    },
    id: "elhrccobhfs8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,34.45a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34L234.19,30l.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25V32.43L232.83,35a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.763px 34.6716px"
    },
    id: "ellhz2a78q1ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.84,156.84a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33L54,152.36l.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "53.588px 157.032px"
    },
    id: "el7qrp1rcvktj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,151.45c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.58,8.58,0,0,1,62.1,151.45Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.28-.43-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S58.08,156,58.09,156.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.425px 154.355px"
    },
    id: "el7rpmzdcutel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.64,147.67c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.34,2.34,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36A4.7,4.7,0,0,1,66,145.06a2.37,2.37,0,0,1,1.22-.39,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,68.64,147.67Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.44,1,0A2.28,2.28,0,0,0,67,153a6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28A3.13,3.13,0,0,0,67,147q-.3-.44-1,0a2.19,2.19,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S64.62,152.25,64.63,152.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "65.965px 150.56px"
    },
    id: "elipo20v7nsoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.18,143.89c0,.19,0,.4,0,.64V146c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.08,1.08,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1.05,8.57,8.57,0,0,1-.18-1.54c0-.39,0-.82,0-1.32s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,7.4,7.4,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,75.18,143.89Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.43-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S71.16,148.47,71.18,148.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "72.505px 146.83px"
    },
    id: "eleq921z2adeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,140.11c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.79,6.79,0,0,1-.45,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.32,2.32,0,0,1,.45,1A8.46,8.46,0,0,1,81.73,140.11Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.3.53.31,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S77.71,144.7,77.72,145.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.055px 143.02px"
    },
    id: "elhw9g1umr7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,139.07a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.48.48,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51a.38.38,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.4149px 139.275px"
    },
    id: "elqdxfo7k42wp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.87,133.68v2.73a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5.1,5.1,0,0,1-.81,1.35,4.56,4.56,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.52,8.52,0,0,1-.17-1.54q0-.57,0-1.32c0-.49,0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.06,1.06,0,0,1,.81.41,2.32,2.32,0,0,1,.46,1A8.46,8.46,0,0,1,92.87,133.68Zm-4,5a3,3,0,0,0,.34,1.5c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.29-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S88.85,138.26,88.86,138.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "90.195px 136.59px"
    },
    id: "elh57ucoxay1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,132.64a.33.33,0,0,1,0-.27.7.7,0,0,1,.1-.34L96,128.17c0-.09.1-.18.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.32.32,0,0,1-.08-.25v-7.56l-1.41,2.51c-.07.11-.13.18-.2.2a.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "95.5509px 132.828px"
    },
    id: "elghsfavhil85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,127.25c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.38,5.38,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.08,1.08,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,104,127.25Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.53-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S100,131.83,100,132.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.325px 130.185px"
    },
    id: "elky346smkf3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,126.21a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25V131a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56l-1.42,2.51c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.648px 126.429px"
    },
    id: "ellfri05my3ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,123.56a.41.41,0,0,1,0-.28.84.84,0,0,1,.1-.33l2.16-3.86c0-.1.11-.19.16-.27a.61.61,0,0,1,.19-.2l.77-.44a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25v9.88a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "111.284px 123.763px"
    },
    id: "el55rhkf73jbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,120.91a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-7.57l-1.42,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.838px 121.102px"
    },
    id: "elomhfex79wt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.33,115.52c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.39,2.39,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,124.33,115.52Zm-4,5a3.25,3.25,0,0,0,.34,1.51c.2.29.53.3,1,0a2.22,2.22,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.22,2.22,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S120.31,120.1,120.32,120.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.655px 118.415px"
    },
    id: "elnlsvex5u89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,114.48a.47.47,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87c0-.09.11-.18.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57L126.05,115a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "127.016px 114.672px"
    },
    id: "elfe4fuv1hwee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,109.09c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,7.22,7.22,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.44,4.44,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.08,1.08,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1.05A8.58,8.58,0,0,1,135.47,109.09Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S131.45,113.67,131.46,114.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "132.795px 112.01px"
    },
    id: "elitz4of9svhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,108.05a.47.47,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V106l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "138.113px 108.242px"
    },
    id: "el9w1qs6coycl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.94,105.39a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "142.708px 105.595px"
    },
    id: "eli48jg2ggvyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,100c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.49,7.49,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,151.2,100Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.3.52.31,1,0a2.24,2.24,0,0,0,1-1.18,6.53,6.53,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.25,3.25,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.2,2.2,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S147.18,104.59,147.19,105Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "148.525px 102.935px"
    },
    id: "eldmci31j2wd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74,96.23c0,.19,0,.4,0,.63V98.3c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.36,2.36,0,0,1-.45-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76A6.74,6.74,0,0,1,153,96a5.42,5.42,0,0,1,.82-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,157.74,96.23Zm-4,5a3,3,0,0,0,.34,1.51q.28.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.12,2.12,0,0,0-1,1.17,6,6,0,0,0-.34,1.91q0,.59,0,1.29C153.71,100.38,153.72,100.81,153.74,101.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "155.065px 99.13px"
    },
    id: "elgg60wjvi8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.62,95.19a.4.4,0,0,1-.06-.28.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24V100a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V93.16l-1.41,2.52a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "160.388px 95.4166px"
    },
    id: "elpsof260n8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,89.8c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.33,2.33,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.36,2.36,0,0,1-.45-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,168.88,89.8Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.2,2.2,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S164.86,94.38,164.87,94.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.205px 92.705px"
    },
    id: "elsjglucqk29p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,88.75a.36.36,0,0,1-.06-.27.72.72,0,0,1,.11-.34L172,84.28l.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25V86.73l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.548px 88.9516px"
    },
    id: "ell9pkue4pj2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,83.37c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.58,8.58,0,0,1,180,83.37Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S176,88,176,88.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "177.325px 86.275px"
    },
    id: "ele2y3nwto9ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,82.32a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25V80.3l-1.41,2.52a.4.4,0,0,1-.2.19.15.15,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "182.705px 82.542px"
    },
    id: "elrc252dh0n3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.49,79.67a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.51.51,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25V77.65l-1.42,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.258px 79.8744px"
    },
    id: "eldakabo7ree6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,74.28c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.42,2.42,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.22,4.22,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,195.75,74.28Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.2,2.2,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.3-.52-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S191.73,78.86,191.74,79.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "193.075px 77.215px"
    },
    id: "elyl3nhczf98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.29,70.5c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.53,2.53,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,202.29,70.5Zm-4,5a3,3,0,0,0,.34,1.51q.28.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6,6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S198.27,75.09,198.29,75.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.615px 73.415px"
    },
    id: "el8mw8k8eymfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,69.46a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34L205.38,65c.05-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.5.5,0,0,1-.19.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.07-.25V67.44L204,70a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.937px 69.675px"
    },
    id: "eljgmrl48thkh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43,64.07c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.25,2.25,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.45,4.45,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,213.43,64.07Zm-4,5a3.14,3.14,0,0,0,.35,1.51c.19.29.52.3,1,0a2.24,2.24,0,0,0,1-1.18,6.53,6.53,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.25,3.25,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.2,2.2,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S209.41,68.66,209.42,69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "210.755px 66.9849px"
    },
    id: "eldt2bc80vocu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.31,63a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25V67.8a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25V61l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "216.077px 63.225px"
    },
    id: "ellpctf3ly3gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,57.64c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.46,8.46,0,0,1,224.57,57.64Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S220.55,62.23,220.56,62.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "221.895px 60.5549px"
    },
    id: "eldoocofqoqxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,56.6a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.48.48,0,0,1-.19.24l-.8.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25V54.58l-1.41,2.52a.43.43,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.214px 56.822px"
    },
    id: "elem8h4w57iqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,51.21v2.73a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.64,12.64,0,0,1,.17-1.76A7.5,7.5,0,0,1,231,51a5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.46,8.46,0,0,1,235.71,51.21Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S231.69,55.8,231.7,56.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.035px 54.13px"
    },
    id: "eln852je0b6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,172.47c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.05,5.05,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1,2.38,2.38,0,0,1,1.23-.39,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,57.5,172.47Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S53.48,177.05,53.5,177.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 175.395px"
    },
    id: "elkwuqc29nhfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,168.61c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.36,12.36,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4A2.48,2.48,0,0,1,59,176a8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34A12.64,12.64,0,0,1,59,170a7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A8.64,8.64,0,0,1,64.19,168.61Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.43,1,0a2.26,2.26,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S60.17,173.19,60.19,173.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "61.505px 171.52px"
    },
    id: "ely47e1z5ird",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,167.48a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33L67.42,163l.17-.28a.83.83,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.56L66.06,168a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "66.988px 167.673px"
    },
    id: "elro6k2p8d9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,162c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,75.63,162Zm-4,5a3.32,3.32,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S71.61,166.59,71.62,167Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "72.955px 164.915px"
    },
    id: "elr0lph21la2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,160.88a.47.47,0,0,1-.05-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.4234px 161.083px"
    },
    id: "elq6b7jw1qpdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.06,155.4c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.37,2.37,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.45-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.63,5.63,0,0,1,.81-1.36,4.49,4.49,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,87.06,155.4Zm-4,5a3,3,0,0,0,.34,1.5c.2.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.53-.31-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S83,160,83.06,160.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.385px 158.31px"
    },
    id: "el2f8j77t75yt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09,154.28A.4.4,0,0,1,88,154a.65.65,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24V159a.83.83,0,0,1-.07.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "89.8255px 154.462px"
    },
    id: "elwf04pb255z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,148.8c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,7.22,7.22,0,0,1-.45,1.58,5.3,5.3,0,0,1-.82,1.35,4.56,4.56,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.54,14.54,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.53,2.53,0,0,1,.45,1.06A8.46,8.46,0,0,1,98.5,148.8Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.28-.44-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S94.48,153.38,94.49,153.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "95.825px 151.71px"
    },
    id: "eldryz3clzyrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.19,144.94c0,.19,0,.4,0,.64V147c0,.24,0,.46,0,.65a12.19,12.19,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.58,8.58,0,0,1,105.19,144.94Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.43-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S101.17,149.52,101.18,149.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "102.515px 147.85px"
    },
    id: "elg5shm288dq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,141.07c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,111.88,141.07Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S107.86,145.66,107.87,146Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "109.205px 143.985px"
    },
    id: "el58hfr6ucf5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,140a.47.47,0,0,1-.05-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.17.17,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "114.674px 140.203px"
    },
    id: "elxqlskeyoujq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.31,134.47c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.49,7.49,0,0,1-.46,1.59,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1,1,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,7.71,7.71,0,0,1-.17-1.54q0-.57,0-1.32c0-.49,0-.94,0-1.33a11.17,11.17,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.21,5.21,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.07,1.07,0,0,1,.81.41,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,123.31,134.47Zm-4,5a3,3,0,0,0,.34,1.5c.19.29.53.31,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.22,2.22,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S119.29,139.06,119.31,139.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.64px 137.405px"
    },
    id: "elrzjs6a78cib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,133.35a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "126.108px 133.545px"
    },
    id: "eledhywklopl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75,127.87c0,.19,0,.4,0,.64V130c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.34,7.34,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,134.75,127.87Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6,6,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.08,3.08,0,0,0-.34-1.51q-.28-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S130.73,132.45,130.74,132.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "132.075px 130.83px"
    },
    id: "elz1mkfaa26nd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.77,126.75a.41.41,0,0,1-.05-.28.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.542px 126.942px"
    },
    id: "elbtc8382fh4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,121.27c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.46,2.46,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.63,12.63,0,0,1,.18-1.77,7.4,7.4,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.49,4.49,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,146.18,121.27Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.44,1,0a2.21,2.21,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S142.16,125.85,142.17,126.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "143.505px 124.18px"
    },
    id: "el5qxodyveekx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,117.41c0,.19,0,.4,0,.64v1.43c0,.24,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.34,2.34,0,0,1-1.23.39,1.07,1.07,0,0,1-.82-.4,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.47,4.47,0,0,1,1.23-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A8.64,8.64,0,0,1,152.87,117.41Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.52.3,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.2,2.2,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S148.85,122,148.87,122.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "150.195px 120.33px"
    },
    id: "elbeovjytano",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.56,113.54c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.06,1.06,0,0,1-.81-.4,2.42,2.42,0,0,1-.46-1.06,7.71,7.71,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7,7,0,0,1,.46-1.61,5.21,5.21,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,159.56,113.54Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S155.54,118.13,155.56,118.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.89px 116.455px"
    },
    id: "elc9boj6wzif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,112.42a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V110.4l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.358px 112.623px"
    },
    id: "els84iuzyg1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,106.94c0,.19,0,.41,0,.64V109c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.32,2.32,0,0,1,.45,1.05A8.46,8.46,0,0,1,171,106.94Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.34-1.5c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S167,111.52,167,111.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "168.325px 109.855px"
    },
    id: "eloc6yso5sxoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,105.82a.41.41,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "173.772px 106.012px"
    },
    id: "elx8lrm9xskz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76,103.08a.47.47,0,0,1,0-.28.79.79,0,0,1,.1-.33L179,98.6c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.78-.44a.13.13,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "178.566px 103.284px"
    },
    id: "elbz7n4q0c2qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51,100.34a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.15-3.86a3.18,3.18,0,0,1,.17-.27.59.59,0,0,1,.18-.2l.78-.44a.14.14,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.88a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V98.32l-1.41,2.51a.41.41,0,0,1-.19.2A.16.16,0,0,1,182,101Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "183.278px 100.543px"
    },
    id: "elc4bid8uycxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25,97.6a.38.38,0,0,1-.05-.27.7.7,0,0,1,.1-.34l2.16-3.86.16-.27a.49.49,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25V95.58l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.022px 97.8044px"
    },
    id: "elxv57uknrfvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.66,92.13c0,.19,0,.4,0,.63V94.2c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.34,4.34,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.36,2.36,0,0,1-.45-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.52,4.52,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,196.66,92.13Zm-4,5A3.14,3.14,0,0,0,193,98.6q.28.44,1,0a2.2,2.2,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.12,2.12,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S192.64,96.71,192.65,97.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "193.985px 95.035px"
    },
    id: "el5dh53yuf3fw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68,91a.45.45,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86a1.78,1.78,0,0,1,.17-.27.51.51,0,0,1,.18-.2l.77-.44a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25v9.88a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V89l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.455px 91.205px"
    },
    id: "eliq4eg62bn1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09,85.52c0,.2,0,.41,0,.64V87.6c0,.24,0,.45,0,.65a12.36,12.36,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A8.52,8.52,0,0,1,208.09,85.52Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S204.07,90.11,204.09,90.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.415px 88.435px"
    },
    id: "el7gtuh02xwq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,84.4a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.07-.24V82.38L210,84.89a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "210.888px 84.6034px"
    },
    id: "elg9opgtb8pu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,78.92c0,.19,0,.41,0,.64V81c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74A7.49,7.49,0,0,1,218.9,85a5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,219.53,78.92Zm-4,5a3.23,3.23,0,0,0,.34,1.5c.2.3.53.31,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S215.51,83.51,215.52,83.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "216.855px 81.875px"
    },
    id: "elmmwjy5iifr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,77.8a.47.47,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V75.77l-1.41,2.52a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.323px 77.995px"
    },
    id: "eltojkiqyf4qo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,72.32c0,.19,0,.4,0,.64V74.4c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.08,1.08,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.33,7.33,0,0,1,.45-1.61,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,231,72.32Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51q-.3-.43-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S226.94,76.9,227,77.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "228.325px 75.255px"
    },
    id: "elwje9z9ojuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,71.2a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24V76a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V69.17l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.768px 71.4216px"
    },
    id: "eluylam0n1bzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,190.84c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.05,5.05,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,57.5,190.84Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.24,2.24,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S53.48,195.42,53.5,195.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 193.74px"
    },
    id: "elxv9o75jacbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,189.75a.4.4,0,0,1-.06-.28.84.84,0,0,1,.1-.33l2.16-3.86a2.61,2.61,0,0,1,.17-.28.55.55,0,0,1,.18-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "60.2338px 189.953px"
    },
    id: "el7mt7pxz2r2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,187.05a.4.4,0,0,1-.06-.28.75.75,0,0,1,.1-.33l2.16-3.87c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V185L64,187.54a.43.43,0,0,1-.2.2.17.17,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "64.9138px 187.245px"
    },
    id: "ello0ygj9rggj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,184.34a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34L70,179.87c.06-.09.11-.18.16-.27a.57.57,0,0,1,.19-.19l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "69.5951px 184.542px"
    },
    id: "elnbdgqsnjk19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,178.91c0,.19,0,.4,0,.63V181c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.34,4.34,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.52,4.52,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,78.17,178.91Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S74.15,183.49,74.17,183.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "75.495px 181.86px"
    },
    id: "el7ja257snfmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13,177.82a.47.47,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57L80,178.31a.4.4,0,0,1-.2.19.15.15,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "80.9455px 178.012px"
    },
    id: "el47utvsyk5jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,172.38c0,.19,0,.4,0,.64v1.43c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.36,2.36,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.32,2.32,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.87,6.87,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.52,4.52,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,89.48,172.38Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.29.43,1,0a2.22,2.22,0,0,0,1-1.17,6,6,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S85.46,177,85.47,177.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.805px 175.3px"
    },
    id: "elvjz4uelp1qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,168.55c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.35,14.35,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6A5.63,5.63,0,0,1,92.2,167a4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.48,2.48,0,0,1,.46,1.06A9.53,9.53,0,0,1,96.11,168.55Zm-4,5a3.25,3.25,0,0,0,.34,1.51q.3.43,1,0a2.12,2.12,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.28-.44-1,0a2.26,2.26,0,0,0-1,1.18,6.53,6.53,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S92.09,173.13,92.1,173.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "93.435px 171.475px"
    },
    id: "el2oh0sxb3tyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74,164.72c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,7.38,7.38,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.05,1.05,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1.05A8.46,8.46,0,0,1,102.74,164.72Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S98.72,169.31,98.73,169.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "100.065px 167.635px"
    },
    id: "elpp2ggb7ht8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,163.63a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "105.467px 163.835px"
    },
    id: "el40t0etcbn9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,158.2c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a11,11,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A7.81,7.81,0,0,1,114,158.2Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.22,2.22,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S110,162.78,110,163.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "111.33px 161.105px"
    },
    id: "elmt4fv5uphni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,157.1a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "116.768px 157.3px"
    },
    id: "elp59zh9ahgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,151.67c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.53,4.53,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.49,2.49,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,125.35,151.67Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S121.33,156.25,121.35,156.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "122.675px 154.575px"
    },
    id: "elbpqiptnum5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,150.58a.47.47,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87c0-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.43.43,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.126px 150.772px"
    },
    id: "elbq4irtk421s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,145.14c0,.19,0,.4,0,.64v1.43c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.07,1.07,0,0,1-.82-.4,2.32,2.32,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.87,6.87,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,136.66,145.14Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S132.64,149.72,132.65,150.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.985px 148.035px"
    },
    id: "el33c0k1km14k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.29,141.31c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.52,2.52,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.63,12.63,0,0,1,.18-1.77,6.87,6.87,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.22,4.22,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.48,2.48,0,0,1,.46,1.06A9.53,9.53,0,0,1,143.29,141.31Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.43,1,0a2.15,2.15,0,0,0,1-1.17,6,6,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S139.27,145.89,139.28,146.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.615px 144.22px"
    },
    id: "el1m5fv15psel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.92,137.48c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,149.92,137.48Zm-4,5a3.23,3.23,0,0,0,.34,1.5c.2.3.53.31,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S145.9,142.07,145.91,142.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "147.245px 140.415px"
    },
    id: "el9kcwtv3o0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.88,136.39a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.3.3,0,0,1-.08-.25v-7.56l-1.42,2.52a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "152.647px 136.594px"
    },
    id: "elx9uzvinckc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23,131c0,.2,0,.41,0,.64V133c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.05,1.05,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.57,8.57,0,0,1,161.23,131Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S157.21,135.54,157.22,135.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "158.555px 133.835px"
    },
    id: "elrplsnyrkmdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,129.86a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.18,0,.3.3,0,0,1-.08-.25v-7.56L163,130.36a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.957px 130.064px"
    },
    id: "eldsb0dihybvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,124.43c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.48,2.48,0,0,1-.46-1.06,8.42,8.42,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,172.54,124.43Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6,6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S168.52,129,168.53,129.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.865px 127.335px"
    },
    id: "eln0qylxxf72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,123.34a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24v9.89a.83.83,0,0,1-.07.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "175.264px 123.532px"
    },
    id: "elyfhs1mglb2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,117.9c0,.19,0,.4,0,.63V120c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.32,2.32,0,0,1-.46-1,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,6.88,6.88,0,0,1,.46-1.6,5.11,5.11,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,183.84,117.9Zm-4,5a3,3,0,0,0,.34,1.51q.28.43,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S179.82,122.48,179.84,122.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "181.17px 120.85px"
    },
    id: "elb9ah8bq323g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8,116.81a.47.47,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.43.43,0,0,1-.2.2.17.17,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.574px 117.005px"
    },
    id: "elliafncevjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.15,111.37c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.89,5.89,0,0,1,.81-1.37,4.67,4.67,0,0,1,1.24-1,2.29,2.29,0,0,1,1.23-.39,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,195.15,111.37Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.43,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S191.13,116,191.14,116.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "192.475px 114.29px"
    },
    id: "elmsb1jrt12gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.78,107.54c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.39,0-.82,0-1.32s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,6.87,6.87,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,201.78,107.54Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.24,2.24,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.2,2.2,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S197.76,112.12,197.77,112.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.105px 110.475px"
    },
    id: "elkkmiiwd6zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.74,106.45a.44.44,0,0,1-.05-.27.83.83,0,0,1,.1-.34L205,102l.16-.27a.49.49,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0A.36.36,0,0,1,205,112v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.15.15,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.539px 106.675px"
    },
    id: "el04zd4cosmg4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,101c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,213.09,101Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.3-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S209.07,105.59,209.08,106Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "210.415px 103.935px"
    },
    id: "el5kmq7k4tpji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,97.19c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.48,2.48,0,0,1-.46-1.06,8.42,8.42,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76A7.25,7.25,0,0,1,215,97a5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,219.72,97.19Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S215.7,101.77,215.71,102.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.045px 100.11px"
    },
    id: "elwcs65a4qylo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,96.1a.4.4,0,0,1-.06-.28.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V94.07l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.448px 96.2916px"
    },
    id: "el3sulep179sg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,90.66v2.72a12.34,12.34,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.38,4.38,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,231,90.66Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S227,95.24,227,95.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "228.325px 93.59px"
    },
    id: "elcmc31l09i6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,89.57a.4.4,0,0,1-.06-.28A.76.76,0,0,1,232,89l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V87.54l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.743px 89.8016px"
    },
    id: "elawc0hwz90u5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,209.21c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a11.3,11.3,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.05,5.05,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A9.53,9.53,0,0,1,57.5,209.21Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.21,2.21,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S53.48,213.79,53.5,214.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 212.12px"
    },
    id: "elvogd85w0l5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,205.38c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.49,7.49,0,0,1-.46,1.59,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.08,1.08,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.54,5.54,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.07,1.07,0,0,1,.81.41,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,64.13,205.38Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.3.52.31,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S60.11,210,60.12,210.35Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "61.455px 208.315px"
    },
    id: "elnl1cvdjh849",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.76,201.56c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4A1.1,1.1,0,0,1,66,210a2.37,2.37,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,70.76,201.56Zm-4,5A3.14,3.14,0,0,0,67.1,208c.19.29.52.3,1,0a2.25,2.25,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S66.74,206.14,66.75,206.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.065px 204.49px"
    },
    id: "elt3gnm1gpcz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.72,200.47a.41.41,0,0,1,0-.28.75.75,0,0,1,.1-.33L73.93,196l.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0A.29.29,0,0,1,74,206v-7.57L72.57,201a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.5081px 200.672px"
    },
    id: "elrw74011ny0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.07,195c0,.19,0,.4,0,.64v1.43c0,.24,0,.46,0,.65a12.19,12.19,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.89,5.89,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.58,8.58,0,0,1,82.07,195Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S78.05,199.61,78.06,200Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.395px 197.895px"
    },
    id: "elh9m5blcefsr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,193.94a.41.41,0,0,1,0-.28.67.67,0,0,1,.1-.33l2.16-3.87.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.8131px 194.134px"
    },
    id: "elyhwes10bie8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.38,188.5c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64A12.19,12.19,0,0,1,93.2,193a6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1.05,2.4,2.4,0,0,1,1.23-.39,1.1,1.1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.58,8.58,0,0,1,93.38,188.5Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.43-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S89.36,193.08,89.37,193.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "90.705px 191.43px"
    },
    id: "elw1g7ik78bs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,184.67v2.73a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5.27,5.27,0,0,1-.81,1.35,4.56,4.56,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.79,12.79,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.46,8.46,0,0,1,100,184.67Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.22,2.22,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51c-.2-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S96,189.25,96,189.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "97.325px 187.58px"
    },
    id: "elg164y0qmlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.63,180.85c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.06,1.06,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.25,7.25,0,0,1,.46-1.6,5.11,5.11,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,106.63,180.85Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6,6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S102.61,185.43,102.63,185.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "103.955px 183.755px"
    },
    id: "elj0uzwce7kk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,179.75a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86c0-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.36.36,0,0,1-.2.19.15.15,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "109.405px 179.952px"
    },
    id: "elhsgh319578f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,174.32c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.34,4.34,0,0,1-1.22,1,2.28,2.28,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.67,4.67,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,117.94,174.32Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S113.92,178.9,113.93,179.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.265px 177.25px"
    },
    id: "elnf7173e3gj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,170.49c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.36,2.36,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,124.57,170.49Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.22,2.22,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.22,2.22,0,0,0-1,1.17,6.32,6.32,0,0,0-.35,1.91c0,.4,0,.83,0,1.3S120.55,175.07,120.56,175.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.895px 173.39px"
    },
    id: "el5ac7mek861",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,166.66c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.32,2.32,0,0,1,.45,1.05A8.46,8.46,0,0,1,131.2,166.66Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S127.18,171.24,127.19,171.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.525px 169.595px"
    },
    id: "elctubgfw6ln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.16,165.57a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.07-.25v-7.56L133,166.06a.34.34,0,0,1-.19.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.928px 165.775px"
    },
    id: "elrlgmptpncmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,160.13c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.05,12.05,0,0,1-.18,1.74,6.8,6.8,0,0,1-.46,1.59,4.94,4.94,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.64,12.64,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.46,8.46,0,0,1,142.51,160.13Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.44,1,0a2.22,2.22,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.2-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S138.49,164.72,138.5,165.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "139.835px 163.045px"
    },
    id: "elt81mo15f0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.14,156.31V159a12.34,12.34,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.75,4.75,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,149.14,156.31Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.43,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S145.12,160.89,145.13,161.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.465px 159.175px"
    },
    id: "elm6pblrt366i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,155.22a.4.4,0,0,1-.06-.28.65.65,0,0,1,.11-.33l2.15-3.87c0-.09.11-.18.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24V160a.83.83,0,0,1-.07.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "151.864px 155.432px"
    },
    id: "eli910rg5cx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44,149.78c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.34,2.34,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.7,4.7,0,0,1,1.24-1.05,2.37,2.37,0,0,1,1.22-.39,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,160.44,149.78Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.2,2.2,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S156.42,154.36,156.44,154.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.765px 152.655px"
    },
    id: "elcqz1ckvm53r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4,148.69a.47.47,0,0,1-.05-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.39.39,0,0,1-.2.2.17.17,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.174px 148.893px"
    },
    id: "ell512vnshvjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,143.25c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.49,2.49,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.31,2.31,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,171.75,143.25Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.43,1,0a2.24,2.24,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.43-1,0a2.19,2.19,0,0,0-1,1.17,6.32,6.32,0,0,0-.35,1.91c0,.4,0,.83,0,1.3S167.73,147.83,167.74,148.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.075px 146.175px"
    },
    id: "el0x3cj4d88eqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,142.16a.41.41,0,0,1-.05-.28.84.84,0,0,1,.1-.33l2.16-3.86c.05-.1.11-.19.16-.28a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "174.483px 142.363px"
    },
    id: "elknne0k9p98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,136.72c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.49,2.49,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.35,14.35,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.42,2.42,0,0,1,.46,1.06A9.53,9.53,0,0,1,183.06,136.72Zm-4,5a3.25,3.25,0,0,0,.34,1.51c.2.29.53.3,1,0a2.21,2.21,0,0,0,1-1.17,6.6,6.6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.28,3.28,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.18,6.53,6.53,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S179,141.3,179.05,141.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "180.385px 139.655px"
    },
    id: "elov9rgzqq6xb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,135.63a.33.33,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86a1.75,1.75,0,0,1,.16-.27.49.49,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.29.29,0,0,1-.08-.24v-7.56l-1.42,2.51a.37.37,0,0,1-.19.2.15.15,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "185.771px 135.818px"
    },
    id: "el3m3w8980ky7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,132.93a.36.36,0,0,1,0-.28.79.79,0,0,1,.1-.33l2.16-3.87c.05-.09.1-.18.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "190.511px 133.133px"
    },
    id: "el0md0tlb4gxye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,127.49c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.48,5.48,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.36,2.36,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.58,8.58,0,0,1,199.05,127.49Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.16,2.16,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.29-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S195,132.07,195,132.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.375px 130.4px"
    },
    id: "el4fr3x0wcws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,126.4a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.16-3.86a2.54,2.54,0,0,1,.16-.28.83.83,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.768px 126.603px"
    },
    id: "el54cnirsueek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,121c0,.19,0,.4,0,.64V123c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,7.22,7.22,0,0,1-.45,1.58,5.6,5.6,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.35,14.35,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.12,1.12,0,0,1,.82.4,2.48,2.48,0,0,1,.45,1.06A8.46,8.46,0,0,1,210.36,121Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.12,2.12,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S206.34,125.54,206.35,125.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "207.685px 123.83px"
    },
    id: "el4x5xl40vdm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,119.87a.38.38,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86a3.18,3.18,0,0,1,.17-.27.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.57.57,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.17.17,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "213.088px 120.077px"
    },
    id: "elexmgy19k1ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.66,114.43c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a10.92,10.92,0,0,1-.17,1.74,6.72,6.72,0,0,1-.46,1.58,5.27,5.27,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1,1,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.34,7.34,0,0,1,.46-1.61,5.05,5.05,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A7.71,7.71,0,0,1,221.66,114.43Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.53.3,1,0a2.22,2.22,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51c-.2-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S217.64,119,217.66,119.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.99px 117.365px"
    },
    id: "elna9h3jpj0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63,113.34a.36.36,0,0,1-.06-.27.83.83,0,0,1,.1-.34l2.16-3.86.17-.27a.47.47,0,0,1,.18-.19L226,108a.14.14,0,0,1,.18,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.44.44,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.413px 113.586px"
    },
    id: "eljw1lbbgbx3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.31,110.64a.4.4,0,0,1-.06-.28.72.72,0,0,1,.11-.33l2.15-3.86.17-.28a.66.66,0,0,1,.18-.19l.78-.44a.13.13,0,0,1,.18,0,.3.3,0,0,1,.08.25v9.88a.68.68,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "229.074px 110.844px"
    },
    id: "ela7gce5pso97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,107.94a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.768px 108.135px"
    },
    id: "ely4jon7tl6iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.84,230.32a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33L54,225.84l.17-.27a.47.47,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V228.3l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "53.588px 230.523px"
    },
    id: "elmo4uzlkuock",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.08,224.94c0,.19,0,.4,0,.64V227c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5,5,0,0,1-.81,1.35,4.56,4.56,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.35,14.35,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.06,1.06,0,0,1,.81.4,2.31,2.31,0,0,1,.46,1.06A8.46,8.46,0,0,1,62.08,224.94Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.12,2.12,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.28-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S58.06,229.52,58.07,229.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.405px 227.855px"
    },
    id: "eld9v64ct5n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.93,223.91a.37.37,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.32.32,0,0,1-.08-.25v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "64.7433px 224.115px"
    },
    id: "ellnb1exqgzdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.17,218.53c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65A12.36,12.36,0,0,1,73,223a7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.27,2.27,0,0,1-1.23.4,1.06,1.06,0,0,1-.81-.4,2.42,2.42,0,0,1-.46-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7,7,0,0,1,.46-1.61,5.21,5.21,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.28,2.28,0,0,1,1.22-.39,1,1,0,0,1,.82.4A2.43,2.43,0,0,1,73,217,8.52,8.52,0,0,1,73.17,218.53Zm-4,5a3,3,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S69.15,223.12,69.17,223.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.495px 221.435px"
    },
    id: "elvlz08jhabar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,217.51a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33L76.23,213l.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57L74.87,218a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "75.783px 217.672px"
    },
    id: "elfykfgupiugl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.27,212.13c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.39,1.1,1.1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.58,8.58,0,0,1,84.27,212.13Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.11,3.11,0,0,0-.35-1.51q-.28-.43-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S80.25,216.71,80.26,217.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "81.595px 215.055px"
    },
    id: "elkc97ykq05z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.79,208.36c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.42,2.42,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.22,4.22,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,90.79,208.36Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.3.52.31,1,0a2.2,2.2,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S86.77,212.94,86.78,213.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "88.115px 211.27px"
    },
    id: "el6da23qtgyu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,207.33a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19L95,202a.14.14,0,0,1,.18,0,.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.43.43,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "93.4397px 207.586px"
    },
    id: "eluzbdrk7vola",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,202c0,.19,0,.4,0,.63V204c0,.24,0,.45,0,.65a12.19,12.19,0,0,1-.18,1.75,7.22,7.22,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.08,1.08,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1A8.58,8.58,0,0,1,101.89,202Zm-4,5a3,3,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S97.87,206.54,97.88,206.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "99.215px 204.825px"
    },
    id: "elmrag8qznnum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74,200.93a.36.36,0,0,1,0-.28.67.67,0,0,1,.1-.33l2.16-3.87.16-.27a.83.83,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "104.551px 201.133px"
    },
    id: "el4hdajz87vdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,195.55c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.37,2.37,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,6.87,6.87,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.49,4.49,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,113,195.55Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S109,200.13,109,200.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "110.325px 198.46px"
    },
    id: "el5a9ygcqg9hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,194.52a.36.36,0,0,1-.06-.27.83.83,0,0,1,.1-.34l2.16-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.52.52,0,0,1-.18.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25V192.5L114.68,195c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.603px 194.726px"
    },
    id: "elf35utifala",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.08,189.15c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.48,2.48,0,0,1-.46-1.06,8.42,8.42,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,124.08,189.15Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S120.06,193.73,120.07,194.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.405px 192.055px"
    },
    id: "elnxtoj5nlgx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.93,188.12a.41.41,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "126.702px 188.312px"
    },
    id: "elndcpb5tyekl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,185.48a.47.47,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57L130.35,186a.36.36,0,0,1-.2.19.15.15,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.274px 185.672px"
    },
    id: "elqzti9yzoxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,180.1c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,7.23,7.23,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1,2.38,2.38,0,0,1,1.23-.39,1.08,1.08,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A8.58,8.58,0,0,1,139.75,180.1Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.24,2.24,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.3-.44-1,0a2.28,2.28,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S135.72,184.68,135.74,185.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.075px 183.025px"
    },
    id: "elnwkqgrykn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,179.07a.34.34,0,0,1,0-.27.7.7,0,0,1,.1-.34l2.16-3.86a1.75,1.75,0,0,1,.16-.27.49.49,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.29.29,0,0,1-.08-.24v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "142.412px 179.258px"
    },
    id: "elyvtduja2ozb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.84,173.69c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.42,2.42,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7,7,0,0,1,.45-1.61,5.63,5.63,0,0,1,.81-1.36,4.22,4.22,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,150.84,173.69Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.29.52.3,1,0a2.2,2.2,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.35-1.5c-.19-.3-.52-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S146.82,178.27,146.83,178.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "148.165px 176.625px"
    },
    id: "eln270wpyx9ud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,172.66a.42.42,0,0,1-.05-.27,1,1,0,0,1,.1-.34l2.16-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.54.54,0,0,1-.18.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.463px 172.866px"
    },
    id: "el68mac53zl47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,170a.33.33,0,0,1-.05-.27.7.7,0,0,1,.1-.34l2.16-3.86c.05-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.3.3,0,0,1-.08-.25V168l-1.41,2.52c-.07.1-.13.17-.2.19a.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "158.04px 170.204px"
    },
    id: "el1lusxg538yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,164.65c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,166.51,164.65Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.44,1,0a2.25,2.25,0,0,0,1-1.17,6.67,6.67,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.25,3.25,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.24,2.24,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S162.49,169.23,162.5,169.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.835px 167.555px"
    },
    id: "elqpygu8wgtl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,163.62a.47.47,0,0,1-.05-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V161.6l-1.41,2.51a.39.39,0,0,1-.2.2.17.17,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.134px 163.815px"
    },
    id: "el8xpudezfas9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.94,161a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V159l-1.41,2.52a.46.46,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "173.708px 161.195px"
    },
    id: "elxd6evq1t7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.18,155.6c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34A14.38,14.38,0,0,1,177,157a7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.36,2.36,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,182.18,155.6Zm-4,5a3.25,3.25,0,0,0,.34,1.51q.3.44,1,0a2.16,2.16,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.28-.44-1,0a2.26,2.26,0,0,0-1,1.18,6.53,6.53,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S178.16,160.18,178.17,160.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.505px 158.52px"
    },
    id: "eli6s1koe2aud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,154.57a.44.44,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.49.49,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.3.3,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.37.37,0,0,1-.08-.25v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.15.15,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "184.775px 154.792px"
    },
    id: "elf77vooad2e5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,151.93a.38.38,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86a3.18,3.18,0,0,1,.17-.27.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.57.57,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.17.17,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.378px 152.137px"
    },
    id: "el541grvyopm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,146.55c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,197.85,146.55Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S193.83,151.13,193.84,151.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.175px 149.46px"
    },
    id: "el3bn6d0qs24w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,142.79c0,.19,0,.4,0,.64v1.43c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.37,4.37,0,0,1-1.22,1,2.39,2.39,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.32,2.32,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.87,6.87,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,204.37,142.79Zm-4,5a3.11,3.11,0,0,0,.35,1.51q.28.44,1,0a2.22,2.22,0,0,0,1-1.17,6,6,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.3S200.35,147.37,200.36,147.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.695px 145.71px"
    },
    id: "elqv26oukwf5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.22,141.76a.47.47,0,0,1-.05-.28.84.84,0,0,1,.1-.33l2.16-3.86a2.61,2.61,0,0,1,.17-.28.55.55,0,0,1,.18-.19l.77-.44a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25v9.88a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.995px 141.963px"
    },
    id: "elx5aj4e2yd3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8,139.12a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V137.1l-1.41,2.51a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.568px 139.323px"
    },
    id: "eljak4tvs5ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,133.74c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.39,0-.82,0-1.32s0-.94,0-1.33a14.54,14.54,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,220,133.74Zm-4,5a3.25,3.25,0,0,0,.34,1.51c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.25,6.25,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.17,3.17,0,0,0-.35-1.51q-.28-.44-1,0a2.26,2.26,0,0,0-1,1.18,6.53,6.53,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S216,138.32,216,138.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.325px 136.65px"
    },
    id: "el34ppukdnpby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,130c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.36,2.36,0,0,1-.45-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.52,4.52,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,226.56,130Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S222.54,134.56,222.55,134.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "223.885px 132.905px"
    },
    id: "elrq7tzrory8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.42,129a.4.4,0,0,1-.06-.28.68.68,0,0,1,.11-.33l2.15-3.87c0-.09.11-.18.17-.27A.47.47,0,0,1,230,124l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "229.199px 129.136px"
    },
    id: "elfaa13vp8hpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,126.31a.47.47,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.16-3.87c.05-.09.1-.18.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-7.57l-1.42,2.52a.35.35,0,0,1-.19.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.769px 126.502px"
    },
    id: "elbubirfwjvy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,246c0,.19,0,.4,0,.64V248c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a11.42,11.42,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.05,5.05,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,57.5,246Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.43-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S53.48,250.53,53.5,250.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 248.83px"
    },
    id: "elpeinhim1ess",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,242.12c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65A14.21,14.21,0,0,1,64,246.6a7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.53,2.53,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.64,12.64,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.54,5.54,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,64.13,242.12Zm-4,5a3.17,3.17,0,0,0,.35,1.51q.28.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S60.11,246.71,60.12,247.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "61.475px 245.035px"
    },
    id: "elxvafolna6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.09,241a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86c0-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.48.48,0,0,1-.19.24l-.8.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25V239l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "66.9047px 241.222px"
    },
    id: "elsdakyqslfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.44,235.6c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58A5.24,5.24,0,0,1,74,243a4.51,4.51,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.35,4.35,0,0,1,1.24-1A2.28,2.28,0,0,1,74,232.6a1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,75.44,235.6Zm-4,5a3.28,3.28,0,0,0,.34,1.51c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.53,6.53,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.25,3.25,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.24,2.24,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S71.42,240.18,71.43,240.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "72.77px 238.5px"
    },
    id: "elv4p2j5jfy7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4,234.5a.37.37,0,0,1-.05-.27.83.83,0,0,1,.1-.34L78.61,230l.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.3.3,0,0,1-.08-.25v-7.56L77.25,235a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.1718px 234.672px"
    },
    id: "elvk96vyhttp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,229.07c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,86.75,229.07Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.43-1,0a2.21,2.21,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S82.73,233.65,82.74,234Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.075px 232px"
    },
    id: "elqy5geeh6nl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.38,225.24c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.58,8.58,0,0,1,93.38,225.24Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.16,2.16,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S89.36,229.82,89.37,230.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "90.705px 228.14px"
    },
    id: "elozhhl8ymzqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,221.41v2.73a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5.27,5.27,0,0,1-.81,1.35,4.56,4.56,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.43,2.43,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.46,8.46,0,0,1,100,221.41Zm-4,5a3.13,3.13,0,0,0,.34,1.51c.2.29.53.3,1,0a2.22,2.22,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.3-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S96,226,96,226.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "97.325px 224.345px"
    },
    id: "elqhwwi38jlfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,220.32a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25V218.3l-1.41,2.51c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "102.768px 220.525px"
    },
    id: "el77hf56eids4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65,217.62a.38.38,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86a3.18,3.18,0,0,1,.17-.27.42.42,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.57.57,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V215.6l-1.41,2.51a.41.41,0,0,1-.19.2.17.17,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "107.418px 217.827px"
    },
    id: "el26va6oi9rv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,212.18c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.46-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,6.88,6.88,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,116,212.18Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51q-.3-.44-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S112,216.76,112,217.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.325px 215.09px"
    },
    id: "el1ghz6kfiwvy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.62,208.35c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.28,2.28,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.53,2.53,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.49,4.49,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,122.62,208.35Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.29.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S118.6,212.94,118.61,213.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "119.945px 211.265px"
    },
    id: "elahrngfemzdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,207.26a.37.37,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24V212a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.393px 207.457px"
    },
    id: "el46jtc4k8f8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,201.83c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.34,4.34,0,0,1-1.22,1,2.33,2.33,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,133.93,201.83Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.2,2.2,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.12,2.12,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S129.91,206.41,129.92,206.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.255px 204.735px"
    },
    id: "el18qq9y579olh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,200.74a.41.41,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.703px 200.932px"
    },
    id: "el019p2la7tiyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,198a.37.37,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.3.3,0,0,1-.08-.25V196l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "141.383px 198.188px"
    },
    id: "elg10pjh2noqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.92,192.59c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6A5.69,5.69,0,0,1,146,191a4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,149.92,192.59Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S145.9,197.18,145.91,197.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "147.245px 195.5px"
    },
    id: "elv03l64s6xk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,188.77c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,7.22,7.22,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1.05,2.43,2.43,0,0,1,1.23-.39,1.12,1.12,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1.05A8.58,8.58,0,0,1,156.55,188.77Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.29-.44-1,0a2.28,2.28,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S152.53,193.35,152.54,193.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.875px 191.645px"
    },
    id: "elnwp6bbn4iqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,187.68a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.83.83,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "159.278px 187.883px"
    },
    id: "elx6vj3rlgtki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,182.24c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a10.93,10.93,0,0,1-.17,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a11.29,11.29,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A7.81,7.81,0,0,1,167.85,182.24Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.16,2.16,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.28,2.28,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S163.83,186.82,163.85,187.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "165.18px 185.14px"
    },
    id: "elrfqzbps16c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.82,181.15a.4.4,0,0,1-.06-.28,1,1,0,0,1,.1-.33l2.16-3.86.17-.28a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.07.24v9.89a.8.8,0,0,1-.07.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.584px 181.353px"
    },
    id: "el0bxroof9ag6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,175.71c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.63,12.63,0,0,1,.18-1.77,7.4,7.4,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.52,8.52,0,0,1,179.16,175.71Zm-4,5a3,3,0,0,0,.34,1.51q.3.44,1,0a2.21,2.21,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S175.14,180.29,175.16,180.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "176.485px 178.62px"
    },
    id: "elsl6tlpz8zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,174.62a.44.44,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86a1.78,1.78,0,0,1,.17-.27.42.42,0,0,1,.18-.19l.77-.45c.08,0,.14,0,.19,0a.3.3,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.45.45,0,0,1-.19.23l-.8.47a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V172.6L181,175.11a.41.41,0,0,1-.19.2.16.16,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "181.895px 174.844px"
    },
    id: "elek6syi1u8bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,169.18c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.37,2.37,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,6.87,6.87,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.49,4.49,0,0,1,1.24-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,190.47,169.18Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S186.45,173.76,186.46,174.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.795px 172.09px"
    },
    id: "el7t6gbufkr9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,168.09a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.49.49,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.41.41,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "193.203px 168.295px"
    },
    id: "el7i99q02hmob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,165.39a.47.47,0,0,1-.05-.28.84.84,0,0,1,.1-.33l2.16-3.86c.05-.1.11-.19.16-.28a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25v9.88a.68.68,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56L197,165.88a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "197.885px 165.593px"
    },
    id: "el3a3qni19227",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,160c0,.19,0,.4,0,.64V162c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.43,2.43,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.63,12.63,0,0,1,.18-1.77,6.87,6.87,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.45,4.45,0,0,1,1.23-1A2.46,2.46,0,0,1,205,157a1.1,1.1,0,0,1,.82.4,2.42,2.42,0,0,1,.46,1.06A9.53,9.53,0,0,1,206.46,160Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.18,2.18,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.2,2.2,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S202.44,164.53,202.45,164.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "203.785px 162.86px"
    },
    id: "elg96kub8zshl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,156.12c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.46,8.46,0,0,1,213.09,156.12Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S209.07,160.71,209.08,161.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "210.415px 159.035px"
    },
    id: "el5f6gju9h8re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,152.3c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.19,12.19,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.41,4.41,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,219.72,152.3Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S215.7,156.88,215.71,157.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.045px 155.195px"
    },
    id: "elzn5eqyee7i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,151.21a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24V156a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.448px 151.43px"
    },
    id: "elquzg5bmbh7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,148.5a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56L226.2,149a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.128px 148.7px"
    },
    id: "el56vm1mm4u8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,143.07v2.72a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.48,2.48,0,0,1-.46-1.06,8.42,8.42,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,235.71,143.07Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S231.69,147.65,231.7,148Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.035px 145.975px"
    },
    id: "ellfgva39obs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,264.32c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1,1,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.71,7.71,0,0,1-.17-1.54q0-.57,0-1.32c0-.49,0-.94,0-1.33a11.42,11.42,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.05,5.05,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,57.5,264.32Zm-4,5a3,3,0,0,0,.34,1.51c.19.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51q-.3-.44-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S53.48,268.9,53.5,269.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 267.23px"
    },
    id: "elxb2frv8d3he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,260.49c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65A14,14,0,0,1,64,265a7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.53,2.53,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34A12.64,12.64,0,0,1,59,261.9a7.24,7.24,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4A2.43,2.43,0,0,1,64,259,9.53,9.53,0,0,1,64.13,260.49Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S60.11,265.08,60.12,265.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "61.475px 263.43px"
    },
    id: "eljk8i024cqre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.09,259.4a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86c0-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.77-.45c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "66.9047px 259.622px"
    },
    id: "eltuxelchoi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.44,254c0,.19,0,.4,0,.63V256c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.48,2.48,0,0,1-.46-1.06,9.4,9.4,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.52,4.52,0,0,1,1.24-1A2.28,2.28,0,0,1,74,251a1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,75.44,254Zm-4,5a3.28,3.28,0,0,0,.34,1.51c.2.29.53.3,1,0a2.28,2.28,0,0,0,1-1.17,6.67,6.67,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.25,3.25,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S71.42,258.55,71.43,258.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "72.765px 256.86px"
    },
    id: "elgiqusfwzezu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4,252.88a.41.41,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.1722px 253.072px"
    },
    id: "elxxxqlpo1pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,250.17a.37.37,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.3.3,0,0,1-.08-.25v-7.56l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "82.8925px 250.358px"
    },
    id: "el9gy0xaw2xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,244.73c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,91.43,244.73Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S87.41,249.32,87.42,249.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "88.755px 247.645px"
    },
    id: "el68z4ks43rmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39,243.64a.42.42,0,0,1-.06-.27,1,1,0,0,1,.11-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46c-.08,0-.14,0-.19,0a.3.3,0,0,1-.08-.25v-7.56l-1.42,2.52a.35.35,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "94.1588px 243.828px"
    },
    id: "eln4155vrbt5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74,238.21c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,7.22,7.22,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76A7.25,7.25,0,0,1,98,238a5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.08,1.08,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1A8.58,8.58,0,0,1,102.74,238.21Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S98.72,242.79,98.73,243.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "100.065px 241.12px"
    },
    id: "elae3ule0o6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37,234.38c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.81,13.81,0,0,1-.18,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.59,9.59,0,0,1,109.37,234.38Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.24,2.24,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.3-.43-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S105.34,239,105.36,239.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.695px 237.305px"
    },
    id: "elkwpjr27hrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,233.29a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.15-3.86.17-.28a.55.55,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.098px 233.493px"
    },
    id: "elp3ov8k6na1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.67,227.85c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.32,2.32,0,0,1-.46-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a12.63,12.63,0,0,1,.18-1.77,6.88,6.88,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.52,8.52,0,0,1,120.67,227.85Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.21,2.21,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S116.65,232.43,116.67,232.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "117.995px 230.785px"
    },
    id: "el31vg1mzta46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,224c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a13.68,13.68,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.41,2.41,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.64,12.64,0,0,1,.18-1.76,7,7,0,0,1,.45-1.61,5.83,5.83,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1,1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,127.3,224Zm-4,5a3.17,3.17,0,0,0,.35,1.51q.28.44,1,0a2.2,2.2,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S123.28,228.61,123.29,229Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.625px 226.915px"
    },
    id: "eluv0tidr6m6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,220.2c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.54,4.54,0,0,1-1.22,1A2.39,2.39,0,0,1,130,229a1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.37,4.37,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,133.93,220.2Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.22,2.22,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.16,2.16,0,0,0-1,1.17,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.83,0,1.29S129.91,224.78,129.92,225.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.245px 223.115px"
    },
    id: "el3my3dkpe3tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,219.11a.41.41,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.703px 219.302px"
    },
    id: "elrjg0mh68jus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,213.67c0,.19,0,.4,0,.64v1.43c0,.24,0,.46,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.89,5.89,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,145.24,213.67Zm-4,5a3.25,3.25,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S141.22,218.25,141.23,218.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "142.565px 216.565px"
    },
    id: "el5sbnwie9a9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,212.58a.4.4,0,0,1-.06-.28,1,1,0,0,1,.11-.33l2.16-3.87c.05-.09.1-.18.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56L147,213.07a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "147.968px 212.775px"
    },
    id: "el391bdop3iek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,207.14c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,7.22,7.22,0,0,1-.45,1.58,5.54,5.54,0,0,1-.82,1.34,4.28,4.28,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.36,2.36,0,0,1,1.23-.4,1.12,1.12,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1.05A8.58,8.58,0,0,1,156.55,207.14Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.16,2.16,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.29-.43-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S152.53,211.72,152.54,212.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.875px 210.04px"
    },
    id: "eloeuuujivtx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,206.05a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.15-3.86.17-.28a.83.83,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.07-.24V204l-1.42,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "159.278px 206.253px"
    },
    id: "elbpmaobmkm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,200.61c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a10.92,10.92,0,0,1-.17,1.74,6.72,6.72,0,0,1-.46,1.58,5.27,5.27,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.81,7.81,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a11.3,11.3,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.08,1.08,0,0,1,.81.4,2.31,2.31,0,0,1,.46,1.06A7.71,7.71,0,0,1,167.85,200.61Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.12,2.12,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.28-.44-1,0a2.26,2.26,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S163.83,205.19,163.85,205.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "165.18px 203.52px"
    },
    id: "el990hxavk2zk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.48,196.78c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.49,7.49,0,0,1-.46,1.59,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.08,1.08,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.54,5.54,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.07,1.07,0,0,1,.81.41,2.43,2.43,0,0,1,.46,1.05A8.52,8.52,0,0,1,174.48,196.78Zm-4,5a3,3,0,0,0,.34,1.5c.2.29.53.31,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S170.46,201.36,170.48,201.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.805px 199.69px"
    },
    id: "elezxe4d8hahb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,195.69a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.52.52,0,0,1-.18.24l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.43.43,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "177.214px 195.896px"
    },
    id: "el6yu1vfv7nie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.79,190.25c0,.2,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.41,2.41,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,185.79,190.25Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S181.77,194.84,181.78,195.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "183.115px 193.165px"
    },
    id: "elyspn25czvbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,189.16a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46c-.08,0-.14,0-.19,0a.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.523px 189.365px"
    },
    id: "elaxrbh6jekho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,186.46a.42.42,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45c.08,0,.14,0,.19,0a.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.48.48,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.36.36,0,0,1-.08-.25v-7.56L192.28,187a.38.38,0,0,1-.2.2.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "193.203px 186.665px"
    },
    id: "eloflbqr603m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.78,181c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.49,12.49,0,0,1,.18-1.76,7,7,0,0,1,.45-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1A9.53,9.53,0,0,1,201.78,181Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.3.52.31,1,0a2.24,2.24,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.2,2.2,0,0,0-1,1.18,6.25,6.25,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S197.76,185.61,197.77,186Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.105px 183.91px"
    },
    id: "eltj10wb9n7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,177.2c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.71,6.71,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.25,4.25,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.58,8.58,0,0,1,208.41,177.2Zm-4,5a3,3,0,0,0,.35,1.51c.19.29.52.3,1,0a2.19,2.19,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.43-1,0a2.18,2.18,0,0,0-1,1.17,6,6,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S204.39,181.78,204.4,182.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.735px 180.105px"
    },
    id: "elwp4p5t2xbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.37,176.11a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.5.5,0,0,1-.19.23l-.81.46a.13.13,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.57l-1.42,2.52a.46.46,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.138px 176.301px"
    },
    id: "elekf48etfqcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,170.67c0,.19,0,.4,0,.64v1.43c0,.24,0,.46,0,.65a12.19,12.19,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.41,4.41,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.89,5.89,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,219.72,170.67Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.19,2.19,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27A3,3,0,0,0,218,170q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S215.7,175.25,215.71,175.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.045px 173.565px"
    },
    id: "el1bffms60g9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,169.58a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.448px 169.775px"
    },
    id: "el4m5eizf6buj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,164.14v2.72a12.19,12.19,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.41,4.41,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1.05,2.4,2.4,0,0,1,1.23-.39,1.08,1.08,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,231,164.14Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.24,2.24,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S227,168.72,227,169.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "228.325px 167.015px"
    },
    id: "el0p9ccw2wfyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,163.05a.4.4,0,0,1-.06-.28.81.81,0,0,1,.11-.33l2.15-3.87.17-.27a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V161l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.768px 163.253px"
    },
    id: "elzanfbj43fhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.84,285.43a.39.39,0,0,1-.06-.27.85.85,0,0,1,.11-.34L54,281l.17-.28a.55.55,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "53.5884px 285.673px"
    },
    id: "elkkdjpow5qbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,282.73a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V280.7l-1.41,2.52a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.288px 282.925px"
    },
    id: "el42hitbpqh3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87,277.29V280a13.81,13.81,0,0,1-.18,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1.05,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.59,9.59,0,0,1,66.87,277.29Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.44,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S62.84,281.87,62.86,282.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "64.195px 280.155px"
    },
    id: "el92nkn3sv6nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,276.2a.47.47,0,0,1,0-.28.84.84,0,0,1,.1-.33L70,271.72c.06-.09.11-.18.16-.27a.68.68,0,0,1,.19-.19l.78-.44a.13.13,0,0,1,.18,0,.29.29,0,0,1,.08.24V281a.68.68,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "69.5956px 276.429px"
    },
    id: "eljo0faf58hvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,270.76c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.48,5.48,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.36,2.36,0,0,1-1.24.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.31,2.31,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,78.17,270.76Zm-4,5a3,3,0,0,0,.34,1.51q.28.43,1,0a2.24,2.24,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S74.15,275.34,74.17,275.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "75.495px 273.665px"
    },
    id: "elchyr8qk9mqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,266.93c0,.19,0,.41,0,.64V269c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.39,2.39,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,84.8,266.93Zm-4,5a3.09,3.09,0,0,0,.35,1.5c.19.29.52.3,1,0a2.2,2.2,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.3-.52-.31-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S80.78,271.51,80.79,271.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "82.125px 269.855px"
    },
    id: "elwje7ausfnnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.76,265.84a.37.37,0,0,1-.05-.27.83.83,0,0,1,.1-.34L88,261.37l.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.32.32,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.53.53,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.32.32,0,0,1-.08-.25v-7.56l-1.41,2.51a.38.38,0,0,1-.2.2.16.16,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.5474px 266.028px"
    },
    id: "elk40gqxl91d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,260.4c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,96.11,260.4Zm-4,5a3.23,3.23,0,0,0,.34,1.5c.2.3.53.31,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S92.09,265,92.1,265.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "93.435px 263.31px"
    },
    id: "elvvsu2xz5pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,259.31A.36.36,0,0,1,97,259a.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.8.46c-.08,0-.14,0-.19,0a.3.3,0,0,1-.08-.25v-7.56l-1.42,2.52a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "98.8253px 259.458px"
    },
    id: "elct8r96jrw5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75,256.61a.33.33,0,0,1,0-.27.7.7,0,0,1,.1-.34l2.16-3.86c.05-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-.81.47a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56l-1.41,2.51a.47.47,0,0,1-.2.2.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "103.561px 256.814px"
    },
    id: "el5a0j9sp5gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,251.17c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.41,5.41,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.12,1.12,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,112.1,251.17Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.34-1.5c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S108.08,255.75,108.09,256.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "109.425px 254.08px"
    },
    id: "elhk1vouvhsgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06,250.08a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56l-1.42,2.51c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "114.828px 250.284px"
    },
    id: "elcjqbib0pmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,244.64v2.73a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58A5.21,5.21,0,0,1,122,252a4.56,4.56,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.46,8.46,0,0,1,123.41,244.64Zm-4,5a3.08,3.08,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.26,2.26,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S119.39,249.23,119.4,249.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.755px 247.515px"
    },
    id: "elfu2x652mnlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,240.82c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.32,2.32,0,0,1-.46-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.88,6.88,0,0,1,.46-1.6,5.11,5.11,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,130,240.82Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S126,245.4,126,245.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "127.325px 243.74px"
    },
    id: "elv3cfyxspv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,239.73a.47.47,0,0,1-.05-.28.75.75,0,0,1,.1-.33l2.16-3.87c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.71.71,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V237.7l-1.41,2.52a.46.46,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "132.774px 239.926px"
    },
    id: "el9nnq5y8xx5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.67,237a.42.42,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.13.13,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.89a.73.73,0,0,1-.08.34.49.49,0,0,1-.18.23l-.81.46a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25V235l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.485px 237.2px"
    },
    id: "el0szjhrhbtwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,231.59c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.82-.4,2.48,2.48,0,0,1-.45-1.06,8.36,8.36,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.24,7.24,0,0,1,.45-1.6,5.42,5.42,0,0,1,.82-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,146,231.59Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.12,2.12,0,0,0-1,1.17A6.26,6.26,0,0,0,142,234c0,.39,0,.82,0,1.29S142,236.17,142,236.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "143.325px 234.495px"
    },
    id: "elnu4ex9e4oe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,227.76c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.43,2.43,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.45,4.45,0,0,1,1.23-1,2.36,2.36,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,152.65,227.76Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.22,2.22,0,0,0,1-1.17,6.6,6.6,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.28,3.28,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.2,2.2,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S148.63,232.34,148.64,232.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.975px 230.695px"
    },
    id: "ela2k8y9q6ykq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,223.93c0,.19,0,.41,0,.64V226c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,6.71,6.71,0,0,1-.45,1.58,5.13,5.13,0,0,1-.82,1.35,4.41,4.41,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.41,2.41,0,0,1,.45,1.06A8.46,8.46,0,0,1,159.28,223.93Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.09,3.09,0,0,0-.35-1.5c-.19-.3-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S155.26,228.51,155.27,228.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.605px 226.83px"
    },
    id: "eldycg0464jwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.24,222.84a.37.37,0,0,1-.05-.27.7.7,0,0,1,.1-.34l2.16-3.86.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56l-1.41,2.51a.38.38,0,0,1-.2.2.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.012px 223.044px"
    },
    id: "el0dpf2bbimm95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,220.14a.38.38,0,0,1,0-.27.7.7,0,0,1,.1-.34l2.16-3.86c.05-.1.11-.19.16-.27a.49.49,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-.81.47a.13.13,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.15.15,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.733px 220.346px"
    },
    id: "eljj4frbw47t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,217.44a.41.41,0,0,1,0-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.413px 217.643px"
    },
    id: "el2cjfhroahia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,212c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.2,12.2,0,0,1-.18,1.74,7.22,7.22,0,0,1-.45,1.58,5.3,5.3,0,0,1-.82,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.1,1.1,0,0,1,.82.4,2.43,2.43,0,0,1,.45,1A8.58,8.58,0,0,1,180,212Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.16,2.16,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51q-.28-.43-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S175.93,216.58,175.94,217Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "177.325px 214.935px"
    },
    id: "elit4fleuht4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,208.17v2.73a12.2,12.2,0,0,1-.18,1.74,6.72,6.72,0,0,1-.46,1.58,5.38,5.38,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.5,12.5,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.63,5.63,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.42,2.42,0,0,1,.46,1.06A8.46,8.46,0,0,1,186.58,208.17Zm-4,5a3.11,3.11,0,0,0,.34,1.5c.2.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3,3,0,0,0-.34-1.5c-.2-.29-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.21,6.21,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S182.55,212.75,182.57,213.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "183.905px 211.08px"
    },
    id: "el0tx71u1x9gi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,207.08a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.308px 207.285px"
    },
    id: "el9qi2aiwdpcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.88,201.64c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.45,9.45,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.37,14.37,0,0,1,.18-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1A8.52,8.52,0,0,1,197.88,201.64Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.44,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S193.86,206.23,193.88,206.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.205px 204.555px"
    },
    id: "el2dq4yya3we5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51,197.82c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.54,4.54,0,0,1-1.22,1,2.34,2.34,0,0,1-1.24.39,1.1,1.1,0,0,1-.81-.4,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.67,4.67,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,204.51,197.82Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.34,6.34,0,0,0,.34-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S200.49,202.4,200.51,202.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.835px 200.74px"
    },
    id: "elwjsslc3h2sg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.14,194c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.49,2.49,0,0,1-1.24.4,1.11,1.11,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.33a14.35,14.35,0,0,1,.17-1.77,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.42,2.42,0,0,1,.46,1.06A9.53,9.53,0,0,1,211.14,194Zm-4,5a3.25,3.25,0,0,0,.34,1.51c.2.29.53.3,1,0a2.15,2.15,0,0,0,1-1.17,6.26,6.26,0,0,0,.35-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.14,3.14,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.24,2.24,0,0,0-1,1.18,6.53,6.53,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S207.12,198.57,207.13,199Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "208.465px 196.91px"
    },
    id: "eltrz1ynnd5md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.77,190.16c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.32,7.32,0,0,1-.46,1.59,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.19,14.19,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.46,2.46,0,0,1,1.23-.4,1.08,1.08,0,0,1,.82.41,2.43,2.43,0,0,1,.46,1.05A9.53,9.53,0,0,1,217.77,190.16Zm-4,5a3.23,3.23,0,0,0,.34,1.5c.2.3.53.31,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.6,6.6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S213.75,194.75,213.76,195.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "215.095px 193.095px"
    },
    id: "el8vb1jriehl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73,189.07a.42.42,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.3.3,0,0,1-.08-.25v-7.56l-1.42,2.52a.35.35,0,0,1-.19.19.14.14,0,0,1-.18,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "220.499px 189.274px"
    },
    id: "elhaj9almfb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08,183.63c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.86,6.86,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.46,8.46,0,0,1,229.08,183.63Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S225.06,188.22,225.07,188.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "226.405px 186.545px"
    },
    id: "el1042n160q3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,179.81v2.72a12.19,12.19,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,5.21,5.21,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,8.64,8.64,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1,1,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1A8.58,8.58,0,0,1,235.71,179.81Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.43-1,0a2.24,2.24,0,0,0-1,1.17,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S231.69,184.39,231.7,184.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.035px 182.705px"
    },
    id: "ely85l6re41y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,301.06c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.49,7.49,0,0,1-.46,1.59,5.5,5.5,0,0,1-.81,1.34,4.72,4.72,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1,1,0,0,1-.81-.41,2.43,2.43,0,0,1-.46-1.05,7.71,7.71,0,0,1-.17-1.54q0-.57,0-1.32c0-.49,0-.93,0-1.33a11.17,11.17,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.21,5.21,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,57.5,301.06Zm-4,5a3,3,0,0,0,.34,1.5c.19.3.53.31,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.31-1,0a2.22,2.22,0,0,0-1,1.18,6,6,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S53.48,305.64,53.5,306Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "54.83px 303.97px"
    },
    id: "el8c51a90dszh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36,300a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.17.17,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.07-.25V298l-1.42,2.52a.38.38,0,0,1-.19.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "60.1275px 300.207px"
    },
    id: "eln1kj39ny3xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.93,297.39a.37.37,0,0,1,0-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.25v9.89a.73.73,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.46a.15.15,0,0,1-.19,0,.3.3,0,0,1-.08-.25v-7.56l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "64.7431px 297.595px"
    },
    id: "el9ci9gbhabg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,294.75a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "69.2776px 294.955px"
    },
    id: "el6ddefu9zr8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,292.11a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.3.3,0,0,1-.08-.25v-7.56l-1.42,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.8475px 292.314px"
    },
    id: "ellk6sdaoaef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.32,286.74c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.37,2.37,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,82.32,286.74Zm-4,5a3.14,3.14,0,0,0,.35,1.51c.19.29.52.3,1,0a2.18,2.18,0,0,0,1-1.18,5.91,5.91,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.2,2.2,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S78.3,291.32,78.31,291.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.645px 289.67px"
    },
    id: "elkkfsy83nchd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,283c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.82-.41,2.32,2.32,0,0,1-.45-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.87,6.87,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.48,2.48,0,0,1,.46,1.06A9.53,9.53,0,0,1,88.84,283Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.3,2.3,0,0,0,1-1.18,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S84.82,287.55,84.83,287.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.165px 285.91px"
    },
    id: "elkg5tzmk1pzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,281.94a.38.38,0,0,1-.06-.27.72.72,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.14.14,0,0,1,.18,0,.3.3,0,0,1,.08.25v9.89a.67.67,0,0,1-.08.33.44.44,0,0,1-.18.23l-.81.47a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "91.4643px 282.146px"
    },
    id: "ela0pi4039v9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.94,276.56c0,.19,0,.41,0,.64v1.44c0,.24,0,.45,0,.65a12.5,12.5,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,8.52,8.52,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a12.64,12.64,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61A5.83,5.83,0,0,1,96,275a4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.46,8.46,0,0,1,99.94,276.56Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.43,1,0a2.18,2.18,0,0,0,1-1.18,5.93,5.93,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3,3,0,0,0-.34-1.51c-.19-.29-.52-.31-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S95.92,281.15,95.93,281.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "97.265px 279.485px"
    },
    id: "eldk1rc55wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,275.54a.47.47,0,0,1-.05-.28.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.88.88,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.3.3,0,0,1-.08-.25v-7.56L101.64,276a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "102.563px 275.732px"
    },
    id: "ellsdahdyset",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,270.16c0,.19,0,.4,0,.64v1.43c0,.24,0,.46,0,.65a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.32,2.32,0,0,1-.46-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.88,6.88,0,0,1,.46-1.6,5.27,5.27,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,111,270.16Zm-4,5a3,3,0,0,0,.34,1.51q.28.44,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.16,2.16,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S107,274.74,107,275.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "108.325px 273.055px"
    },
    id: "elvr180ycjxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89,269.13a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.15-3.86.17-.28a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.88a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56l-1.41,2.51a.41.41,0,0,1-.19.2.18.18,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.658px 269.333px"
    },
    id: "elqge6wapksrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,266.49a.41.41,0,0,1,0-.28.84.84,0,0,1,.1-.33l2.16-3.86a2.54,2.54,0,0,1,.16-.28.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.56L117.31,267a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "118.273px 266.693px"
    },
    id: "elpsw5devizfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,261.11c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.3,5.3,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.39,2.39,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.32,2.32,0,0,1-.45-1,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,6.82,6.82,0,0,1,.45-1.61,5.63,5.63,0,0,1,.81-1.36,4.35,4.35,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,126.7,261.11Zm-4,5a3.11,3.11,0,0,0,.35,1.51c.19.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.19,3.19,0,0,0-.34-1.51q-.3-.43-1,0a2.18,2.18,0,0,0-1,1.18,6.19,6.19,0,0,0-.35,1.9c0,.4,0,.83,0,1.3S122.68,265.69,122.69,266.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.025px 264.045px"
    },
    id: "elmqiiz9mj6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,260.08a.42.42,0,0,1,0-.27,1,1,0,0,1,.1-.34l2.16-3.86.17-.27a.55.55,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.07.25v9.89a.78.78,0,0,1-.07.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "129.365px 260.285px"
    },
    id: "elr77hi5zg509",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,257.44a.33.33,0,0,1,0-.27.7.7,0,0,1,.1-.34l2.16-3.86c0-.09.1-.18.16-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.53.53,0,0,1-.19.24l-.81.46a.14.14,0,0,1-.18,0,.32.32,0,0,1-.08-.25v-7.56L133,257.93c-.07.11-.13.18-.2.2a.16.16,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.941px 257.644px"
    },
    id: "elx4krby94c2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,252.07c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.4,7.4,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.51,4.51,0,0,1-1.22,1,2.3,2.3,0,0,1-1.24.4,1.1,1.1,0,0,1-.81-.4,2.41,2.41,0,0,1-.45-1.06,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.74,6.74,0,0,1,.45-1.6,5.69,5.69,0,0,1,.81-1.37,4.35,4.35,0,0,1,1.24-1,2.28,2.28,0,0,1,1.22-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,142.37,252.07Zm-4,5a3.14,3.14,0,0,0,.35,1.51q.28.43,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51c-.2-.29-.53-.3-1,0a2.18,2.18,0,0,0-1,1.18,6.26,6.26,0,0,0-.35,1.91c0,.39,0,.82,0,1.29S138.35,256.65,138.36,257Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "139.695px 254.975px"
    },
    id: "elxw68u1tmf7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,248.3c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a13.84,13.84,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.46,2.46,0,0,1-1.23.4,1.11,1.11,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.81,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,7.4,7.4,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.31,2.31,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A9.66,9.66,0,0,1,148.89,248.3Zm-4,5a3,3,0,0,0,.34,1.51q.28.43,1,0a2.24,2.24,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.82,0-1.29s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.44-1,0a2.18,2.18,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S144.87,252.88,144.89,253.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.215px 251.235px"
    },
    id: "el6c3lxw9ldst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75,247.27a.38.38,0,0,1-.06-.27.85.85,0,0,1,.11-.34L152,242.8a3.18,3.18,0,0,1,.17-.27.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25V252a.8.8,0,0,1-.08.33.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.37.37,0,0,1-.07-.25v-7.56l-1.42,2.51a.41.41,0,0,1-.19.2.17.17,0,0,1-.19-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "151.543px 247.46px"
    },
    id: "elcgdbhycv9fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,241.89c0,.19,0,.41,0,.64V244c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.32s0-.93,0-1.33a14.38,14.38,0,0,1,.17-1.76,7.5,7.5,0,0,1,.46-1.61,5.83,5.83,0,0,1,.81-1.36,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1,1,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1A8.46,8.46,0,0,1,160,241.89Zm-4,5a3.19,3.19,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.27,6.27,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S156,246.48,156,246.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.325px 244.835px"
    },
    id: "el65z8jo4hatk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.84,240.86a.37.37,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.73.73,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.46a.14.14,0,0,1-.19,0,.29.29,0,0,1-.08-.24v-7.57l-1.41,2.52a.4.4,0,0,1-.2.19.14.14,0,0,1-.18-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.613px 241.062px"
    },
    id: "elgcm9t0rg46n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,235.49c0,.19,0,.4,0,.64v1.43c0,.24,0,.46,0,.65a12.21,12.21,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.5,5.5,0,0,1-.81,1.34,4.56,4.56,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1,1,0,0,1-.81-.4,2.32,2.32,0,0,1-.46-1.05,8.58,8.58,0,0,1-.18-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a12.64,12.64,0,0,1,.18-1.76,6.88,6.88,0,0,1,.46-1.6,5.56,5.56,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.29,2.29,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.43,2.43,0,0,1,.46,1.05A8.64,8.64,0,0,1,171.08,235.49Zm-4,5a3,3,0,0,0,.34,1.51q.3.43,1,0a2.28,2.28,0,0,0,1-1.17,6.28,6.28,0,0,0,.34-1.91c0-.39,0-.83,0-1.3s0-.89,0-1.27a3.13,3.13,0,0,0-.34-1.51q-.3-.44-1,0a2.24,2.24,0,0,0-1,1.17,6,6,0,0,0-.34,1.91c0,.39,0,.83,0,1.3S167.06,240.07,167.08,240.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "168.405px 238.385px"
    },
    id: "ellgquaskrrxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.94,234.46a.4.4,0,0,1-.06-.28.86.86,0,0,1,.11-.33l2.15-3.86.17-.28a.66.66,0,0,1,.18-.19l.78-.44a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.81.81,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.56L172.78,235a.41.41,0,0,1-.19.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "173.708px 234.663px"
    },
    id: "eldgjbln5vd3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.51,231.82a.41.41,0,0,1,0-.28.79.79,0,0,1,.1-.33l2.16-3.87.16-.27a.68.68,0,0,1,.19-.19l.77-.44a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24v9.89a.68.68,0,0,1-.08.34.5.5,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V229.8l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "178.324px 232.023px"
    },
    id: "elikmv0jnze3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,226.44c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.65a12.21,12.21,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.57,5.57,0,0,1-.81,1.35,4.72,4.72,0,0,1-1.23,1,2.36,2.36,0,0,1-1.23.4,1.11,1.11,0,0,1-.82-.41,2.43,2.43,0,0,1-.45-1,8.57,8.57,0,0,1-.18-1.54c0-.39,0-.82,0-1.32s0-.94,0-1.33a12.78,12.78,0,0,1,.18-1.77,7.4,7.4,0,0,1,.45-1.6,5.36,5.36,0,0,1,.82-1.36,4.31,4.31,0,0,1,1.23-1,2.4,2.4,0,0,1,1.23-.4,1.1,1.1,0,0,1,.81.4,2.54,2.54,0,0,1,.46,1.06A8.52,8.52,0,0,1,186.75,226.44Zm-4,5a3,3,0,0,0,.34,1.51c.2.29.52.3,1,0a2.26,2.26,0,0,0,1-1.18,6.27,6.27,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.9,0-1.28a3.16,3.16,0,0,0-.34-1.51q-.3-.43-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S182.73,231,182.75,231.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "184.075px 229.375px"
    },
    id: "elm949velk54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,225.41a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.66.66,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.36.36,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.61.61,0,0,1-.19.24l-.81.46a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-7.56l-1.41,2.51c-.06.11-.12.18-.19.2a.18.18,0,0,1-.19,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.378px 225.615px"
    },
    id: "elyq6neyla5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,220c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a12.34,12.34,0,0,1-.18,1.75,6.85,6.85,0,0,1-.45,1.58,5.24,5.24,0,0,1-.82,1.34,4.41,4.41,0,0,1-1.23,1,2.27,2.27,0,0,1-1.23.4,1.1,1.1,0,0,1-.81-.4,2.54,2.54,0,0,1-.46-1.06,9.53,9.53,0,0,1-.17-1.54c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.25,7.25,0,0,1,.46-1.6,5.69,5.69,0,0,1,.81-1.37,4.31,4.31,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.32,2.32,0,0,1,.45,1.05A8.58,8.58,0,0,1,197.85,220Zm-4,5a3.16,3.16,0,0,0,.34,1.51q.3.44,1,0a2.18,2.18,0,0,0,1-1.18,6.19,6.19,0,0,0,.35-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51c-.19-.29-.52-.3-1,0a2.26,2.26,0,0,0-1,1.18,6.28,6.28,0,0,0-.34,1.91c0,.39,0,.82,0,1.29S193.83,224.62,193.84,225Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.175px 222.905px"
    },
    id: "ellcz0mmn805",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.7,219a.47.47,0,0,1,0-.28.75.75,0,0,1,.1-.33l2.16-3.87.16-.27a.57.57,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.45.45,0,0,1-.19.23l-.8.47a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V217l-1.41,2.52a.48.48,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "200.515px 219.195px"
    },
    id: "elbx78tfqi2q7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.28,216.37a.4.4,0,0,1-.06-.28.76.76,0,0,1,.11-.33l2.15-3.87c.05-.09.11-.18.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.89a.84.84,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-7.57l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.048px 216.562px"
    },
    id: "el29g4tiug0ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,211c0,.19,0,.4,0,.64v1.44c0,.23,0,.45,0,.64a12.19,12.19,0,0,1-.18,1.75,6.72,6.72,0,0,1-.46,1.58,4.94,4.94,0,0,1-.81,1.34,4.41,4.41,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.06,1.06,0,0,1-.81-.4,2.43,2.43,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76,7.41,7.41,0,0,1,.46-1.6,5.63,5.63,0,0,1,.81-1.36,4.5,4.5,0,0,1,1.23-1.05,2.4,2.4,0,0,1,1.23-.39,1.06,1.06,0,0,1,.81.4,2.32,2.32,0,0,1,.46,1.05A8.58,8.58,0,0,1,213.52,211Zm-4,5a3.13,3.13,0,0,0,.34,1.51q.3.43,1,0a2.16,2.16,0,0,0,1-1.17,6,6,0,0,0,.34-1.91c0-.39,0-.83,0-1.29s0-.9,0-1.28a3,3,0,0,0-.34-1.51q-.29-.44-1,0a2.28,2.28,0,0,0-1,1.17,6.34,6.34,0,0,0-.34,1.91c0,.4,0,.83,0,1.3S209.5,215.57,209.51,216Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "210.845px 213.875px"
    },
    id: "eljapc8945bzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,210a.39.39,0,0,1-.05-.27.83.83,0,0,1,.1-.34l2.16-3.86c0-.1.11-.19.16-.27a.49.49,0,0,1,.19-.19l.77-.45a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v9.89a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-.8.47c-.08,0-.14,0-.19,0a.29.29,0,0,1-.08-.24v-7.56l-1.41,2.51a.42.42,0,0,1-.2.2.16.16,0,0,1-.18-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "216.143px 210.188px"
    },
    id: "elevgyp9eqgeq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.61,204.58c0,.19,0,.41,0,.64v1.44c0,.23,0,.45,0,.65a13.86,13.86,0,0,1-.17,1.74,7.23,7.23,0,0,1-.46,1.58,5.13,5.13,0,0,1-.82,1.35,4.51,4.51,0,0,1-1.22,1,2.37,2.37,0,0,1-1.24.4,1.07,1.07,0,0,1-.81-.41,2.43,2.43,0,0,1-.45-1.05,8.46,8.46,0,0,1-.18-1.54c0-.38,0-.82,0-1.32s0-.94,0-1.33a12.49,12.49,0,0,1,.18-1.76,7.49,7.49,0,0,1,.45-1.61,5.63,5.63,0,0,1,.81-1.36,4.49,4.49,0,0,1,1.24-1,2.4,2.4,0,0,1,1.22-.4,1.1,1.1,0,0,1,.82.4,2.54,2.54,0,0,1,.46,1.06A9.53,9.53,0,0,1,224.61,204.58Zm-4,5a3,3,0,0,0,.34,1.5c.19.29.53.3,1,0a2.26,2.26,0,0,0,1-1.18,6.21,6.21,0,0,0,.34-1.9c0-.4,0-.83,0-1.3s0-.89,0-1.28a3.11,3.11,0,0,0-.34-1.5c-.2-.29-.53-.31-1,0a2.22,2.22,0,0,0-1,1.18,5.93,5.93,0,0,0-.34,1.9c0,.4,0,.83,0,1.3S220.59,209.16,220.61,209.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "221.935px 207.49px"
    },
    id: "elxvv0bgsjj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,203.55a.36.36,0,0,1-.06-.27.85.85,0,0,1,.11-.34l2.15-3.86.17-.27a.47.47,0,0,1,.18-.19l.78-.45a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v9.89a.88.88,0,0,1-.08.34.57.57,0,0,1-.19.23l-.81.46a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-7.56l-1.41,2.52a.38.38,0,0,1-.19.19.16.16,0,0,1-.19-.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.237px 203.755px"
    },
    id: "elht585spven",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,198.18c0,.19,0,.4,0,.63v1.44c0,.24,0,.45,0,.65a14,14,0,0,1-.17,1.75,7.23,7.23,0,0,1-.46,1.58,5.24,5.24,0,0,1-.82,1.34,4.44,4.44,0,0,1-1.23,1,2.34,2.34,0,0,1-1.23.39,1.1,1.1,0,0,1-.81-.4,2.49,2.49,0,0,1-.46-1.05,9.66,9.66,0,0,1-.17-1.55c0-.38,0-.82,0-1.31s0-.94,0-1.34a14.38,14.38,0,0,1,.17-1.76A7.41,7.41,0,0,1,231,198a5.69,5.69,0,0,1,.81-1.37,4.47,4.47,0,0,1,1.23-1,2.34,2.34,0,0,1,1.23-.39,1.07,1.07,0,0,1,.82.4,2.43,2.43,0,0,1,.46,1A9.66,9.66,0,0,1,235.71,198.18Zm-4,5a3.28,3.28,0,0,0,.34,1.51q.3.43,1,0a2.19,2.19,0,0,0,1-1.17,6.32,6.32,0,0,0,.35-1.91c0-.4,0-.83,0-1.3s0-.89,0-1.27a3.11,3.11,0,0,0-.35-1.51q-.28-.44-1,0a2.24,2.24,0,0,0-1,1.17,6.6,6.6,0,0,0-.34,1.91c0,.39,0,.83,0,1.29S231.69,202.76,231.7,203.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.035px 201.1px"
    },
    id: "eleynuctr5qrf",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "82.39px 297.9px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "82.39px 297.9px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 331.47 82.38 358.16 128.61 331.47 82.38 304.78 36.15 331.47",
    style: {
      fill: "current",
      transformOrigin: "82.38px 331.47px"
    },
    id: "el7jhiv6cw75e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8g2qcr9b0eu"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 331.47 82.38 358.16 128.61 331.47 82.38 304.78 36.15 331.47",
    style: {
      opacity: 0.1,
      transformOrigin: "82.38px 331.47px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli1wsp8lmodl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 358.16 82.38 354.83 125.72 329.8 128.62 331.47 82.38 358.16",
    style: {
      opacity: 0.1,
      transformOrigin: "105.5px 343.98px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.38,358.16v12.31a6.21,6.21,0,0,1-3.08-.74h0l-20-11.56L38,345.88a4.09,4.09,0,0,1-1.85-3.2V331.47Z",
    style: {
      fill: "current",
      transformOrigin: "59.265px 350.971px"
    },
    id: "el2e1hi4x5zko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmgapiu5052"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.38,358.16v12.31a6.21,6.21,0,0,1-3.08-.74h0l-20-11.56L38,345.88a4.09,4.09,0,0,1-1.85-3.2V331.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "59.265px 350.971px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,337.37,63.5,350.61A3.39,3.39,0,0,1,65,353.27v3.12c0,1-.69,1.38-1.54.89L40.58,344A3.39,3.39,0,0,1,39,341.38v-3.12C39,337.28,39.73,336.88,40.58,337.37Z",
    style: {
      fill: "current",
      transformOrigin: "52px 347.327px"
    },
    id: "elac135tw378d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,340v1.51a.69.69,0,0,0,.31.54l.34.2c.18.09.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.54l-.34-.2C40.8,339.73,40.66,339.81,40.66,340Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "41.14px 341.034px"
    },
    id: "elt5untgb9ct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,340.91v1.51a.65.65,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C42.35,340.63,42.22,340.71,42.22,340.91Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "42.7px 341.938px"
    },
    id: "elks4k6awr5uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,341.8v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.53l-.35-.2C43.91,341.53,43.77,341.61,43.77,341.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "44.255px 342.838px"
    },
    id: "elj9wm9ouhw1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,342.7v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C45.47,342.43,45.33,342.51,45.33,342.7Z",
    style: {
      fill: "current",
      transformOrigin: "45.81px 343.736px"
    },
    id: "el12o5js2npvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,343.6v1.51a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C47,343.32,46.89,343.4,46.89,343.6Z",
    style: {
      fill: "current",
      transformOrigin: "47.37px 344.628px"
    },
    id: "elglpkon4sjue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,344.5V346a.67.67,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.35-.2C48.58,344.22,48.44,344.3,48.44,344.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "48.925px 345.521px"
    },
    id: "elqmsvv9t4n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,345.39v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18V346a.65.65,0,0,0-.3-.53l-.35-.2C50.14,345.12,50,345.2,50,345.39Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "50.48px 346.436px"
    },
    id: "elof10kwsm8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,346.29v1.51a.69.69,0,0,0,.31.54l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C51.7,346,51.56,346.1,51.56,346.29Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "52.04px 347.322px"
    },
    id: "el1slwgmhjbfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,347.19v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C53.25,346.91,53.11,347,53.11,347.19Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "53.595px 348.219px"
    },
    id: "eliku3vwpa1tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,348.09v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.53l-.35-.2C54.81,347.81,54.67,347.89,54.67,348.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "55.15px 349.118px"
    },
    id: "elyqtwvhwayy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,349v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.2C56.37,348.71,56.23,348.79,56.23,349Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "56.71px 350.032px"
    },
    id: "el6okjpyz0u3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,349.88v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C57.92,349.61,57.78,349.69,57.78,349.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.265px 350.916px"
    },
    id: "el6dyj4okjd9x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,350.78v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C59.48,350.5,59.34,350.58,59.34,350.78Z",
    style: {
      fill: "current",
      transformOrigin: "59.82px 351.808px"
    },
    id: "elafqjol2ueva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ely7h2e9m81ya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.33,342.7v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C45.47,342.43,45.33,342.51,45.33,342.7Z",
    style: {
      opacity: 0.2,
      transformOrigin: "45.81px 343.736px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9uoh1mi67un"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89,343.6v1.51a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C47,343.32,46.89,343.4,46.89,343.6Z",
    style: {
      opacity: 0.2,
      transformOrigin: "47.37px 344.628px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elizmvj12is4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,350.78v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C59.48,350.5,59.34,350.58,59.34,350.78Z",
    style: {
      opacity: 0.2,
      transformOrigin: "59.82px 351.808px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,351.68v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C61,351.4,60.9,351.48,60.9,351.68Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "61.38px 352.708px"
    },
    id: "el8rmv67em597",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,352.57v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C62.59,352.3,62.45,352.38,62.45,352.57Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "62.935px 353.608px"
    },
    id: "elueextag0e7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,331.47v11.21a4.11,4.11,0,0,1-1.85,3.2L108.38,356.5,85.46,369.73a6.24,6.24,0,0,1-3.08.74V358.16Z",
    style: {
      fill: "current",
      transformOrigin: "105.5px 350.971px"
    },
    id: "el2uuepxd58by",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elykbo3xb79pf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.62,331.47v11.21a4.11,4.11,0,0,1-1.85,3.2L108.38,356.5,85.46,369.73a6.24,6.24,0,0,1-3.08.74V358.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "105.5px 350.971px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,356.31l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.31,1,1,0,0,1-.39.87h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.16,1.16,0,0,1,.05-.34Z",
    style: {
      fill: "current",
      transformOrigin: "70.6614px 357.679px"
    },
    id: "el4tyq1i8vcaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnf7i8abbhts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.14,356.31l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.31,1,1,0,0,1-.39.87h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.16,1.16,0,0,1,.05-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "70.6614px 357.679px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,356.39a2.94,2.94,0,0,1,1.34,2.31c0,.86-.6,1.2-1.34.78a3,3,0,0,1-1.34-2.32C68.78,356.31,69.38,356,70.12,356.39Z",
    style: {
      fill: "current",
      transformOrigin: "70.12px 357.941px"
    },
    id: "el4qfd1oqp7k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg8xhlm06d44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,356.39a2.94,2.94,0,0,1,1.34,2.31c0,.86-.6,1.2-1.34.78a3,3,0,0,1-1.34-2.32C68.78,356.31,69.38,356,70.12,356.39Z",
    style: {
      opacity: 0.2,
      transformOrigin: "70.12px 357.941px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,359.66l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,361.67a.92.92,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      fill: "current",
      transformOrigin: "76.5026px 361.043px"
    },
    id: "elmlotdrilg3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpmdn59smtzp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,359.66l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,361.67a.92.92,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      opacity: 0.4,
      transformOrigin: "76.5026px 361.043px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,359.74a3,3,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C74.59,359.66,75.19,359.31,75.93,359.74Z",
    style: {
      fill: "current",
      transformOrigin: "75.93px 361.285px"
    },
    id: "el7g7k9z9uf7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2ig9j40d6ml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.93,359.74a3,3,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C74.59,359.66,75.19,359.31,75.93,359.74Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.93px 361.285px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 311.45 82.38 338.14 128.61 311.45 82.38 284.76 36.15 311.45",
    style: {
      fill: "current",
      transformOrigin: "82.38px 311.45px"
    },
    id: "ela6y49hbfjy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxetfxm6kqe"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 311.45 82.38 338.14 128.61 311.45 82.38 284.76 36.15 311.45",
    style: {
      opacity: 0.1,
      transformOrigin: "82.38px 311.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elr3rose0w5mf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 338.14 82.38 334.81 125.72 309.78 128.61 311.45 82.38 338.14",
    style: {
      opacity: 0.1,
      transformOrigin: "105.495px 323.96px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 324.8 82.38 351.49 82.38 338.14 36.15 311.45 36.15 324.8",
    style: {
      fill: "current",
      transformOrigin: "59.265px 331.47px"
    },
    id: "el3g9thtfguxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcfo1gvuvqyh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 324.8 82.38 351.49 82.38 338.14 36.15 311.45 36.15 324.8",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "59.265px 331.47px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,317.35,63.5,330.59A3.41,3.41,0,0,1,65,333.26v3.12c0,1-.69,1.38-1.54.88L40.58,324A3.41,3.41,0,0,1,39,321.36v-3.12C39,317.26,39.73,316.86,40.58,317.35Z",
    style: {
      fill: "current",
      transformOrigin: "52px 327.31px"
    },
    id: "elz86fvmun0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,320v1.52A.69.69,0,0,0,41,322l.34.2c.18.1.31,0,.31-.18v-1.51a.64.64,0,0,0-.31-.53l-.34-.2C40.8,319.72,40.66,319.8,40.66,320Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "41.155px 321px"
    },
    id: "el44e5uzb63ws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,320.89v1.51a.67.67,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C42.35,320.62,42.22,320.69,42.22,320.89Z",
    style: {
      fill: "current",
      transformOrigin: "42.7px 321.923px"
    },
    id: "elemy2rjn1hw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,321.79v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C43.91,321.51,43.77,321.59,43.77,321.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "44.255px 322.818px"
    },
    id: "elvhq9c5tu079",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,322.69v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.53l-.35-.2C45.47,322.41,45.33,322.49,45.33,322.69Z",
    style: {
      fill: "current",
      transformOrigin: "45.81px 323.718px"
    },
    id: "el7bw61kk3jc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,323.58v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.2C47,323.31,46.89,323.39,46.89,323.58Z",
    style: {
      fill: "current",
      transformOrigin: "47.37px 324.618px"
    },
    id: "eltzfoagjhwua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,324.48V326a.69.69,0,0,0,.31.54l.35.2c.17.09.31,0,.31-.18V325a.69.69,0,0,0-.31-.54l-.35-.2C48.58,324.2,48.44,324.28,48.44,324.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "48.925px 325.508px"
    },
    id: "ela3wxob009qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,325.38v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C50.14,325.1,50,325.18,50,325.38Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "50.48px 326.408px"
    },
    id: "elpc9suds3l9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,326.28v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C51.7,326,51.56,326.08,51.56,326.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "52.04px 327.308px"
    },
    id: "elra4js977ao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,327.17v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C53.25,326.9,53.11,327,53.11,327.17Z",
    style: {
      fill: "current",
      transformOrigin: "53.595px 328.21px"
    },
    id: "elnwmvl57o9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,328.07v1.51a.69.69,0,0,0,.31.54l.35.2c.17.09.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C54.81,327.79,54.67,327.87,54.67,328.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "55.15px 329.101px"
    },
    id: "elr41fu52ytkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,329v1.51a.67.67,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.34-.2C56.37,328.69,56.23,328.77,56.23,329Z",
    style: {
      fill: "current",
      transformOrigin: "56.71px 330.019px"
    },
    id: "eldkxu3sm38hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,329.87v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.53l-.35-.2C57.92,329.59,57.78,329.67,57.78,329.87Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.265px 330.898px"
    },
    id: "elsuhthe4bea8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,330.76v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.65.65,0,0,0-.3-.53l-.35-.2C59.48,330.49,59.34,330.57,59.34,330.76Z",
    style: {
      fill: "current",
      transformOrigin: "59.82px 331.798px"
    },
    id: "elbzjy0bkoy2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbxm7xz0h4d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.22,320.89v1.51a.67.67,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C42.35,320.62,42.22,320.69,42.22,320.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "42.7px 321.923px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2xm0lb9ipfx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.33,322.69v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.53l-.35-.2C45.47,322.41,45.33,322.49,45.33,322.69Z",
    style: {
      opacity: 0.2,
      transformOrigin: "45.81px 323.718px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmm2bbe788pj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89,323.58v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.2C47,323.31,46.89,323.39,46.89,323.58Z",
    style: {
      opacity: 0.2,
      transformOrigin: "47.37px 324.618px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1ig7qo2gz5o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.11,327.17v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C53.25,326.9,53.11,327,53.11,327.17Z",
    style: {
      opacity: 0.2,
      transformOrigin: "53.595px 328.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3nq1vqrevea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.23,329v1.51a.67.67,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.34-.2C56.37,328.69,56.23,328.77,56.23,329Z",
    style: {
      opacity: 0.2,
      transformOrigin: "56.71px 330.019px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely7n23ns0pp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,330.76v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.65.65,0,0,0-.3-.53l-.35-.2C59.48,330.49,59.34,330.57,59.34,330.76Z",
    style: {
      opacity: 0.2,
      transformOrigin: "59.82px 331.798px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,331.66v1.51a.69.69,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C61,331.38,60.9,331.46,60.9,331.66Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "61.38px 332.691px"
    },
    id: "elhk4nbg09jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,332.56v1.51a.67.67,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C62.59,332.28,62.45,332.36,62.45,332.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "62.935px 333.588px"
    },
    id: "elfutmsd2temc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 351.49 128.61 324.8 128.61 311.45 82.38 338.14 82.38 351.49",
    style: {
      fill: "current",
      transformOrigin: "105.495px 331.47px"
    },
    id: "elaxoiwmv6h08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el96bfxjxcimo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 351.49 128.61 324.8 128.61 311.45 82.38 338.14 82.38 351.49",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "105.495px 331.47px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.92 331.47 41.92 328.13 82.38 351.49 82.38 354.83 41.92 331.47",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.15px 341.48px"
    },
    id: "elqj38tiw4kqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.72 326.47 125.72 329.8 82.38 354.83 82.38 351.49 125.72 326.47",
    style: {
      fill: "current",
      transformOrigin: "104.05px 340.65px"
    },
    id: "elis5suvmhkif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.72 326.47 125.72 329.8 82.38 354.83 82.38 351.49 125.72 326.47",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "104.05px 340.65px"
    },
    id: "elo338kbic2sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,336.29l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      fill: "current",
      transformOrigin: "70.6624px 337.659px"
    },
    id: "elqz75jih3r1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfzbp8xf98hs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.14,336.29l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "70.6624px 337.659px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,336.37a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,336.29,69.38,335.94,70.12,336.37Z",
    style: {
      fill: "current",
      transformOrigin: "70.12px 337.915px"
    },
    id: "el7c11c0txjzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5ohes9vbgbu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,336.37a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,336.29,69.38,335.94,70.12,336.37Z",
    style: {
      opacity: 0.2,
      transformOrigin: "70.12px 337.915px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,339.64l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,341.65a.91.91,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      fill: "current",
      transformOrigin: "76.5029px 341.023px"
    },
    id: "elwd5oxuouvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elasdglky2sz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,339.64l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,341.65a.91.91,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      opacity: 0.4,
      transformOrigin: "76.5029px 341.023px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,339.72A3,3,0,0,1,77.27,342c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,339.64,75.19,339.29,75.93,339.72Z",
    style: {
      fill: "current",
      transformOrigin: "75.93px 341.245px"
    },
    id: "els3nl1tbi8cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4cm78xb02gq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.93,339.72A3,3,0,0,1,77.27,342c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,339.64,75.19,339.29,75.93,339.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.93px 341.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 291.43 82.38 318.12 128.61 291.43 82.38 264.74 36.15 291.43",
    style: {
      fill: "current",
      transformOrigin: "82.38px 291.43px"
    },
    id: "elgtrcsjgejyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqhmqx0smwo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 291.43 82.38 318.12 128.61 291.43 82.38 264.74 36.15 291.43",
    style: {
      opacity: 0.1,
      transformOrigin: "82.38px 291.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el488k3i4foy6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 318.12 82.38 314.79 125.72 289.76 128.61 291.43 82.38 318.12",
    style: {
      opacity: 0.1,
      transformOrigin: "105.495px 303.94px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 304.78 82.38 331.47 82.38 318.12 36.15 291.43 36.15 304.78",
    style: {
      fill: "current",
      transformOrigin: "59.265px 311.45px"
    },
    id: "elmlexe61g9lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx1hw6qyrmch"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 304.78 82.38 331.47 82.38 318.12 36.15 291.43 36.15 304.78",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "59.265px 311.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,297.32,63.5,310.55A3.41,3.41,0,0,1,65,313.22v3.12c0,1-.69,1.38-1.54.89L40.58,304A3.41,3.41,0,0,1,39,301.32V298.2C39,297.22,39.73,296.82,40.58,297.32Z",
    style: {
      fill: "current",
      transformOrigin: "52px 307.274px"
    },
    id: "elj1em8k7f4lk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,300v1.52A.69.69,0,0,0,41,302l.34.2c.18.1.31,0,.31-.18v-1.51a.65.65,0,0,0-.31-.53l-.34-.2C40.8,299.68,40.66,299.76,40.66,300Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "41.155px 300.989px"
    },
    id: "el5ryo8ly6bfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,300.85v1.51a.67.67,0,0,0,.31.54l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C42.35,300.58,42.22,300.66,42.22,300.85Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "42.7px 301.886px"
    },
    id: "elfvyfma4b8zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,301.75v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C43.91,301.47,43.77,301.55,43.77,301.75Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "44.255px 302.778px"
    },
    id: "el0aug4idke2ve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,302.65v1.51a.67.67,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18V303.2a.68.68,0,0,0-.3-.53l-.35-.2C45.47,302.37,45.33,302.45,45.33,302.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "45.81px 303.678px"
    },
    id: "elqtp2jmr2nvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,303.54v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18V304.1a.66.66,0,0,0-.31-.53l-.34-.2C47,303.27,46.89,303.35,46.89,303.54Z",
    style: {
      fill: "current",
      transformOrigin: "47.37px 304.578px"
    },
    id: "elrnk2j13pd8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,304.44V306a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18V305a.69.69,0,0,0-.31-.54l-.35-.2C48.58,304.17,48.44,304.25,48.44,304.44Z",
    style: {
      fill: "current",
      transformOrigin: "48.925px 305.501px"
    },
    id: "el5vi9149xtj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,305.34v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17V305.9a.68.68,0,0,0-.3-.54l-.35-.2C50.14,305.06,50,305.14,50,305.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "50.48px 306.368px"
    },
    id: "elw62064u85ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,306.24v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C51.7,306,51.56,306,51.56,306.24Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "52.04px 307.273px"
    },
    id: "el4uq26p2zeav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,307.13v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C53.25,306.86,53.11,306.94,53.11,307.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "53.595px 308.168px"
    },
    id: "el7bi4ykl9ozy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,308v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C54.81,307.76,54.67,307.84,54.67,308Z",
    style: {
      fill: "current",
      transformOrigin: "55.15px 309.045px"
    },
    id: "eloz3rks5ihnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,308.93v1.51a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.34-.2C56.37,308.65,56.23,308.73,56.23,308.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "56.71px 309.958px"
    },
    id: "elwewq6jaxfzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,309.83v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.35-.2C57.92,309.55,57.78,309.63,57.78,309.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.265px 310.858px"
    },
    id: "elym2u5kkd0ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,310.72v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.65.65,0,0,0-.3-.53l-.35-.2C59.48,310.45,59.34,310.53,59.34,310.72Z",
    style: {
      fill: "current",
      transformOrigin: "59.82px 311.758px"
    },
    id: "elf3gcvnwtmtd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,311.62v1.51a.69.69,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C61,311.35,60.9,311.42,60.9,311.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "61.38px 312.653px"
    },
    id: "elwup9ohnp56n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,312.52V314a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C62.59,312.24,62.45,312.32,62.45,312.52Z",
    style: {
      fill: "current",
      transformOrigin: "62.935px 313.527px"
    },
    id: "elo3h51ow2z8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln7a1bwh3je"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89,303.54v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18V304.1a.66.66,0,0,0-.31-.53l-.34-.2C47,303.27,46.89,303.35,46.89,303.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "47.37px 304.578px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellmt1bkay4r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.44,304.44V306a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18V305a.69.69,0,0,0-.31-.54l-.35-.2C48.58,304.17,48.44,304.25,48.44,304.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "48.925px 305.501px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6fm2yvy7ozh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.67,308v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C54.81,307.76,54.67,307.84,54.67,308Z",
    style: {
      opacity: 0.2,
      transformOrigin: "55.15px 309.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaj0ntjzm044"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,310.72v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.65.65,0,0,0-.3-.53l-.35-.2C59.48,310.45,59.34,310.53,59.34,310.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "59.82px 311.758px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnbjbq6705y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.45,312.52V314a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C62.59,312.24,62.45,312.32,62.45,312.52Z",
    style: {
      opacity: 0.2,
      transformOrigin: "62.935px 313.527px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 331.47 128.61 304.78 128.61 291.43 82.38 318.12 82.38 331.47",
    style: {
      fill: "current",
      transformOrigin: "105.495px 311.45px"
    },
    id: "eltzjc19ycink",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb7fy690x73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 331.47 128.61 304.78 128.61 291.43 82.38 318.12 82.38 331.47",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "105.495px 311.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.92 311.45 41.92 308.11 82.38 331.47 82.38 334.81 41.92 311.45",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.15px 321.46px"
    },
    id: "elofl0yf5fnnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.72 306.44 125.72 309.78 82.38 334.81 82.38 331.47 125.72 306.44",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "104.05px 320.625px"
    },
    id: "el1hxl0m0sjl7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,316.27l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      fill: "current",
      transformOrigin: "70.6624px 317.639px"
    },
    id: "el5bfex1yn8c4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9ecsvb2lbt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.14,316.27l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "70.6624px 317.639px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,316.35a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,316.27,69.38,315.92,70.12,316.35Z",
    style: {
      fill: "current",
      transformOrigin: "70.12px 317.895px"
    },
    id: "elgxwhqiin7rw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbwqpsgk9axl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,316.35a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,316.27,69.38,315.92,70.12,316.35Z",
    style: {
      opacity: 0.2,
      transformOrigin: "70.12px 317.895px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,319.62l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,321.63a.91.91,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      fill: "current",
      transformOrigin: "76.5029px 321.003px"
    },
    id: "elx23nk7gvi2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9y7ce3s7ut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,319.62l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,321.63a.91.91,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      opacity: 0.4,
      transformOrigin: "76.5029px 321.003px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,319.7A3,3,0,0,1,77.27,322c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,319.62,75.19,319.27,75.93,319.7Z",
    style: {
      fill: "current",
      transformOrigin: "75.93px 321.235px"
    },
    id: "el76u85j71qo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el94kaa8abje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.93,319.7A3,3,0,0,1,77.27,322c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,319.62,75.19,319.27,75.93,319.7Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.93px 321.235px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 271.41 82.38 298.1 128.61 271.41 82.38 244.72 36.15 271.41",
    style: {
      fill: "current",
      transformOrigin: "82.38px 271.41px"
    },
    id: "eln1iype8v5pn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el293cxcmjlip"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 271.41 82.38 298.1 128.61 271.41 82.38 244.72 36.15 271.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.15,
      transformOrigin: "82.38px 271.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhcaxpw68dca"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 271.41 82.38 298.1 128.61 271.41 82.38 244.72 36.15 271.41",
    style: {
      opacity: 0.1,
      transformOrigin: "82.38px 271.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmiepk0nwha8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 294.77 82.38 298.1 128.61 271.41 125.72 269.75 82.38 294.77",
    style: {
      opacity: 0.1,
      transformOrigin: "105.495px 283.925px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 284.76 82.38 311.45 82.38 298.1 36.15 271.41 36.15 284.76",
    style: {
      fill: "current",
      transformOrigin: "59.265px 291.43px"
    },
    id: "el2w455eul68w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elet0mp7cuani"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 284.76 82.38 311.45 82.38 298.1 36.15 271.41 36.15 284.76",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "59.265px 291.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,277.31,63.5,290.55A3.4,3.4,0,0,1,65,293.22v3.11c0,1-.69,1.38-1.54.89L40.58,284A3.39,3.39,0,0,1,39,281.32V278.2C39,277.22,39.73,276.82,40.58,277.31Z",
    style: {
      fill: "current",
      transformOrigin: "52px 287.267px"
    },
    id: "eliki4ys7snol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,280v1.51A.69.69,0,0,0,41,282l.34.2c.18.09.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.54l-.34-.2C40.8,279.67,40.66,279.75,40.66,280Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "41.155px 280.982px"
    },
    id: "els89mc3woa7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,280.85v1.51a.65.65,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17V281.4a.69.69,0,0,0-.31-.53l-.34-.2C42.35,280.57,42.22,280.65,42.22,280.85Z",
    style: {
      fill: "current",
      transformOrigin: "42.7px 281.878px"
    },
    id: "el3frv6ulpul2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,281.74v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18V282.3a.67.67,0,0,0-.31-.53l-.35-.2C43.91,281.47,43.77,281.55,43.77,281.74Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "44.255px 282.778px"
    },
    id: "elsf95qocr7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,282.64v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18V283.2a.68.68,0,0,0-.3-.54l-.35-.2C45.47,282.37,45.33,282.45,45.33,282.64Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "45.81px 283.676px"
    },
    id: "elqdy9gch9md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,283.54v1.51a.69.69,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18V284.1a.69.69,0,0,0-.31-.54l-.34-.2C47,283.26,46.89,283.34,46.89,283.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "47.37px 284.571px"
    },
    id: "el8i2i1uex66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,284.44V286a.67.67,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18V285a.69.69,0,0,0-.31-.53l-.35-.2C48.58,284.16,48.44,284.24,48.44,284.44Z",
    style: {
      fill: "current",
      transformOrigin: "48.925px 285.495px"
    },
    id: "elz0f33874fie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,285.33v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.66.66,0,0,0-.3-.53l-.35-.2C50.14,285.06,50,285.14,50,285.33Z",
    style: {
      fill: "current",
      transformOrigin: "50.48px 286.368px"
    },
    id: "elfcpj1jxtyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,286.23v1.51a.69.69,0,0,0,.31.54l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C51.7,286,51.56,286,51.56,286.23Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "52.04px 287.271px"
    },
    id: "eltbdxxzgb2mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,287.13v1.51a.66.66,0,0,0,.31.53l.35.21c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C53.25,286.85,53.11,286.93,53.11,287.13Z",
    style: {
      fill: "current",
      transformOrigin: "53.595px 288.161px"
    },
    id: "el0a2b9b4d5r1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,288v1.51a.67.67,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.53l-.35-.2C54.81,287.75,54.67,287.83,54.67,288Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "55.15px 289.037px"
    },
    id: "eleidv4lqs9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,288.92v1.52a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.2C56.37,288.65,56.23,288.73,56.23,288.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "56.71px 289.958px"
    },
    id: "elunm1j3w11oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,289.82v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C57.92,289.55,57.78,289.63,57.78,289.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "58.265px 290.856px"
    },
    id: "el6av14hoi1gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,290.72v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C59.48,290.44,59.34,290.52,59.34,290.72Z",
    style: {
      fill: "current",
      transformOrigin: "59.82px 291.748px"
    },
    id: "elhgvcqu9jkz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0fdpqxyy05uh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.22,280.85v1.51a.65.65,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17V281.4a.69.69,0,0,0-.31-.53l-.34-.2C42.35,280.57,42.22,280.65,42.22,280.85Z",
    style: {
      opacity: 0.2,
      transformOrigin: "42.7px 281.878px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrohgxr6sua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.44,284.44V286a.67.67,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18V285a.69.69,0,0,0-.31-.53l-.35-.2C48.58,284.16,48.44,284.24,48.44,284.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "48.925px 285.495px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgyhqiv0va1d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,285.33v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.66.66,0,0,0-.3-.53l-.35-.2C50.14,285.06,50,285.14,50,285.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "50.48px 286.368px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3di9qm5717a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.11,287.13v1.51a.66.66,0,0,0,.31.53l.35.21c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C53.25,286.85,53.11,286.93,53.11,287.13Z",
    style: {
      opacity: 0.2,
      transformOrigin: "53.595px 288.161px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8huaj2m6dgt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,290.72v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C59.48,290.44,59.34,290.52,59.34,290.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "59.82px 291.748px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,291.62v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C61,291.34,60.9,291.42,60.9,291.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "61.38px 292.648px"
    },
    id: "ele0873lsjz3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,292.51V294a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C62.59,292.24,62.45,292.32,62.45,292.51Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "62.935px 293.527px"
    },
    id: "eleaf36py5g4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 311.45 128.61 284.76 128.61 271.41 82.38 298.1 82.38 311.45",
    style: {
      fill: "current",
      transformOrigin: "105.495px 291.43px"
    },
    id: "el0fwcudi4fi9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgbhuz2s9v1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 311.45 128.61 284.76 128.61 271.41 82.38 298.1 82.38 311.45",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "105.495px 291.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.92 291.43 41.92 288.09 82.38 311.45 82.38 314.79 41.92 291.43",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.15px 301.44px"
    },
    id: "elb1py7di0m2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.72 286.43 125.72 289.76 82.38 314.79 82.38 311.45 125.72 286.43",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "104.05px 300.61px"
    },
    id: "elv9jb7gpfvlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,296.25l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      fill: "current",
      transformOrigin: "70.6624px 297.619px"
    },
    id: "elrodgak76h8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvwpnp7aifdd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.14,296.25l.71-.41h0a.93.93,0,0,1,1,.1,3,3,0,0,1,1.33,2.32.94.94,0,0,1-.39.86h0l-.66.38-.11-.2a1.36,1.36,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.21,1.21,0,0,1,.05-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "70.6624px 297.619px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,296.33a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,296.25,69.38,295.9,70.12,296.33Z",
    style: {
      fill: "current",
      transformOrigin: "70.12px 297.875px"
    },
    id: "elwx9pi2bkj2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp8idxxmeexb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,296.33a2.94,2.94,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a3,3,0,0,1-1.34-2.32C68.78,296.25,69.38,295.9,70.12,296.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "70.12px 297.875px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,299.6l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,301.61a.92.92,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      fill: "current",
      transformOrigin: "76.5026px 300.983px"
    },
    id: "elncoen4hd6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elroevul59i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,299.6l.71-.4h0a1,1,0,0,1,.94.1A3,3,0,0,1,78,301.61a.92.92,0,0,1-.4.86h0l-.65.37-.12-.2a1.2,1.2,0,0,1-.39-.15,2.93,2.93,0,0,1-1.33-2.31,1.29,1.29,0,0,1,0-.35Z",
    style: {
      opacity: 0.4,
      transformOrigin: "76.5026px 300.983px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,299.68A3,3,0,0,1,77.27,302c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,299.6,75.19,299.25,75.93,299.68Z",
    style: {
      fill: "current",
      transformOrigin: "75.93px 301.225px"
    },
    id: "el5ukuv9s0c15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljrlw95oxc0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.93,299.68A3,3,0,0,1,77.27,302c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.32C74.59,299.6,75.19,299.25,75.93,299.68Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.93px 301.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,250.33,84.2,225.77a4.07,4.07,0,0,0-3.69,0L38,250.33a4.13,4.13,0,0,0-1.85,3.2v11.21l46.27,26.7h0l46.21-26.7V253.53A4.13,4.13,0,0,0,126.77,250.33Z",
    style: {
      fill: "current",
      transformOrigin: "82.39px 258.384px"
    },
    id: "elfuyo5rakduu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4z5rnorf59q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.77,250.33,84.2,225.77a4.07,4.07,0,0,0-3.69,0L38,250.33a4.13,4.13,0,0,0-1.85,3.2v11.21l46.27,26.7h0l46.21-26.7V253.53A4.13,4.13,0,0,0,126.77,250.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "82.39px 258.384px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,277.46v14l-46.25-26.7V253.53a4.14,4.14,0,0,1,1.51-3c-.67.59-.56,1.38.34,1.9L80.56,277A3.82,3.82,0,0,0,82.4,277.46Z",
    style: {
      fill: "current",
      transformOrigin: "59.275px 270.995px"
    },
    id: "elfkskdj02z0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq2pbbj5gmh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4,277.46v14l-46.25-26.7V253.53a4.14,4.14,0,0,1,1.51-3c-.67.59-.56,1.38.34,1.9L80.56,277A3.82,3.82,0,0,0,82.4,277.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "59.275px 270.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,257.29,63.5,270.53A3.39,3.39,0,0,1,65,273.19v3.12c0,1-.69,1.38-1.54.89L40.58,264A3.39,3.39,0,0,1,39,261.3v-3.12C39,257.2,39.73,256.8,40.58,257.29Z",
    style: {
      fill: "current",
      transformOrigin: "52px 267.247px"
    },
    id: "elp7z5ozi0fbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,259.93v1.51A.66.66,0,0,0,41,262l.34.2c.18.1.31,0,.31-.17v-1.52a.66.66,0,0,0-.31-.53l-.34-.2C40.8,259.65,40.66,259.73,40.66,259.93Z",
    style: {
      fill: "current",
      transformOrigin: "41.155px 260.978px"
    },
    id: "elde12nvdsuj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,260.83v1.51a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.53l-.34-.2C42.35,260.55,42.22,260.63,42.22,260.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "42.7px 261.858px"
    },
    id: "eldf65lroiolr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,261.72v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C43.91,261.45,43.77,261.53,43.77,261.72Z",
    style: {
      fill: "current",
      transformOrigin: "44.255px 262.758px"
    },
    id: "el5gms958hbmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,262.62v1.51a.69.69,0,0,0,.31.54l.35.2c.17.09.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C45.47,262.34,45.33,262.42,45.33,262.62Z",
    style: {
      fill: "current",
      transformOrigin: "45.81px 263.651px"
    },
    id: "elvnpmgutznua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,263.52V265a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.34-.2C47,263.24,46.89,263.32,46.89,263.52Z",
    style: {
      fill: "current",
      transformOrigin: "47.37px 264.527px"
    },
    id: "elifknf211awr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,264.42v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18V265a.67.67,0,0,0-.31-.53l-.35-.2C48.58,264.14,48.44,264.22,48.44,264.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "48.925px 265.453px"
    },
    id: "el0zsa6rijef38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,265.31v1.51a.69.69,0,0,0,.31.54l.35.2c.17.1.3,0,.3-.18v-1.51a.65.65,0,0,0-.3-.53l-.35-.2C50.14,265,50,265.12,50,265.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "50.48px 266.339px"
    },
    id: "elcszcsz4s9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,266.21v1.51a.69.69,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C51.7,265.93,51.56,266,51.56,266.21Z",
    style: {
      fill: "current",
      transformOrigin: "52.04px 267.24px"
    },
    id: "elssvhqq8twor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,267.11v1.51a.66.66,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.35-.2C53.25,266.83,53.11,266.91,53.11,267.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "53.595px 268.138px"
    },
    id: "els9yv2fcehh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,268v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.66.66,0,0,0-.3-.53l-.35-.2C54.81,267.73,54.67,267.81,54.67,268Z",
    style: {
      fill: "current",
      transformOrigin: "55.15px 269.031px"
    },
    id: "ellllgyg67y1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,268.9v1.51a.69.69,0,0,0,.31.54l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.21C56.37,268.63,56.23,268.71,56.23,268.9Z",
    style: {
      fill: "current",
      transformOrigin: "56.71px 269.936px"
    },
    id: "eldr9rsgzju6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,269.8v1.51a.69.69,0,0,0,.31.54l.35.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C57.92,269.52,57.78,269.6,57.78,269.8Z",
    style: {
      fill: "current",
      transformOrigin: "58.265px 270.831px"
    },
    id: "el9wlplspnu1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,270.7v1.51a.67.67,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.17v-1.52a.68.68,0,0,0-.3-.53l-.35-.2C59.48,270.42,59.34,270.5,59.34,270.7Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "59.82px 271.728px"
    },
    id: "elm4mjeakug3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,271.6v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.53l-.34-.2C61,271.32,60.9,271.4,60.9,271.6Z",
    style: {
      fill: "current",
      transformOrigin: "61.38px 272.628px"
    },
    id: "elw5un439gbmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,272.49V274a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C62.59,272.22,62.45,272.3,62.45,272.49Z",
    style: {
      fill: "current",
      transformOrigin: "62.935px 273.526px"
    },
    id: "elokugz1b81e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg819jmtt0ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.66,259.93v1.51A.66.66,0,0,0,41,262l.34.2c.18.1.31,0,.31-.17v-1.52a.66.66,0,0,0-.31-.53l-.34-.2C40.8,259.65,40.66,259.73,40.66,259.93Z",
    style: {
      opacity: 0.2,
      transformOrigin: "41.155px 260.978px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellb9q75brdan"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.77,261.72v1.52a.69.69,0,0,0,.31.53l.35.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.35-.2C43.91,261.45,43.77,261.53,43.77,261.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "44.255px 262.758px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellyfx3ts273j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.33,262.62v1.51a.69.69,0,0,0,.31.54l.35.2c.17.09.3,0,.3-.18v-1.51a.68.68,0,0,0-.3-.54l-.35-.2C45.47,262.34,45.33,262.42,45.33,262.62Z",
    style: {
      opacity: 0.2,
      transformOrigin: "45.81px 263.651px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5rdisprx7tv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89,263.52V265a.66.66,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.17v-1.52a.69.69,0,0,0-.31-.53l-.34-.2C47,263.24,46.89,263.32,46.89,263.52Z",
    style: {
      opacity: 0.2,
      transformOrigin: "47.37px 264.527px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgtfz3wvsv95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.56,266.21v1.51a.69.69,0,0,0,.31.54l.34.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.34-.2C51.7,265.93,51.56,266,51.56,266.21Z",
    style: {
      opacity: 0.2,
      transformOrigin: "52.04px 267.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1epsstqi41z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.67,268v1.51a.69.69,0,0,0,.31.53l.35.2c.17.1.3,0,.3-.18v-1.51a.66.66,0,0,0-.3-.53l-.35-.2C54.81,267.73,54.67,267.81,54.67,268Z",
    style: {
      opacity: 0.2,
      transformOrigin: "55.15px 269.031px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eleoqtp5sfdkn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.23,268.9v1.51a.69.69,0,0,0,.31.54l.34.2c.17.1.31,0,.31-.18v-1.51a.66.66,0,0,0-.31-.53l-.34-.21C56.37,268.63,56.23,268.71,56.23,268.9Z",
    style: {
      opacity: 0.2,
      transformOrigin: "56.71px 269.936px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzxmmuv2a5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.78,269.8v1.51a.69.69,0,0,0,.31.54l.35.2c.17.09.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C57.92,269.52,57.78,269.6,57.78,269.8Z",
    style: {
      opacity: 0.2,
      transformOrigin: "58.265px 270.831px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2g80v2i4aai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9,271.6v1.51a.69.69,0,0,0,.31.53l.34.2c.17.1.31,0,.31-.18v-1.51a.67.67,0,0,0-.31-.53l-.34-.2C61,271.32,60.9,271.4,60.9,271.6Z",
    style: {
      opacity: 0.2,
      transformOrigin: "61.38px 272.628px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3iai72sbut2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.45,272.49V274a.69.69,0,0,0,.31.54l.35.2c.17.1.31,0,.31-.18v-1.51a.69.69,0,0,0-.31-.54l-.35-.2C62.59,272.22,62.45,272.3,62.45,272.49Z",
    style: {
      opacity: 0.2,
      transformOrigin: "62.935px 273.526px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38,252.46,80.56,277a4.09,4.09,0,0,0,3.7,0l42.51-24.56a1.12,1.12,0,0,0,0-2.13L84.2,225.77a4.07,4.07,0,0,0-3.69,0L38,250.33A1.12,1.12,0,0,0,38,252.46Z",
    style: {
      fill: "current",
      transformOrigin: "82.385px 251.385px"
    },
    id: "elafpv91qm7hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz6v4cdj6xf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,252.46,80.56,277a4.09,4.09,0,0,0,3.7,0l42.51-24.56a1.12,1.12,0,0,0,0-2.13L84.2,225.77a4.07,4.07,0,0,0-3.69,0L38,250.33A1.12,1.12,0,0,0,38,252.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      transformOrigin: "82.385px 251.385px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.92 271.42 41.92 268.08 82.38 291.44 82.38 294.77 41.92 271.42",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.15px 281.425px"
    },
    id: "elzwdnkhzixy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.72 266.41 125.72 269.75 82.38 294.77 82.38 291.44 125.72 266.41",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "104.05px 280.59px"
    },
    id: "el9so05j8rg6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,276.24l.71-.41h0a1,1,0,0,1,1,.09,3,3,0,0,1,1.33,2.32,1,1,0,0,1-.39.87h0l-.66.37-.11-.19a1.73,1.73,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.16,1.16,0,0,1,.05-.34Z",
    style: {
      fill: "current",
      transformOrigin: "70.6614px 277.608px"
    },
    id: "elew2lyglis7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp7epb4qk0r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.14,276.24l.71-.41h0a1,1,0,0,1,1,.09,3,3,0,0,1,1.33,2.32,1,1,0,0,1-.39.87h0l-.66.37-.11-.19a1.73,1.73,0,0,1-.39-.15,3,3,0,0,1-1.34-2.32,1.16,1.16,0,0,1,.05-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "70.6614px 277.608px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,276.31a3,3,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.31C68.78,276.23,69.38,275.89,70.12,276.31Z",
    style: {
      fill: "current",
      transformOrigin: "70.12px 277.857px"
    },
    id: "elid3n7wf5sk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela8yeeo806f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,276.31a3,3,0,0,1,1.34,2.32c0,.85-.6,1.2-1.34.77a2.94,2.94,0,0,1-1.34-2.31C68.78,276.23,69.38,275.89,70.12,276.31Z",
    style: {
      opacity: 0.2,
      transformOrigin: "70.12px 277.857px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,279.59l.71-.41h0a.92.92,0,0,1,.94.1A2.94,2.94,0,0,1,78,281.59a.93.93,0,0,1-.4.87h0l-.65.38-.12-.2a1.47,1.47,0,0,1-.39-.15,3,3,0,0,1-1.33-2.32,1.18,1.18,0,0,1,0-.34Z",
    style: {
      fill: "current",
      transformOrigin: "76.5028px 280.967px"
    },
    id: "elm0rih286ht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliaqdcssaq1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,279.59l.71-.41h0a.92.92,0,0,1,.94.1A2.94,2.94,0,0,1,78,281.59a.93.93,0,0,1-.4.87h0l-.65.38-.12-.2a1.47,1.47,0,0,1-.39-.15,3,3,0,0,1-1.33-2.32,1.18,1.18,0,0,1,0-.34Z",
    style: {
      opacity: 0.4,
      transformOrigin: "76.5028px 280.967px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,279.67A2.94,2.94,0,0,1,77.27,282c0,.86-.6,1.2-1.34.78a3,3,0,0,1-1.34-2.32C74.59,279.59,75.19,279.24,75.93,279.67Z",
    style: {
      fill: "current",
      transformOrigin: "75.93px 281.223px"
    },
    id: "elxdu55epyp5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elisme7yopdf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.93,279.67A2.94,2.94,0,0,1,77.27,282c0,.86-.6,1.2-1.34.78a3,3,0,0,1-1.34-2.32C74.59,279.59,75.19,279.24,75.93,279.67Z",
    style: {
      opacity: 0.2,
      transformOrigin: "75.93px 281.223px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "458.485px 266.465px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "458.485px 266.465px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.14,301.58l-11.25-6s-.86-17.2.48-30.83c1.89-19.15,16.13-41.39,30.88-36S459.49,253.73,454.7,270,446.14,301.58,446.14,301.58Z",
    style: {
      fill: "current",
      transformOrigin: "452.98px 264.755px"
    },
    id: "elba8n21zq457",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6u0xlo6jb67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.14,301.58l-11.25-6s-.86-17.2.48-30.83c1.89-19.15,16.13-41.39,30.88-36S459.49,253.73,454.7,270,446.14,301.58,446.14,301.58Z",
    style: {
      opacity: 0.1,
      transformOrigin: "452.98px 264.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.64,299.58h0a.5.5,0,0,0,.48-.52c-1.45-42.56,19.74-64,19.95-64.17a.5.5,0,1,0-.7-.71c-.21.21-21.71,21.93-20.25,64.92A.5.5,0,0,0,440.64,299.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.648px 266.794px"
    },
    id: "elgqhsp99ucc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.91,305l-5.85-3.38a65.33,65.33,0,0,1,3.64-28.39c5.42-14.71,19.42-22.72,25.86-20.53,7.87,2.67,7.92,10.2,5.06,15.16C477.24,273.66,456.16,288.43,451.91,305Z",
    style: {
      fill: "current",
      transformOrigin: "464.063px 278.671px"
    },
    id: "elaqhykd0j4ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,303.69h0a.51.51,0,0,0,.5-.5c-.12-26.91,25.15-45.1,25.4-45.28a.49.49,0,0,0,.12-.69.5.5,0,0,0-.69-.12c-.26.18-26,18.67-25.83,46.09A.5.5,0,0,0,448.83,303.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "461.636px 280.351px"
    },
    id: "elv8g47s9cod",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "280.884px 243.213px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "280.884px 243.213px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.92,356.49a11.35,11.35,0,0,0,5.29,8.79l115.3,66.58a11.69,11.69,0,0,0,10.59,0l203-117.21a9.95,9.95,0,0,0,0-17.59L333.82,230.48a11.76,11.76,0,0,0-10.59,0l-203,117.22A11.34,11.34,0,0,0,114.92,356.49Z",
    style: {
      fill: "current",
      transformOrigin: "284.658px 331.174px"
    },
    id: "eli3rqbqhvua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el21ud79kkozg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.41,305.85a11.36,11.36,0,0,1-5.29,8.8l-203,117.21a10.89,10.89,0,0,1-5.29,1.27V421.66a10.89,10.89,0,0,0,5.29-1.27l203-117.21c2.56-1.48,2.88-3.76,1-5.44A11.34,11.34,0,0,1,454.41,305.85Z",
    style: {
      opacity: 0.5,
      transformOrigin: "347.62px 365.436px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo9gm6v22qrk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.21,353.81l115.3,66.58a11.69,11.69,0,0,0,10.59,0l203-117.21c2.93-1.69,2.93-4.43,0-6.12L333.82,230.48a11.76,11.76,0,0,0-10.59,0l-203,117.22C117.29,349.38,117.29,352.12,120.21,353.81Z",
    style: {
      opacity: 0.3,
      transformOrigin: "284.66px 325.439px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elecnar1cl4iv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.8,421.66v11.46a10.7,10.7,0,0,1-5.29-1.26l-115.3-66.58a9.92,9.92,0,0,1-.54-17.24c-2.37,1.7-2.19,4.19.54,5.77l115.3,66.58A10.7,10.7,0,0,0,240.8,421.66Z",
    style: {
      opacity: 0.7,
      transformOrigin: "177.86px 390.581px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110,347.88c-2.74-1.58-2.59-4.25-2.59-7.63V181a11.71,11.71,0,0,1,5.29-9.17l203-117.21a11.33,11.33,0,0,1,10.26-.19c2.74,1.58,2.6,4.26,2.6,7.63V221.31a11.67,11.67,0,0,1-5.3,9.17l-203,117.22A11.36,11.36,0,0,1,110,347.88Z",
    style: {
      fill: "current",
      transformOrigin: "217.985px 201.156px"
    },
    id: "elmnpt8o38yc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2gzuge3nmfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.53,62.06c0-3.37-2.38-4.74-5.3-3.06l-203,117.22a10.75,10.75,0,0,0-3.74,4l-7.56-4.4h0a10.94,10.94,0,0,1,3.75-4l203-117.2a11.35,11.35,0,0,1,10.27-.19C328.67,56,328.53,58.69,328.53,62.06Z",
    style: {
      opacity: 0.3,
      transformOrigin: "218.731px 116.757px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0lcl5ccgmz0e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.92,185.39V344.64c0,3.37,2.37,4.74,5.29,3.06l203-117.22a11.67,11.67,0,0,0,5.3-9.17V62.06c0-3.37-2.37-4.74-5.3-3.05l-203,117.21A11.71,11.71,0,0,0,114.92,185.39Z",
    style: {
      opacity: 0.5,
      transformOrigin: "221.715px 203.352px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elq8lphmxa27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.59,348a11.38,11.38,0,0,1-9.64-.13c-2.74-1.58-2.59-4.25-2.59-7.63V181a10.74,10.74,0,0,1,1.55-5.21l7.56,4.37v0a10.87,10.87,0,0,0-1.55,5.2V344.64C114.92,347.77,117,349.18,119.59,348Z",
    style: {
      opacity: 0.7,
      transformOrigin: "113.474px 262.399px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.06,182.33l195.74-113c1.75-1,3.17-.19,3.17,1.83v139a7,7,0,0,1-3.17,5.5l-195.74,113c-1.75,1-3.18.19-3.18-1.84v-139A7,7,0,0,1,123.06,182.33Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "220.925px 198.995px"
    },
    id: "elr0ci08gmjmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkhy99o3whnn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.87,348l188.44-108.8a5.89,5.89,0,0,1,5.3,0l3.13,1.72c1.47.85,1.47,2.22,0,3.06L143.27,352.77a5.81,5.81,0,0,1-5.29,0l-3.11-1.71C133.41,350.22,133.41,348.85,134.87,348Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.3,
      transformOrigin: "233.309px 295.989px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrqe0hndl777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.65,356.8,338.09,248a5.41,5.41,0,0,1,4.84-.27L392,276.05c1.21.7,1,1.95-.46,2.8L203.3,387.5a5.47,5.47,0,0,1-4.85.27L149.2,359.58C148,358.89,148.19,357.64,149.65,356.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.3,
      transformOrigin: "270.6px 317.748px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.94,293.7l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A1,1,0,0,0,312.94,293.7Zm-8.62-11.79-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26A.94.94,0,0,0,304.32,281.91Zm-19.06,11-10,5.77c-.25.14-.27.37,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l10-5.76c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,285.26,292.91Zm10.44-6-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.92.92,0,0,0,295.7,286.89Zm-23.15,13.36-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0L279,304c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,272.55,300.25Zm-8.62,5-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A1,1,0,0,0,263.93,305.23Zm22.12,13.3,5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,286.05,318.53Zm-8.62,5,5.9-3.41c.25-.14.27-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,277.43,323.51Zm-8.62,5,5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A1,1,0,0,0,268.81,328.49Zm-8.63,5,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37,0,.49l5.65,3.26A.92.92,0,0,0,260.18,333.46Zm44.13-34.79,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,304.31,298.67Zm-9.63,14.88,13.16-7.6c.25-.14.27-.37.05-.49l-13.71-7.92a1,1,0,0,0-.86,0l-6.81,3.93c-.25.15-.27.37-.05.5l7.26,4.19c.22.12.2.35-.05.49l-5.45,3.14c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,294.68,313.55Zm-39.38-3.34-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.94.94,0,0,0,255.3,310.21Zm-8.62,5-5.9,3.4c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26A.94.94,0,0,0,246.68,315.19ZM199,368.34a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49ZM177.69,355l-5.9,3.4c-.25.15-.27.37,0,.5l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37,0-.49L178.55,355A.94.94,0,0,0,177.69,355Zm10.94,10a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.26.15-.28.37-.06.5Zm23.79,5.35,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A1,1,0,0,0,212.42,370.35Zm-9.48,5a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37,0,.5ZM186.32,350l-5.9,3.4c-.25.15-.28.37,0,.5L186,357.2a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49L187.17,350A.92.92,0,0,0,186.32,350Zm43.11-24.9-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25a.94.94,0,0,0,.85,0l5.91-3.41c.25-.15.27-.37.05-.5l-5.65-3.25A1,1,0,0,0,229.43,325.14Zm-34.49,19.92-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49L195.8,345A.94.94,0,0,0,194.94,345.06Zm43.12-24.89-5.9,3.4c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26A.92.92,0,0,0,238.06,320.17Zm-17.25,9.95-5.9,3.41c-.25.14-.27.37,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26A1,1,0,0,0,220.81,330.12Zm-8.62,5-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,212.19,335.1Zm-8.63,5-5.9,3.41c-.25.14-.27.36,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37,0-.5l-5.65-3.26A1,1,0,0,0,203.56,340.08Zm39.38,3.34,5.9-3.41c.25-.14.27-.36,0-.49l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36,0,.49l5.65,3.26A.94.94,0,0,0,242.94,343.42Zm80.44-72.52-5.9,3.41c-.25.14-.27.37-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26A1,1,0,0,0,323.38,270.9Zm-10.44,6-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.91-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A1,1,0,0,0,312.94,276.93Zm19.07-11-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.25a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25A.92.92,0,0,0,332,265.93ZM284.34,310.2l5.9-3.4c.25-.15.28-.37.05-.5L284.65,303a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.65,3.26A.92.92,0,0,0,284.34,310.2Zm57.15-49.28a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49Zm-89.93,77.52,5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,251.56,338.44Zm105.75-61.05,5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,357.31,277.39Zm-16.69.32,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A.94.94,0,0,0,340.62,277.71Zm8.93-12.14a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5Zm1.82-1.05,13.7,7.92a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-13.71-7.92a1,1,0,0,0-.85,0l-5.9,3.41C351.17,264.17,351.14,264.4,351.37,264.52Zm-19.92,11-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.92.92,0,0,0,331.45,275.56ZM266.55,313l-5.91,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L267.4,313A1,1,0,0,0,266.55,313Zm81.28-30.63a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.37.05-.49L349,275.21a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-72.66,25.65-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5L276,308A1,1,0,0,0,275.17,308.05Zm-67.58,55.31a.94.94,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37,0-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5Zm-10-10.5-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26A.94.94,0,0,0,197.56,352.86Zm19.51,5.5L223,355c.25-.14.27-.37.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,217.07,358.36Zm8.62-5,5.9-3.41c.25-.14.27-.36,0-.49L226,346.22a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,225.69,353.38Zm8.62-5,5.9-3.41c.25-.14.28-.36,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26A1,1,0,0,0,234.31,348.4Zm-28.13-.52-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5L207,347.85A1,1,0,0,0,206.18,347.88Zm8.63-5-5.9,3.41c-.26.14-.28.36-.06.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26A1,1,0,0,0,214.81,342.9ZM249.3,323l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L250.16,323A.94.94,0,0,0,249.3,323Zm-8.63,5-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26A.94.94,0,0,0,240.67,328Zm17.25-10-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49L258.78,318A.94.94,0,0,0,257.92,318Zm-34.49,19.91-5.9,3.41c-.25.14-.28.37-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,223.43,337.92Zm8.62-5-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.25A1,1,0,0,0,232.05,332.94Zm-11,32.43,5.9-3.41c.26-.14.28-.36.06-.49l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26A.92.92,0,0,0,221,365.37Zm-45.47-2.14L169.93,360a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41C175.77,363.58,175.8,363.35,175.57,363.23Zm11.24,2.82-5.64-3.26a.94.94,0,0,0-.86,0l-9.08,5.24c-.25.14-.27.36,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l9.07-5.24C187,366.4,187,366.17,186.81,366.05Zm-19.66-9.26-5.65-3.26a.92.92,0,0,0-.85,0l-7.27,4.19c-.25.15-.27.37,0,.5l5.65,3.26a1,1,0,0,0,.86,0l7.26-4.2C167.35,357.14,167.37,356.92,167.15,356.79Zm5.57-3.22a.94.94,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5Zm24.43,15.82-5.65-3.26a1,1,0,0,0-.85,0l-11.35,6.55c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l11.35-6.55C197.35,369.74,197.37,369.52,197.15,369.39Zm4,7-5.65-3.26a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.14-.27.37-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l7.27-4.19C201.33,376.76,201.35,376.53,201.13,376.41Zm35.7-59.85a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49L238,309.37a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm-17.25,9.95a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37,0-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5ZM181.34,348.6a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm46.87-27.06a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.37,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5ZM211,331.49a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.37-.05.49Zm-5.6,45.26a1,1,0,0,0-.86,0L195.43,382c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l9.07-5.24c.26-.15.28-.37.05-.5Zm-6.78-38.11a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-8.62,5a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm175.16-59.1a.94.94,0,0,0-.86,0l-14.52,8.38c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l14.52-8.39c.25-.14.28-.36.05-.49Zm-19.06,11a1,1,0,0,0-.86,0L339.3,299c-.25.14-.27.37-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5ZM229.67,360.39l5.9-3.4c.25-.15.27-.37.05-.5L230,353.23a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,229.67,360.39Zm99.14-54.91a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49Zm44.93-25.94a.94.94,0,0,0-.86,0L367,283c-.25.14-.27.36-.05.49l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49ZM388,277.82,374.3,269.9a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l13.71,7.91a.94.94,0,0,0,.86,0l5.9-3.41C388.21,278.17,388.23,278,388,277.82Zm-91.42,46.27a1,1,0,0,0-.86,0l-7.26,4.2c-.25.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l7.26-4.19c.25-.15.27-.37.05-.5Zm21.78-12.58a.94.94,0,0,0-.86,0l-9.07,5.24c-.25.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l9.08-5.24c.25-.14.27-.36,0-.49Zm-41.75,24.1a1,1,0,0,0-.86,0l-48.56,28c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l48.56-28c.25-.15.27-.37.05-.5Zm-51.29,29.61a1,1,0,0,0-.86,0l-7.26,4.2c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l7.26-4.19c.25-.15.28-.37.05-.5Zm61.27-35.37a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l7.26-4.2c.26-.14.28-.36.06-.49ZM215.35,371a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l7.26-4.2c.25-.14.27-.36.05-.49Zm91.22-52.67a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l7.26-4.2c.26-.14.28-.36.06-.49Zm30.86-17.82a1,1,0,0,0-.85,0l-5.9,3.41c-.26.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5ZM356.75,287l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,356.75,287Zm-35.19,1.7,5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,321.56,288.72Zm-22.91,31.84,17.25-9.95c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-17.25,10c-.25.14-.27.36-.05.49l5.65,3.26A.92.92,0,0,0,298.65,320.56ZM347.27,292a.92.92,0,0,0,.85,0l5.9-3.4c.26-.15.28-.37.06-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49Zm-7.21-4.68,5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.64,3.26A1,1,0,0,0,340.06,287.35Zm-50,38.19,5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A.94.94,0,0,0,290,325.54ZM328.21,303a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-81.3,47.4,5.91-3.41c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A.94.94,0,0,0,246.91,350.44Zm8.63-5,5.9-3.41c.25-.15.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,255.54,345.46Zm-17.25,10,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,238.29,355.41Zm34.49-19.91,5.9-3.41c.26-.14.28-.36.06-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,272.78,335.5Zm-8.62,5,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37,0,.5l5.64,3.26A1,1,0,0,0,264.16,340.48Zm17.25-10,5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0L275,326.8c-.25.14-.28.36,0,.49l5.64,3.26A.94.94,0,0,0,281.41,330.52Zm47.06-69.26a.92.92,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36,0-.49l-1.5-.87a1,1,0,0,0-.86,0L327,259.9c-.25.14-.27.36-.05.49ZM285.6,288.4a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm17.25-10a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L304,271.25a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49Zm-27.78,16a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm19.16-11.06a1,1,0,0,0,.86,0L301,280c.25-.14.27-.36.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-36.4,21a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5L259,297.24a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37,0,.5Zm8.62-5a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm44.77-28.24a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-1.51-.87a.92.92,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36,0,.49Zm25.87-14.94a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37,0-.5l-1.51-.87a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.37-.05.49ZM349,263.13a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5ZM365.37,282l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,365.37,282Zm-45.53-15.8a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-1.5-.87a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49ZM249.2,309.41a.94.94,0,0,0,.86,0L256,306c.25-.15.28-.37,0-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49Z",
    style: {
      fill: "current",
      transformOrigin: "270.678px 318.576px"
    },
    id: "el7mg7ukmqeqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk19c6lne39m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.94,293.7l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A1,1,0,0,0,312.94,293.7Zm-8.62-11.79-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26A.94.94,0,0,0,304.32,281.91Zm-19.06,11-10,5.77c-.25.14-.27.37,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l10-5.76c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,285.26,292.91Zm10.44-6-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.92.92,0,0,0,295.7,286.89Zm-23.15,13.36-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0L279,304c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,272.55,300.25Zm-8.62,5-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A1,1,0,0,0,263.93,305.23Zm22.12,13.3,5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,286.05,318.53Zm-8.62,5,5.9-3.41c.25-.14.27-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,277.43,323.51Zm-8.62,5,5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A1,1,0,0,0,268.81,328.49Zm-8.63,5,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37,0,.49l5.65,3.26A.92.92,0,0,0,260.18,333.46Zm44.13-34.79,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,304.31,298.67Zm-9.63,14.88,13.16-7.6c.25-.14.27-.37.05-.49l-13.71-7.92a1,1,0,0,0-.86,0l-6.81,3.93c-.25.15-.27.37-.05.5l7.26,4.19c.22.12.2.35-.05.49l-5.45,3.14c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,294.68,313.55Zm-39.38-3.34-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.94.94,0,0,0,255.3,310.21Zm-8.62,5-5.9,3.4c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26A.94.94,0,0,0,246.68,315.19ZM199,368.34a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49ZM177.69,355l-5.9,3.4c-.25.15-.27.37,0,.5l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37,0-.49L178.55,355A.94.94,0,0,0,177.69,355Zm10.94,10a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.26.15-.28.37-.06.5Zm23.79,5.35,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A1,1,0,0,0,212.42,370.35Zm-9.48,5a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37,0,.5ZM186.32,350l-5.9,3.4c-.25.15-.28.37,0,.5L186,357.2a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49L187.17,350A.92.92,0,0,0,186.32,350Zm43.11-24.9-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25a.94.94,0,0,0,.85,0l5.91-3.41c.25-.15.27-.37.05-.5l-5.65-3.25A1,1,0,0,0,229.43,325.14Zm-34.49,19.92-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49L195.8,345A.94.94,0,0,0,194.94,345.06Zm43.12-24.89-5.9,3.4c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26A.92.92,0,0,0,238.06,320.17Zm-17.25,9.95-5.9,3.41c-.25.14-.27.37,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26A1,1,0,0,0,220.81,330.12Zm-8.62,5-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,212.19,335.1Zm-8.63,5-5.9,3.41c-.25.14-.27.36,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37,0-.5l-5.65-3.26A1,1,0,0,0,203.56,340.08Zm39.38,3.34,5.9-3.41c.25-.14.27-.36,0-.49l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36,0,.49l5.65,3.26A.94.94,0,0,0,242.94,343.42Zm80.44-72.52-5.9,3.41c-.25.14-.27.37-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26A1,1,0,0,0,323.38,270.9Zm-10.44,6-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.91-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A1,1,0,0,0,312.94,276.93Zm19.07-11-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.25a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25A.92.92,0,0,0,332,265.93ZM284.34,310.2l5.9-3.4c.25-.15.28-.37.05-.5L284.65,303a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.65,3.26A.92.92,0,0,0,284.34,310.2Zm57.15-49.28a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49Zm-89.93,77.52,5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,251.56,338.44Zm105.75-61.05,5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,357.31,277.39Zm-16.69.32,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A.94.94,0,0,0,340.62,277.71Zm8.93-12.14a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5Zm1.82-1.05,13.7,7.92a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-13.71-7.92a1,1,0,0,0-.85,0l-5.9,3.41C351.17,264.17,351.14,264.4,351.37,264.52Zm-19.92,11-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26A.92.92,0,0,0,331.45,275.56ZM266.55,313l-5.91,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L267.4,313A1,1,0,0,0,266.55,313Zm81.28-30.63a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.37.05-.49L349,275.21a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-72.66,25.65-5.9,3.41c-.25.14-.28.36,0,.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5L276,308A1,1,0,0,0,275.17,308.05Zm-67.58,55.31a.94.94,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37,0-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5Zm-10-10.5-5.9,3.41c-.25.14-.27.36,0,.49l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26A.94.94,0,0,0,197.56,352.86Zm19.51,5.5L223,355c.25-.14.27-.37.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,217.07,358.36Zm8.62-5,5.9-3.41c.25-.14.27-.36,0-.49L226,346.22a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,225.69,353.38Zm8.62-5,5.9-3.41c.25-.14.28-.36,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26A1,1,0,0,0,234.31,348.4Zm-28.13-.52-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.4c.25-.15.28-.37.05-.5L207,347.85A1,1,0,0,0,206.18,347.88Zm8.63-5-5.9,3.41c-.26.14-.28.36-.06.49l5.65,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26A1,1,0,0,0,214.81,342.9ZM249.3,323l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L250.16,323A.94.94,0,0,0,249.3,323Zm-8.63,5-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26A.94.94,0,0,0,240.67,328Zm17.25-10-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49L258.78,318A.94.94,0,0,0,257.92,318Zm-34.49,19.91-5.9,3.41c-.25.14-.28.37-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26A1,1,0,0,0,223.43,337.92Zm8.62-5-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.25A1,1,0,0,0,232.05,332.94Zm-11,32.43,5.9-3.41c.26-.14.28-.36.06-.49l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26A.92.92,0,0,0,221,365.37Zm-45.47-2.14L169.93,360a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l5.9-3.41C175.77,363.58,175.8,363.35,175.57,363.23Zm11.24,2.82-5.64-3.26a.94.94,0,0,0-.86,0l-9.08,5.24c-.25.14-.27.36,0,.49l5.65,3.26a.94.94,0,0,0,.86,0l9.07-5.24C187,366.4,187,366.17,186.81,366.05Zm-19.66-9.26-5.65-3.26a.92.92,0,0,0-.85,0l-7.27,4.19c-.25.15-.27.37,0,.5l5.65,3.26a1,1,0,0,0,.86,0l7.26-4.2C167.35,357.14,167.37,356.92,167.15,356.79Zm5.57-3.22a.94.94,0,0,0,.85,0l5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5Zm24.43,15.82-5.65-3.26a1,1,0,0,0-.85,0l-11.35,6.55c-.25.15-.27.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l11.35-6.55C197.35,369.74,197.37,369.52,197.15,369.39Zm4,7-5.65-3.26a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.14-.27.37-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l7.27-4.19C201.33,376.76,201.35,376.53,201.13,376.41Zm35.7-59.85a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49L238,309.37a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm-17.25,9.95a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37,0-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5ZM181.34,348.6a1,1,0,0,0,.85,0l5.91-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm46.87-27.06a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.37,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5ZM211,331.49a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.37-.05.49Zm-5.6,45.26a1,1,0,0,0-.86,0L195.43,382c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l9.07-5.24c.26-.15.28-.37.05-.5Zm-6.78-38.11a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-8.62,5a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm175.16-59.1a.94.94,0,0,0-.86,0l-14.52,8.38c-.25.15-.28.37-.05.5l5.64,3.26a1,1,0,0,0,.86,0l14.52-8.39c.25-.14.28-.36.05-.49Zm-19.06,11a1,1,0,0,0-.86,0L339.3,299c-.25.14-.27.37-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5ZM229.67,360.39l5.9-3.4c.25-.15.27-.37.05-.5L230,353.23a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,229.67,360.39Zm99.14-54.91a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49Zm44.93-25.94a.94.94,0,0,0-.86,0L367,283c-.25.14-.27.36-.05.49l5.65,3.26a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49ZM388,277.82,374.3,269.9a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l13.71,7.91a.94.94,0,0,0,.86,0l5.9-3.41C388.21,278.17,388.23,278,388,277.82Zm-91.42,46.27a1,1,0,0,0-.86,0l-7.26,4.2c-.25.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l7.26-4.19c.25-.15.27-.37.05-.5Zm21.78-12.58a.94.94,0,0,0-.86,0l-9.07,5.24c-.25.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l9.08-5.24c.25-.14.27-.36,0-.49Zm-41.75,24.1a1,1,0,0,0-.86,0l-48.56,28c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l48.56-28c.25-.15.27-.37.05-.5Zm-51.29,29.61a1,1,0,0,0-.86,0l-7.26,4.2c-.25.14-.27.36-.05.49l5.65,3.26a.92.92,0,0,0,.85,0l7.26-4.19c.25-.15.28-.37.05-.5Zm61.27-35.37a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l7.26-4.2c.26-.14.28-.36.06-.49ZM215.35,371a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.28.37,0,.5l5.64,3.26a1,1,0,0,0,.86,0l7.26-4.2c.25-.14.27-.36.05-.49Zm91.22-52.67a.94.94,0,0,0-.86,0l-7.26,4.19c-.25.15-.27.37-.05.5l5.65,3.26a1,1,0,0,0,.85,0l7.26-4.2c.26-.14.28-.36.06-.49Zm30.86-17.82a1,1,0,0,0-.85,0l-5.9,3.41c-.26.14-.28.36-.05.49l5.64,3.26a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5ZM356.75,287l5.9-3.4c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49l5.64,3.26A.94.94,0,0,0,356.75,287Zm-35.19,1.7,5.9-3.41c.25-.14.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,321.56,288.72Zm-22.91,31.84,17.25-9.95c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-17.25,10c-.25.14-.27.36-.05.49l5.65,3.26A.92.92,0,0,0,298.65,320.56ZM347.27,292a.92.92,0,0,0,.85,0l5.9-3.4c.26-.15.28-.37.06-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49Zm-7.21-4.68,5.9-3.41c.25-.15.28-.37.05-.5l-5.64-3.25a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.64,3.26A1,1,0,0,0,340.06,287.35Zm-50,38.19,5.9-3.4c.25-.15.27-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49l5.64,3.26A.94.94,0,0,0,290,325.54ZM328.21,303a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-81.3,47.4,5.91-3.41c.25-.15.27-.37.05-.5l-5.65-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37-.05.5l5.65,3.25A.94.94,0,0,0,246.91,350.44Zm8.63-5,5.9-3.41c.25-.15.27-.37.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5l5.64,3.26A1,1,0,0,0,255.54,345.46Zm-17.25,10,5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,238.29,355.41Zm34.49-19.91,5.9-3.41c.26-.14.28-.36.06-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5l5.65,3.26A1,1,0,0,0,272.78,335.5Zm-8.62,5,5.9-3.41c.25-.14.27-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37,0,.5l5.64,3.26A1,1,0,0,0,264.16,340.48Zm17.25-10,5.9-3.41c.25-.14.27-.36.05-.49l-5.65-3.26a.92.92,0,0,0-.85,0L275,326.8c-.25.14-.28.36,0,.49l5.64,3.26A.94.94,0,0,0,281.41,330.52Zm47.06-69.26a.92.92,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36,0-.49l-1.5-.87a1,1,0,0,0-.86,0L327,259.9c-.25.14-.27.36-.05.49ZM285.6,288.4a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm17.25-10a.94.94,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36.05-.49L304,271.25a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36-.05.49Zm-27.78,16a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.28-.37.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm19.16-11.06a1,1,0,0,0,.86,0L301,280c.25-.14.27-.36.05-.49l-5.65-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5Zm-36.4,21a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37.05-.5L259,297.24a1,1,0,0,0-.86,0l-5.9,3.41c-.25.15-.27.37,0,.5Zm8.62-5a1,1,0,0,0,.86,0l5.9-3.41c.25-.15.27-.37.05-.5l-5.65-3.25a.92.92,0,0,0-.85,0l-5.9,3.4c-.25.15-.28.37-.05.5Zm44.77-28.24a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-1.51-.87a.92.92,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.36,0,.49Zm25.87-14.94a.94.94,0,0,0,.86,0l5.9-3.4c.25-.15.27-.37,0-.5l-1.51-.87a1,1,0,0,0-.85,0l-5.9,3.41c-.25.14-.28.37-.05.49ZM349,263.13a1,1,0,0,0,.85,0l5.9-3.41c.25-.14.28-.36.05-.49l-5.64-3.26a.94.94,0,0,0-.86,0l-5.9,3.4c-.25.15-.27.37-.05.5ZM365.37,282l5.9-3.4c.25-.15.28-.37.05-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.37-.05.49l5.64,3.26A.94.94,0,0,0,365.37,282Zm-45.53-15.8a1,1,0,0,0,.86,0l5.9-3.41c.25-.14.27-.36,0-.49l-1.5-.87a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49ZM249.2,309.41a.94.94,0,0,0,.86,0L256,306c.25-.15.28-.37,0-.5l-5.64-3.26a1,1,0,0,0-.86,0l-5.9,3.41c-.25.14-.27.36-.05.49Z",
    style: {
      opacity: 0.1,
      transformOrigin: "270.678px 318.576px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj8swq79c8ac"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "274.72 353.89 275.93 354.58 308.07 373.13 365.21 340.14 366.4 339.46 333.06 320.22 274.72 353.89",
    style: {
      opacity: 0.4,
      transformOrigin: "320.56px 346.675px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 354.58 308.07 373.13 365.21 340.14 333.06 321.59 275.93 354.58",
    style: {
      fill: "current",
      transformOrigin: "320.57px 347.36px"
    },
    id: "el82mbuvlr3hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltv01n0s4ub"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 354.58 308.07 373.13 365.21 340.14 333.06 321.59 275.93 354.58",
    style: {
      opacity: 0.45,
      transformOrigin: "320.57px 347.36px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110,347.88a8,8,0,0,0,1.63.69,7.45,7.45,0,0,1-1.63-.68,5.39,5.39,0,0,1-.5-.33Z",
    style: {
      fill: "current",
      transformOrigin: "110.565px 348.065px"
    },
    id: "elvt9d2jxj6zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,348.38s0-.05.08-.08l-.06.06Z",
    style: {
      fill: "current",
      transformOrigin: "119.26px 348.34px"
    },
    id: "el1yjwrxmr4x5",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "242.405px 208.5px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "242.405px 208.5px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "242.405px 208.5px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elcsc1fbfppr5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "244.375px 209.627px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.48,74.37a1.35,1.35,0,0,0-.05-.29.07.07,0,0,0,0-.06,1.07,1.07,0,0,0-.07-.27,1.18,1.18,0,0,0-.19-.39,1.1,1.1,0,0,0-.19-.28,1,1,0,0,0-.2-.2l0,0a1.35,1.35,0,0,0-.26-.15,2.24,2.24,0,0,0-2.08.26L142.33,190.74a6.84,6.84,0,0,0-3.08,5.35v148.4a2.1,2.1,0,0,0,1.11,1.86l.13.08.16.1a1.22,1.22,0,0,0,.27.09,1.74,1.74,0,0,0,.39.05,1.91,1.91,0,0,0,1-.3l.08,0h0l2.94-1.69L346.41,228.55a6.82,6.82,0,0,0,3.09-5.34V74.75C349.5,74.62,349.49,74.49,349.48,74.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "244.375px 209.627px"
    },
    id: "elirn565crp2g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,72.71a2.24,2.24,0,0,0-2.08.26L142.33,190.74a6.84,6.84,0,0,0-3.08,5.35v10.08l-3.94-2.31v-10a6.81,6.81,0,0,1,3.08-5.33L342.48,70.74a2.16,2.16,0,0,1,2.23-.18C345.27,70.9,347.83,72.36,348.49,72.71Z",
    style: {
      fill: "current",
      transformOrigin: "241.9px 138.251px"
    },
    id: "ellci8ejxckke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.49,74.73c0-2-1.38-2.73-3.08-1.76L142.33,190.75a6.81,6.81,0,0,0-3.08,5.34v10.08L349.49,84.85Z",
    style: {
      fill: "current",
      transformOrigin: "244.37px 139.357px"
    },
    id: "elw6vyyzt60d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld9491vs9bln"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "242.365px 131.68px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.41,73,142.33,190.75a6.36,6.36,0,0,0-2.17,2.28l-3.91-2.26a6.22,6.22,0,0,1,2.14-2.26L342.47,70.74a2.17,2.17,0,0,1,2.24-.18c.56.34,3.12,1.79,3.77,2.14A2.26,2.26,0,0,0,346.41,73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "242.365px 131.68px"
    },
    id: "elxp3jvy3kdmn",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el47ebmxr0ey8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.31,203.87v-10a6.23,6.23,0,0,1,.94-3.08l3.92,2.25a6.27,6.27,0,0,0-.92,3.07v10.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "137.74px 198.49px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,86.21a4.6,4.6,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.56,4.56,0,0,0,1.75-3.68C332.67,86.4,331.89,85.65,330.92,86.21Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "330.925px 88.8901px"
    },
    id: "elulcqiiqc0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,82.58a4.61,4.61,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.68a4.59,4.59,0,0,0,1.75-3.69C338.94,82.78,338.16,82,337.19,82.58Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "337.195px 85.2589px"
    },
    id: "el94uckzc3nhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,79a4.59,4.59,0,0,0-1.75,3.69c0,1.48.78,2.23,1.75,1.68a4.61,4.61,0,0,0,1.74-3.69C345.21,79.15,344.43,78.4,343.47,79Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "343.465px 81.6718px"
    },
    id: "el3gwh9vth7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elln6g3kzce9g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.36,346.36l-.16-.09L137,344.39a3.27,3.27,0,0,1-1.61-2.39,3.4,3.4,0,0,1,0-.45V203.86l3.94,2.31V344.49a2,2,0,0,0,1,1.75l.1.07,0,0Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.9,
      transformOrigin: "137.906px 275.11px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "243.435px 225.433px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.89,184a1.28,1.28,0,0,1,.15-.57l2.22-4.59a.38.38,0,0,1,.1-.13l.06,0a.14.14,0,0,1,.17,0,.28.28,0,0,1,.07.22v1.54a2.09,2.09,0,0,1,0,.48,2.06,2.06,0,0,1-.16.42l-1.17,2.42,1.17,1.08a.57.57,0,0,1,.16.23,1.51,1.51,0,0,1,0,.43V187a.7.7,0,0,1-.07.31.47.47,0,0,1-.17.21l-.06,0a.13.13,0,0,1-.1,0l-2.22-2a.47.47,0,0,1-.15-.39Z",
    style: {
      fill: "current",
      transformOrigin: "201.282px 183.106px"
    },
    id: "ellc73wwjm6e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,172.45a2.75,2.75,0,0,1,.17-.45.86.86,0,0,1,.33-.35l.83-.48a.14.14,0,0,1,.18,0,.32.32,0,0,1,.07.22,1.11,1.11,0,0,1,0,.17l-3.81,16.2a1.76,1.76,0,0,1-.15.44.87.87,0,0,1-.34.37l-.8.46a.13.13,0,0,1-.17,0,.32.32,0,0,1-.08-.23.61.61,0,0,1,0-.17Z",
    style: {
      fill: "current",
      transformOrigin: "206.904px 180.099px"
    },
    id: "eln1nvh7egolc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,177a1.32,1.32,0,0,1-.15.58l-2.22,4.58a.46.46,0,0,1-.1.14l-.05,0a.15.15,0,0,1-.18,0,.32.32,0,0,1-.07-.23v-1.54a2.09,2.09,0,0,1,0-.48,2.89,2.89,0,0,1,.16-.42l1.17-2.42-1.17-1.07a.84.84,0,0,1-.16-.24,1.51,1.51,0,0,1,0-.43V174a.73.73,0,0,1,.07-.31.48.48,0,0,1,.18-.21l.05,0a.12.12,0,0,1,.1,0l2.22,2a.48.48,0,0,1,.15.4Z",
    style: {
      fill: "current",
      transformOrigin: "212.479px 177.9px"
    },
    id: "elcrrx5isnodl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,176a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.69a.85.85,0,0,1-.09.38.61.61,0,0,1-.21.27l-1,.6a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28v-1.7a.92.92,0,0,1,.09-.38.57.57,0,0,1,.21-.26Z",
    style: {
      fill: "current",
      transformOrigin: "219.5px 177.608px"
    },
    id: "eldfb6ecjilq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,173.94a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.69a.92.92,0,0,1-.09.39.63.63,0,0,1-.21.26l-1,.6a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28v-1.7a.92.92,0,0,1,.09-.38.63.63,0,0,1,.21-.26Z",
    style: {
      fill: "current",
      transformOrigin: "223.04px 175.548px"
    },
    id: "el12hs2hve83l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,171.92a.18.18,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.7a.92.92,0,0,1-.09.38.73.73,0,0,1-.22.26l-1,.6a.18.18,0,0,1-.22,0,.38.38,0,0,1-.09-.28v-1.7a.92.92,0,0,1,.09-.38.58.58,0,0,1,.22-.26Z",
    style: {
      fill: "current",
      transformOrigin: "226.5px 173.53px"
    },
    id: "elcnyihn7mbgj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,196.33l43-24.89c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-43,24.89c-.61.35-1.1.1-1.1-.56A2.33,2.33,0,0,1,200.82,196.33Z",
    style: {
      fill: "current",
      transformOrigin: "222.315px 185.07px"
    },
    id: "el9t07m8fd3ri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,215.31l117-67.61c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-117,67.61c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,217.26,215.31Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "275.765px 182.69px"
    },
    id: "elgdngztxdizo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,224.8l16.31-9.45c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-16.31,9.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,217.26,224.8Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "225.42px 221.265px"
    },
    id: "eltmcz3ulngy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,234.3l16.31-9.46c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-16.31,9.45c-.6.35-1.09.1-1.09-.56A2.33,2.33,0,0,1,217.26,234.3Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "225.42px 230.755px"
    },
    id: "elbek0ij93wcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.09,169l94.36-54.56c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-94.36,54.56c-.6.35-1.09.1-1.09-.56A2.33,2.33,0,0,1,248.09,169Z",
    style: {
      fill: "current",
      transformOrigin: "295.275px 142.905px"
    },
    id: "eldvc5gzdlf0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.62,291l26.23-15.12c.6-.34,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-26.23,15.11c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,217.62,291Z",
    style: {
      fill: "current",
      transformOrigin: "230.73px 284.627px"
    },
    id: "elvht8fb4r5cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.09,273.39l94.36-54.55c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-94.36,54.56c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,248.09,273.39Z",
    style: {
      fill: "current",
      transformOrigin: "295.275px 247.303px"
    },
    id: "elweua7u6mn2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.09,245l94.36-54.56c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-94.36,54.56c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,248.09,245Z",
    style: {
      fill: "current",
      transformOrigin: "295.275px 218.905px"
    },
    id: "eljueqevrccb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.09,254.46l94.36-54.56c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-94.36,54.56c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,248.09,254.46Z",
    style: {
      fill: "current",
      transformOrigin: "295.275px 228.365px"
    },
    id: "el6qzyuolerud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.62,281.47l26.23-15.11c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-26.23,15.11c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,217.62,281.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "230.73px 275.105px"
    },
    id: "elb3mbpxttmre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,250.29l3.25-1.92c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3.25,1.92c-.6.35-1.09.11-1.09-.55A2.37,2.37,0,0,1,238.9,250.29Z",
    style: {
      fill: "current",
      transformOrigin: "240.53px 250.516px"
    },
    id: "eldrjqyhsdyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,205.84l21.67-12.57c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-21.67,12.57c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,205.84Z",
    style: {
      fill: "current",
      transformOrigin: "211.655px 200.74px"
    },
    id: "el1llq11ljoa9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgheofbpx22k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.82,205.84l21.67-12.57c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-21.67,12.57c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,205.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "211.655px 200.74px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,215.31,211,209.45c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,200.82,215.31Z",
    style: {
      fill: "current",
      transformOrigin: "205.925px 213.57px"
    },
    id: "el9mk90xavo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7gieakfmgdi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.82,215.31,211,209.45c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,200.82,215.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "205.925px 213.57px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,224.81,211,218.94c.6-.34,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,224.81Z",
    style: {
      fill: "current",
      transformOrigin: "205.925px 223.062px"
    },
    id: "eljl0g4rce14m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkyv5n47bjt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.82,224.81,211,218.94c.6-.34,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,224.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "205.925px 223.062px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,234.3,211,228.44c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,234.3Z",
    style: {
      fill: "current",
      transformOrigin: "205.925px 232.555px"
    },
    id: "eliz4uvkldonb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmgokdt7w0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.82,234.3,211,228.44c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,234.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "205.925px 232.555px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,243.79,211,237.93c.6-.35,1.09-.1,1.09.55A2.35,2.35,0,0,1,211,240.3l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,243.79Z",
    style: {
      fill: "current",
      transformOrigin: "205.925px 242.045px"
    },
    id: "elpwo0tytzg29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9tu2actrw56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.82,243.79,211,237.93c.6-.35,1.09-.1,1.09.55A2.35,2.35,0,0,1,211,240.3l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,200.82,243.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "205.925px 242.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,190.82l13-7.48c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-13,7.48c-.61.35-1.1.1-1.1-.56A2.33,2.33,0,0,1,226.74,190.82Z",
    style: {
      fill: "current",
      transformOrigin: "233.235px 188.264px"
    },
    id: "el7t87mxskwiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh2emwjxqw0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.74,190.82l13-7.48c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-13,7.48c-.61.35-1.1.1-1.1-.56A2.33,2.33,0,0,1,226.74,190.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "233.235px 188.264px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,236.23l95.61-55.3c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82L246.84,238.6c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,246.84,236.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.645px 209.765px"
    },
    id: "elwq5nobt29s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,178.91l13-7.48c.61-.35,1.1-.11,1.1.55a2.35,2.35,0,0,1-1.1,1.82l-13,7.48c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,329.46,178.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "335.96px 176.354px"
    },
    id: "el0ft988clhgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.59,236.65l95.62-55.29c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82L229.59,239c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,229.59,236.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "277.405px 210.18px"
    },
    id: "el6m3263blef8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,205.82l21.67-12.57c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82L217.26,208.2c-.6.34-1.09.1-1.1-.56A2.38,2.38,0,0,1,217.26,205.82Z",
    style: {
      fill: "current",
      transformOrigin: "228.095px 200.723px"
    },
    id: "el0a6lirgwhd2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5gdenhgri92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.26,205.82l21.67-12.57c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82L217.26,208.2c-.6.34-1.09.1-1.1-.56A2.38,2.38,0,0,1,217.26,205.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "228.095px 200.723px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,190.8l86.94-50.21c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-86.94,50.2c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,243.18,190.8Z",
    style: {
      fill: "current",
      transformOrigin: "286.65px 166.88px"
    },
    id: "eldtdnw0go9u5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elstxmookgnf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.18,190.8l86.94-50.21c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-86.94,50.2c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,243.18,190.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "286.65px 166.88px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldhr1tov8su8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "188.005px 256.802px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185,203.48l6-3.44c.6-.35,1.09-.07,1.09.62v2.19a2.41,2.41,0,0,1-1.09,1.88l-6,3.44c-.59.34-1.08.06-1.08-.63v-2.19A2.39,2.39,0,0,1,185,203.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 204.102px"
    },
    id: "elhxc1hm5s9l5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,213.06l6-3.44c.6-.35,1.09-.07,1.09.62v2.2a2.38,2.38,0,0,1-1.09,1.87l-6,3.44c-.59.35-1.08.07-1.08-.62v-2.19A2.41,2.41,0,0,1,185,213.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 213.685px"
    },
    id: "eljejs0sd2xek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,222.64l6-3.44c.6-.34,1.09-.06,1.09.63V222a2.38,2.38,0,0,1-1.09,1.87l-6,3.44c-.59.35-1.08.07-1.08-.62v-2.19A2.43,2.43,0,0,1,185,222.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 223.258px"
    },
    id: "elakusnlgvkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,232.22l6-3.44c.6-.34,1.09-.06,1.09.63v2.19a2.38,2.38,0,0,1-1.09,1.87l-6,3.44c-.59.35-1.08.07-1.08-.62V234.1A2.43,2.43,0,0,1,185,232.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 232.848px"
    },
    id: "elc67and9haki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,241.81l6-3.45c.6-.34,1.09-.06,1.09.63v2.19a2.41,2.41,0,0,1-1.09,1.88l-6,3.44c-.59.34-1.08.06-1.08-.63v-2.19A2.39,2.39,0,0,1,185,241.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 242.43px"
    },
    id: "elediurxaiy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,251.39l6-3.44c.6-.35,1.09-.07,1.09.62v2.19a2.41,2.41,0,0,1-1.09,1.88l-6,3.44c-.59.34-1.08.06-1.08-.63v-2.19A2.39,2.39,0,0,1,185,251.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 252.012px"
    },
    id: "el2q64ixt8jpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,261l6-3.44c.6-.35,1.09-.07,1.09.62v2.19a2.41,2.41,0,0,1-1.09,1.88l-6,3.44c-.59.34-1.08.06-1.08-.63v-2.19A2.39,2.39,0,0,1,185,261Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 261.622px"
    },
    id: "elxk3j16toa49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,270.55l6-3.44c.6-.35,1.09-.07,1.09.62v2.19A2.4,2.4,0,0,1,191,271.8l-6,3.44c-.59.35-1.08.07-1.08-.62v-2.2A2.41,2.41,0,0,1,185,270.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 271.175px"
    },
    id: "ely72uijcu92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,280.13l6-3.44c.6-.34,1.09-.06,1.09.63v2.19a2.38,2.38,0,0,1-1.09,1.87l-6,3.44c-.59.35-1.08.07-1.08-.62V282A2.43,2.43,0,0,1,185,280.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 280.758px"
    },
    id: "elz900pqa2o0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,289.71l6-3.44c.6-.34,1.09-.06,1.09.63v2.19A2.38,2.38,0,0,1,191,291l-6,3.44c-.59.35-1.08.07-1.08-.62v-2.19A2.43,2.43,0,0,1,185,289.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 290.358px"
    },
    id: "eljo0h0w2u6ws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,299.29l6-3.44c.6-.34,1.09-.06,1.09.63v2.19a2.38,2.38,0,0,1-1.09,1.87L185,304c-.59.34-1.08.06-1.08-.63v-2.19A2.43,2.43,0,0,1,185,299.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 299.925px"
    },
    id: "elka3bkm2qr7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,308.88l6-3.44c.6-.35,1.09-.07,1.09.62v2.19a2.41,2.41,0,0,1-1.09,1.88l-6,3.44c-.59.34-1.08.06-1.08-.63v-2.19A2.39,2.39,0,0,1,185,308.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.005px 309.502px"
    },
    id: "elfigytpo6drv",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,208.54l32.22-18.61c1.2-.69,2.17-.13,2.17,1.25V228.4a4.8,4.8,0,0,1-2.17,3.75l-32.22,18.6c-1.2.69-2.17.13-2.17-1.25V212.29A4.78,4.78,0,0,1,145.48,208.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "161.59px 220.34px"
    },
    id: "elgi7ave0aco9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,242l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,242Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 242.333px"
    },
    id: "eltubujewerx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzz66nvsza4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,242l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,242Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 242.333px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,211.5l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,211.5Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 211.83px"
    },
    id: "eliww5telw45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj6lwo5lyn8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,211.5l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,211.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 211.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,215.17l3-1.71c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-3,1.71c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,152.64,215.17Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 215.501px"
    },
    id: "elkt8owsh9zle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhbf459afv8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,215.17l3-1.71c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-3,1.71c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,152.64,215.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 215.501px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,221.25l3-1.71c.61-.35,1.1-.1,1.1.56a2.33,2.33,0,0,1-1.1,1.81l-3,1.71c-.61.35-1.1.11-1.1-.55A2.34,2.34,0,0,1,152.64,221.25Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 221.581px"
    },
    id: "el6n98oms8494",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliwttjt68bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,221.25l3-1.71c.61-.35,1.1-.1,1.1.56a2.33,2.33,0,0,1-1.1,1.81l-3,1.71c-.61.35-1.1.11-1.1-.55A2.34,2.34,0,0,1,152.64,221.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 221.581px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,229.78l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,229.78Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 230.11px"
    },
    id: "elt0h0m6lnpaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwcy16414cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,229.78l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,229.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 230.11px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,233.46l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,233.46Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 233.79px"
    },
    id: "el3hbhtjngs8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqh4l2cph1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,233.46l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,233.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 233.79px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,206.81l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,206.81Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 202.765px"
    },
    id: "el8gtzwhxfnty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvexr74kawck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,206.81l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,206.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 202.765px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,237.28l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,237.28Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 233.242px"
    },
    id: "elsbybizwi0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzjrquzfq0y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,237.28l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,237.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 233.242px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,210.48l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,210.48Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 207.67px"
    },
    id: "elcvv5j4fabc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbwqv3my07x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,210.48l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,210.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 207.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,216.58l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,216.58Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 213.765px"
    },
    id: "elaay0vj8za8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqgmelnpcfcd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,216.58l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,216.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 213.765px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,225.09l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,225.09Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 221.052px"
    },
    id: "ele4v54wy6smo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwy8vt6ah1wc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,225.09l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,225.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 221.052px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,228.77l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,228.77Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 225.955px"
    },
    id: "elaqxur51jgxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqwldua925hk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,228.77l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,228.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 225.955px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,257.75l32.22-18.6c1.2-.69,2.17-.13,2.17,1.25v73.53a4.78,4.78,0,0,1-2.17,3.75l-32.22,18.61c-1.2.69-2.17.13-2.17-1.25V261.5A4.78,4.78,0,0,1,145.48,257.75Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "161.59px 287.72px"
    },
    id: "elstz8owo1k7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,260.71l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,260.71Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 261.045px"
    },
    id: "elmetxn7650o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfer7vltxo7v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,260.71l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,260.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 261.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,264.39l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,264.39Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 264.72px"
    },
    id: "el6jfpwzv21gy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnk9jpmoflx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,264.39l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,264.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 264.72px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,270.47l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,270.47Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 270.8px"
    },
    id: "el8axzpps0aix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrnnqnhr33cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,270.47l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,270.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 270.8px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,279l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,279Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 279.335px"
    },
    id: "el87bquainwj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbil4jt0zddw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,279l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,279Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 279.335px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,256l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82L156.59,258.4c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,256Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 251.972px"
    },
    id: "el8k4knzmk86b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliwr8ny2ano"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,256l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82L156.59,258.4c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,256Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 251.972px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,259.7l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,259.7Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 256.885px"
    },
    id: "elof57hleegma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1vyv6jk7cqc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,259.7l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,259.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 256.885px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,265.79l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,265.79Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 262.982px"
    },
    id: "elpp341jcn5us",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elasfwe0sl0un"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,265.79l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,265.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 262.982px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,274.31l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,274.31Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 270.265px"
    },
    id: "elab9h0xnq5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljmojvzge8m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,274.31l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,274.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 270.265px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,282.71l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,282.71Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 283.04px"
    },
    id: "eltvmwpewp1nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqf01vttelwj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,282.71l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,282.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 283.04px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,288.79l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,288.79Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 289.12px"
    },
    id: "elhx6b30yzu2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldzzhf5a364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,288.79l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,288.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 289.12px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,278l14-8c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,278Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 275.185px"
    },
    id: "el4zco0hbuu74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el86zkad7k5pq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,278l14-8c.61-.35,1.1-.1,1.1.56a2.32,2.32,0,0,1-1.1,1.81l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,278Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 275.185px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,284.11l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,284.11Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 281.295px"
    },
    id: "elv33hkhct1bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhlmlwuu77b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,284.11l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,284.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 281.295px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,309.54l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.7c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,148.47,309.54Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 309.871px"
    },
    id: "el0a9mxo2sjx46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1raw7z925mo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,309.54l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.7c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,148.47,309.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 309.871px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,304.86l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,304.86Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 300.815px"
    },
    id: "el6kswytgsgav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj2nrn1vssz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,304.86l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,304.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 300.815px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,313.26l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,313.26Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 313.59px"
    },
    id: "el7nwdtbln3er",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliko99exch58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,313.26l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,313.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 313.59px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,319.34l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,319.34Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 319.67px"
    },
    id: "ele4bhzptszcv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els84nc4atmwi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,319.34l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,152.64,319.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 319.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,308.57l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,308.57Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 305.755px"
    },
    id: "el38uzyrrxjh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ely1qvy0dwcnd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,308.57l14-8c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.76,308.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 305.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,314.66l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,314.66Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 311.852px"
    },
    id: "elmayllvh061b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elad5rornu1xl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,314.66l14-8c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,160.76,314.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 311.852px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,294.83l3-1.7c.61-.35,1.1-.11,1.1.55a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,152.64,294.83Z",
    style: {
      fill: "current",
      transformOrigin: "154.14px 295.169px"
    },
    id: "el4uf2cdza4cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elko3fuz07l3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.64,294.83l3-1.7c.61-.35,1.1-.11,1.1.55a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,152.64,294.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "154.14px 295.169px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,303.36l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,303.36Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 303.693px"
    },
    id: "elncojnzagrko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elty9chx3to5n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,303.36l3-1.71c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-3,1.71c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,148.47,303.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 303.693px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,290.16l14-8c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.11-1.09-.55A2.37,2.37,0,0,1,160.76,290.16Z",
    style: {
      fill: "current",
      transformOrigin: "167.765px 287.351px"
    },
    id: "el7w5i7nw9wxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpq32r7m90ji"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.76,290.16l14-8c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-14,8c-.6.35-1.09.11-1.09-.55A2.37,2.37,0,0,1,160.76,290.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "167.765px 287.351px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,298.68l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,298.68Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 294.635px"
    },
    id: "elp5ta3lozh6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elctahk1sgk6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,298.68l18.12-10.46c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,156.59,298.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 294.635px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,328l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,328Z",
    style: {
      fill: "current",
      transformOrigin: "149.97px 328.33px"
    },
    id: "elz2nio37l1et",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq6qxnse92l8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.47,328l3-1.71c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-3,1.71c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,148.47,328Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.97px 328.33px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,323.26l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,323.26Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 319.222px"
    },
    id: "elf3jqcmwf57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els48ifkdqrcn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.59,323.26l18.12-10.46c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-18.12,10.46c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,156.59,323.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "165.655px 319.222px"
    },
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.38px 140.61px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 208.145px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 208.145px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 208.145px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.34,171.12l-34.12,19.66a3,3,0,0,0-1.36,2.36V239.8a2.94,2.94,0,0,0,1.37,2.34l5.42,3.08a3,3,0,0,0,2.73,0l34.12-19.65a3,3,0,0,0,1.36-2.36V176.54a3,3,0,0,0-1.37-2.35l-5.42-3.08A3,3,0,0,0,410.34,171.12Z",
    style: {
      fill: "current",
      transformOrigin: "397.36px 208.167px"
    },
    id: "eln9p4hsvl6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw3shcw2667"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.38,245.21a3.12,3.12,0,0,1-2.73,0l-5.42-3.09a3,3,0,0,1-1.37-2.34V193.14a2.82,2.82,0,0,1,.43-1.39l8.13,4.68a2.7,2.7,0,0,0-.4,1.34v46.65C383,245.22,383.58,245.68,384.38,245.21Z",
    style: {
      opacity: 0.2,
      transformOrigin: "379.62px 218.637px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elydisgnjsxg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.84,176.29c-.1-.68-.66-.93-1.34-.54l-34.11,19.66a2.81,2.81,0,0,0-1,1l-8.13-4.68a2.71,2.71,0,0,1,.93-1l34.12-19.66a3,3,0,0,1,2.73,0l5.42,3.08A3,3,0,0,1,419.84,176.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "397.55px 183.576px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,227.74c-.86-.51-7.39-4.19-7.59-4.31a1.27,1.27,0,0,1-.28-1.94L374.86,207,383,211.7l-12.13,14.13A1.29,1.29,0,0,0,371.13,227.74Z",
    style: {
      fill: "current",
      transformOrigin: "372.965px 217.37px"
    },
    id: "ely9xq23dkvw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp00apjyqyb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.13,227.74c-.86-.51-7.39-4.19-7.59-4.31a1.27,1.27,0,0,1-.28-1.94L374.86,207,383,211.7l-12.13,14.13A1.29,1.29,0,0,0,371.13,227.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "372.965px 217.37px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,175.75l-34.12,19.66a3,3,0,0,0-1.36,2.36V211.7l-12.13,14.13a1.22,1.22,0,0,0,.78,2.09L383,229.43h0v15c0,.87.61,1.23,1.36.79l34.12-19.65a3,3,0,0,0,1.36-2.36V176.54C419.86,175.67,419.25,175.32,418.5,175.75Z",
    style: {
      fill: "current",
      transformOrigin: "395.182px 210.487px"
    },
    id: "elewya3ygekef",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-1--inject-13",
    d: "M414.63,207.63l-2.75-.14c-.2,0-.34-.28-.33-.6a15.49,15.49,0,0,0-.11-2.3,1.67,1.67,0,0,1,.18-1l2.72-3.86a1,1,0,0,0,0-.86L413,196c-.12-.28-.35-.36-.51-.2l-3,3.21a.45.45,0,0,1-.61,0,5.14,5.14,0,0,0-1.33-.79.64.64,0,0,1-.27-.68l.68-4.35c0-.3-.07-.53-.27-.51l-3.21.38a.76.76,0,0,0-.5.55l-1.33,4.54a1.24,1.24,0,0,1-.48.67,11.79,11.79,0,0,0-2,1.35.41.41,0,0,1-.58-.17L398,197.7c-.15-.23-.39-.27-.54-.09l-3.18,3.9a1.08,1.08,0,0,0-.1.88l.95,3a1.36,1.36,0,0,1-.06.94,26.36,26.36,0,0,0-1.36,2.83,1,1,0,0,1-.52.56l-3.05.84a.84.84,0,0,0-.46.63l-1.11,4.92c-.07.3,0,.54.23.55l2.76.15c.19,0,.33.27.33.6a15.46,15.46,0,0,0,.1,2.29,1.58,1.58,0,0,1-.17,1l-2.73,3.87a.94.94,0,0,0,0,.85l1.35,2.93c.13.27.36.36.52.19l3-3.2a.45.45,0,0,1,.61,0,4.86,4.86,0,0,0,1.33.8.62.62,0,0,1,.26.68l-.67,4.34c-.05.31.07.54.26.52l3.22-.38a.77.77,0,0,0,.49-.55l1.34-4.54a1.2,1.2,0,0,1,.47-.67,12,12,0,0,0,2-1.35.4.4,0,0,1,.58.17l1.5,2.29c.15.24.39.28.54.09l3.18-3.9a1,1,0,0,0,.09-.87l-.94-3a1.39,1.39,0,0,1,.05-.95,24.44,24.44,0,0,0,1.36-2.82,1,1,0,0,1,.53-.56l3.05-.84a.91.91,0,0,0,.46-.63l1.11-4.93C414.93,207.89,414.83,207.64,414.63,207.63Zm-7.58,3.87c-1,4.5-4.21,8.43-7.14,8.78s-4.5-3-3.49-7.52,4.21-8.42,7.15-8.77S408.06,207,407.05,211.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "401.698px 212.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 140.59px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 140.59px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.395px 140.59px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.34,103.57l-34.12,19.66a3,3,0,0,0-1.36,2.36v46.65a3,3,0,0,0,1.37,2.35l5.42,3.08a3,3,0,0,0,2.73,0L418.5,158a3,3,0,0,0,1.36-2.36V109a3,3,0,0,0-1.37-2.35l-5.42-3.08A3,3,0,0,0,410.34,103.57Z",
    style: {
      fill: "current",
      transformOrigin: "397.36px 140.62px"
    },
    id: "el8s08httr4kd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcou1z9m2qzj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.38,177.66a3.12,3.12,0,0,1-2.73,0l-5.42-3.08a3,3,0,0,1-1.37-2.35V125.59a2.89,2.89,0,0,1,.43-1.4l8.13,4.68a2.77,2.77,0,0,0-.4,1.35v46.65C383,177.67,383.58,178.12,384.38,177.66Z",
    style: {
      opacity: 0.2,
      transformOrigin: "379.62px 151.082px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf3gqt5zq39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.84,108.74c-.1-.69-.66-.93-1.34-.54l-34.11,19.65a3,3,0,0,0-1,1l-8.13-4.68a2.68,2.68,0,0,1,.93-1l34.12-19.66a3,3,0,0,1,2.73,0l5.42,3.08A3,3,0,0,1,419.84,108.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "397.55px 116.016px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,160.19c-.86-.51-7.39-4.19-7.59-4.31a1.28,1.28,0,0,1-.28-1.95l11.6-14.46,8.16,4.68-12.13,14.13A1.29,1.29,0,0,0,371.13,160.19Z",
    style: {
      fill: "current",
      transformOrigin: "372.975px 149.83px"
    },
    id: "el93e8nhe30m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmjfj01s5bjp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.13,160.19c-.86-.51-7.39-4.19-7.59-4.31a1.28,1.28,0,0,1-.28-1.95l11.6-14.46,8.16,4.68-12.13,14.13A1.29,1.29,0,0,0,371.13,160.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "372.975px 149.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,108.2l-34.12,19.65a3,3,0,0,0-1.36,2.37v13.93l-12.13,14.12a1.22,1.22,0,0,0,.78,2.09L383,161.88h0v15c0,.87.61,1.22,1.36.79L418.5,158a3,3,0,0,0,1.36-2.36V109C419.86,108.12,419.25,107.77,418.5,108.2Z",
    style: {
      fill: "current",
      transformOrigin: "395.192px 142.935px"
    },
    id: "elnjmy9s89nt",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "401.445px 143.515px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.82,149.53a2.28,2.28,0,0,1,.5-1.42l.3-.36a3.63,3.63,0,0,0,.72-1.53,7.47,7.47,0,0,0,.22-1.78,13,13,0,0,1,.54-3.81,14.57,14.57,0,0,1,1.37-3.21,11.76,11.76,0,0,1,1.87-2.48,9.9,9.9,0,0,1,2.07-1.64c.11-.06.2-.06.27,0a.45.45,0,0,1,.11.35v3.68a1,1,0,0,1-.1.46.85.85,0,0,1-.23.32,6.71,6.71,0,0,0-.88.81,5.4,5.4,0,0,0-.71,1,4.5,4.5,0,0,0-.48,1.21,6.22,6.22,0,0,0-.16,1.48,13.52,13.52,0,0,1-.11,1.71,11.66,11.66,0,0,1-.28,1.51,10,10,0,0,1-.41,1.21,2.92,2.92,0,0,1-.48.79.63.63,0,0,1,.48.28,3.2,3.2,0,0,1,.41.79,6.33,6.33,0,0,1,.28,1.19,10,10,0,0,1,.11,1.5,4.08,4.08,0,0,0,.16,1.28,1.14,1.14,0,0,0,.48.67,1.19,1.19,0,0,0,.71.17,2.84,2.84,0,0,0,.88-.22.25.25,0,0,1,.23.06.46.46,0,0,1,.1.34v3.69a1.05,1.05,0,0,1-.11.48.66.66,0,0,1-.27.33,5.77,5.77,0,0,1-2.07.75,2.88,2.88,0,0,1-1.87-.31,3.42,3.42,0,0,1-1.37-1.63,7.72,7.72,0,0,1-.54-3.2,4.83,4.83,0,0,0-.22-1.53c-.14-.44-.38-.67-.72-.7h-.3c-.33,0-.5-.32-.5-.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.806px 146.219px"
    },
    id: "elsimume5ipg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.07,137.51a2.23,2.23,0,0,1-.51,1.42l-.3.36a3.75,3.75,0,0,0-.72,1.53,7.53,7.53,0,0,0-.22,1.78,13.46,13.46,0,0,1-.53,3.82,15.06,15.06,0,0,1-1.37,3.21,12.72,12.72,0,0,1-1.88,2.48,9.83,9.83,0,0,1-2.07,1.63.21.21,0,0,1-.27,0,.52.52,0,0,1-.11-.36v-3.68a1.06,1.06,0,0,1,.1-.46.94.94,0,0,1,.23-.32,5.6,5.6,0,0,0,.88-.81,5.45,5.45,0,0,0,.72-1,4.84,4.84,0,0,0,.47-1.21,6.2,6.2,0,0,0,.17-1.48,12.58,12.58,0,0,1,.1-1.62,12.83,12.83,0,0,1,.29-1.52,9.83,9.83,0,0,1,.41-1.26,3,3,0,0,1,.47-.82.63.63,0,0,1-.47-.25,2.6,2.6,0,0,1-.41-.73,5.81,5.81,0,0,1-.29-1.18,10.91,10.91,0,0,1-.1-1.59,4.07,4.07,0,0,0-.17-1.29,1.21,1.21,0,0,0-.47-.67,1.3,1.3,0,0,0-.72-.17,2.91,2.91,0,0,0-.88.22.21.21,0,0,1-.23-.06.46.46,0,0,1-.1-.34v-3.68a1.21,1.21,0,0,1,.11-.49.77.77,0,0,1,.27-.33,6.18,6.18,0,0,1,2.07-.75,2.86,2.86,0,0,1,1.88.32,3.4,3.4,0,0,1,1.37,1.62,7.94,7.94,0,0,1,.53,3.2,4.75,4.75,0,0,0,.22,1.53c.14.45.39.68.72.7h.3q.51.06.51.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "409.079px 140.819px"
    },
    id: "elgpuzdlzzj85",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.38px 73.048px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.38px 73.048px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "391.38px 73.048px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.34,36,376.22,55.67A3,3,0,0,0,374.86,58v46.66a3,3,0,0,0,1.37,2.35l5.42,3.08a3,3,0,0,0,2.73,0L418.5,90.45a3,3,0,0,0,1.36-2.36V41.44a3,3,0,0,0-1.37-2.35L413.07,36A3,3,0,0,0,410.34,36Z",
    style: {
      fill: "current",
      transformOrigin: "397.36px 73.045px"
    },
    id: "elje39gld91rd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5w6xqhutuoe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.38,110.11a3.12,3.12,0,0,1-2.73,0L376.23,107a3,3,0,0,1-1.37-2.34V58a2.85,2.85,0,0,1,.43-1.39l8.13,4.68a2.73,2.73,0,0,0-.4,1.34v46.66C383,110.11,383.58,110.57,384.38,110.11Z",
    style: {
      opacity: 0.2,
      transformOrigin: "379.62px 83.5172px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz9oaooibp5h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.84,41.19c-.1-.69-.66-.93-1.34-.54L384.39,60.3a2.81,2.81,0,0,0-1,1l-8.13-4.68a2.71,2.71,0,0,1,.93-1L410.34,36a3,3,0,0,1,2.73,0l5.42,3.09A3,3,0,0,1,419.84,41.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "397.55px 48.4857px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,92.63c-.86-.51-7.39-4.18-7.59-4.3a1.28,1.28,0,0,1-.28-2l11.6-14.46L383,76.6,370.89,90.72A1.28,1.28,0,0,0,371.13,92.63Z",
    style: {
      fill: "current",
      transformOrigin: "372.95px 82.25px"
    },
    id: "elfngezil3d1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloizhqd5x6x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.13,92.63c-.86-.51-7.39-4.18-7.59-4.3a1.28,1.28,0,0,1-.28-2l11.6-14.46L383,76.6,370.89,90.72A1.28,1.28,0,0,0,371.13,92.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "372.95px 82.25px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,40.65,384.38,60.3A3,3,0,0,0,383,62.66V76.6L370.89,90.72a1.22,1.22,0,0,0,.78,2.09L383,94.33h0v15c0,.87.61,1.22,1.36.79L418.5,90.45a3,3,0,0,0,1.36-2.36V41.44C419.86,40.57,419.25,40.21,418.5,40.65Z",
    style: {
      fill: "current",
      transformOrigin: "395.192px 75.3828px"
    },
    id: "el0fbbc4rpejg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "401.464px 75.8244px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.42,83.38a1.77,1.77,0,0,1,.13-.73,4.34,4.34,0,0,1,.37-.69l7-11.29.12-.13a.21.21,0,0,1,.08-.06.2.2,0,0,1,.26,0,.46.46,0,0,1,.1.34v4.36a1.83,1.83,0,0,1-.2.91,5.3,5.3,0,0,1-.36.59l-3,4.69,3,1.2a1.16,1.16,0,0,1,.36.17c.14.08.2.3.2.66v4.35a1.07,1.07,0,0,1-.1.47.68.68,0,0,1-.26.31l-.08,0a.24.24,0,0,1-.12,0l-7-3.22a1,1,0,0,1-.37-.26.9.9,0,0,1-.13-.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "391.448px 79.4848px"
    },
    id: "el2mkfky6ertj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.64,64.25a3.61,3.61,0,0,1,.26-.71,1.21,1.21,0,0,1,.51-.54l2.33-1.35a.22.22,0,0,1,.28,0,.52.52,0,0,1,.11.36,1,1,0,0,1,0,.26l-5.9,25.15a2.73,2.73,0,0,1-.24.67,1.33,1.33,0,0,1-.52.58L397.14,90a.21.21,0,0,1-.27,0,.46.46,0,0,1-.12-.35,1.6,1.6,0,0,1,0-.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "401.441px 75.8244px"
    },
    id: "elbtvb5rsen4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.47,68.31a2,2,0,0,1-.13.74,6.35,6.35,0,0,1-.38.69L408,81a1,1,0,0,1-.12.14l-.07,0a.21.21,0,0,1-.27,0,.45.45,0,0,1-.1-.34V76.51a1.87,1.87,0,0,1,.2-.9A5.06,5.06,0,0,1,408,75l3-4.72-3-1.17a1.21,1.21,0,0,1-.36-.18c-.13-.09-.2-.32-.2-.68V63.93a1,1,0,0,1,.1-.46.72.72,0,0,1,.27-.32l.07,0H408l7,3.23a1.09,1.09,0,0,1,.38.25,1,1,0,0,1,.13.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "411.475px 72.1696px"
    },
    id: "el2v5xgooha9m",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "344.091px 337.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1--inject-13",
    className: "animable",
    style: {
      transformOrigin: "344.091px 337.593px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.22,281.84c5.26.81,8.46,3.8,8.61,8s-6.39,20-6.39,20c7.24,6.56,12.2,10.9,15.73,13.41,2.79,2,10.37,11.14,10.15,13s-3.29-1.92-5.26-3.86S346.27,330.09,342,328s-18.4-9.16-20.24-11.71S329.22,281.84,329.22,281.84Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "339.422px 309.295px"
    },
    id: "elqt6ifj3u41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.73,281.74a12.28,12.28,0,0,1,4.53,1.07,8.38,8.38,0,0,1,4.71,5.63c.38,2.31-.53,6.16-2.14,10.35a91.39,91.39,0,0,1-4.07,8.8l-3-2.43Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "333.393px 294.665px"
    },
    id: "elenn90zc5h4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66,399s1.35,9.19,4,12.6c2.43,3.08,4.17,7,7,10.21.63.7,2,2,2.56,2.56a1.1,1.1,0,0,1-.09,1.71c-1.23,1.22-6.53,1.6-9.55-.58s-6-6.37-7.82-8.14c-.9-.88-1.75-1.72-2.37-2.35a2.38,2.38,0,0,1-.64-2.28c.05-.23.12-.5.19-.82.38-1.73-2-8.72-2-8.72Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "365.263px 413.033px"
    },
    id: "els0ilzp81k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.26,416.87a4.69,4.69,0,0,0,.29,1.65,7.34,7.34,0,0,0,2.81,2.09,6.31,6.31,0,0,1,3.09,3.19,11.06,11.06,0,0,0,5.23,5.05,15.91,15.91,0,0,0,9.41.79c3.92-.78,4.19-3.11,4.19-3.11s.17-2.18-.82-2.5S356.26,416.87,356.26,416.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.776px 423.443px"
    },
    id: "ell0ut5vseez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,407.28a21.06,21.06,0,0,1,.26,5.65c-.08,1.14-.11,2.94.75,3.94,1.19,1.58,3.68,2.05,5.31,4.21s4,6.08,9.19,7,9-.79,10-2.27,0-2.85-3.31-4.57c-3.53-1.82-8.25-7.36-8.25-7.36a19.77,19.77,0,0,1-3.33-5.54l-1.26-4c-.27-.78-5.82.9-6.41,2l.67,3.54-1.43-3.35A3.59,3.59,0,0,0,355.25,407.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "368.19px 416.24px"
    },
    id: "elpb580tcq09n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.4,426.92a6.54,6.54,0,0,1,3.7-5.66c3.84-2.06,6.23-.83,7.43,0,1.43,1,3.5,3.08,2.3,4.64s-3.4,2.53-7.36,2.65A9.41,9.41,0,0,1,367.4,426.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "374.295px 424.355px"
    },
    id: "elvt3drpjfph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.85,415a.45.45,0,0,0,.35-.19c.43-.62,3.21-3,5.95-2.27.13-.31-.1-.63-.67-1a8,8,0,0,0-6,2.76.41.41,0,0,0,.12.59A.46.46,0,0,0,361.85,415Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "364.794px 413.27px"
    },
    id: "elypdiz849hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.75,414.55a1.34,1.34,0,0,0-.79-.93,8.19,8.19,0,0,0-5.67,2.78.42.42,0,0,0,.13.59.52.52,0,0,0,.27.07.45.45,0,0,0,.35-.19C364.45,416.26,367.09,414,369.75,414.55Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "366.485px 415.34px"
    },
    id: "el3cdrd9rxwm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.92,410.67a.78.78,0,0,0-.56-1.06c-3.13-.68-6.18,1.84-6.74,2.66a.4.4,0,0,0,.13.58.36.36,0,0,0,.26.07.42.42,0,0,0,.35-.19C360.82,412.06,364,409.4,366.92,410.67Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "363.262px 411.209px"
    },
    id: "elfcz17f419jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.12,418.89a2.49,2.49,0,0,0-1.24-1.12,8,8,0,0,0-5.91,2.77.41.41,0,0,0,.13.59.48.48,0,0,0,.26.07.46.46,0,0,0,.35-.2C368.17,420.35,371.24,417.77,374.12,418.89Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "370.508px 419.485px"
    },
    id: "el1ksahsrx54hj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53,419.13a.51.51,0,0,0,.35-.19c.42-.62,3.14-2.92,5.85-2.29a1.51,1.51,0,0,0-.93-1,8.17,8.17,0,0,0-5.67,2.78.41.41,0,0,0,.13.59A.5.5,0,0,0,365.53,419.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "368.393px 417.39px"
    },
    id: "ele2cyd1cq6c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,325.85c-1,5.79-1.35,9.06.69,14.91s8.8,10.57,17,15.14c6.76,3.79,16.73,9.25,18.75,10.11s2.25,2.06,2,5.88,1.21,10.05,5.59,17.79c4.63,8.19,7.66,14.76,7.66,14.76a28.54,28.54,0,0,1,9.12-3.34s-8.47-37.91-10.26-42.87-20.84-20.76-20.84-20.76,1.87-7.94,3.25-13.72Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "332.716px 364.095px"
    },
    id: "elzu19smn1c5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.74,388.9s2.48,7.66,4.46,11.24a55.33,55.33,0,0,0,7,10.21c.63.7,2.05,2,2.56,2.56a1.1,1.1,0,0,1-.09,1.71c-1.23,1.22-6.53,1.6-9.55-.58s-6-6.37-7.82-8.13L376,403.56a2.42,2.42,0,0,1-.64-2.29c.06-.23.12-.5.19-.82.38-1.72-2-8.72-2-8.72Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "384.838px 402.253px"
    },
    id: "ellf2paygilks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,314.38c-1,5.79-1.35,9.06.69,14.91s6.78,15.13,14.95,19.71c6.77,3.79,17,7.65,19,8.54,1.55.69,2.07,2.37,2.73,6.56.6,3.79,2.43,7.92,6.81,15.67C371,388,373.92,393,373.92,393a19.15,19.15,0,0,1,8.49-3.11s-9.71-36.22-11.49-41.18-14.72-12.25-20.27-15.45-8.65-5.19-15-9.48Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "351.916px 353.69px"
    },
    id: "elzd9ui3o7uvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.7,405.36A4.69,4.69,0,0,0,376,407a7.28,7.28,0,0,0,2.81,2.1,6.21,6.21,0,0,1,3.08,3.19,11.06,11.06,0,0,0,5.24,5,15.89,15.89,0,0,0,9.41.79c3.92-.78,4.19-3.1,4.19-3.1s.16-2.19-.82-2.51S375.7,405.36,375.7,405.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.22px 411.908px"
    },
    id: "el5ypswxzgl6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,395.77a21.15,21.15,0,0,1,.27,5.65c-.09,1.14-.11,2.94.75,3.94,1.18,1.58,3.68,2.06,5.3,4.22s4,6.07,9.19,7,9-.79,10-2.27,0-2.85-3.3-4.56c-3.54-1.82-8.26-7.37-8.26-7.37a20.34,20.34,0,0,1-3.33-5.53l-1-3.77c-.28-.78-5.92.67-6.51,1.78l.69,3.44-1.55-3.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "387.62px 404.851px"
    },
    id: "elcicp00fwdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,415.41a6.54,6.54,0,0,1,3.7-5.66c3.84-2.06,6.22-.83,7.42,0,1.44,1,3.5,3.08,2.3,4.65s-3.4,2.52-7.35,2.65A9.45,9.45,0,0,1,386.84,415.41Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "393.73px 412.849px"
    },
    id: "el3ceqonwvnmx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.29,403.48a.45.45,0,0,0,.35-.19c.42-.62,3.2-3,5.94-2.26.14-.32-.1-.64-.66-1a8,8,0,0,0-6,2.76.41.41,0,0,0,.13.59A.37.37,0,0,0,381.29,403.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "384.232px 401.755px"
    },
    id: "elm0qxjpxbf2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.19,403.05a1.36,1.36,0,0,0-.79-.94,8.17,8.17,0,0,0-5.67,2.78.43.43,0,0,0,.39.66.42.42,0,0,0,.35-.19C383.89,404.76,386.53,402.53,389.19,403.05Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "385.926px 403.83px"
    },
    id: "el2pow47uscv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35,399.16a.78.78,0,0,0-.55-1.06c-3.14-.68-6.19,1.84-6.75,2.66a.42.42,0,0,0,.13.59.52.52,0,0,0,.27.07.48.48,0,0,0,.35-.19C380.26,400.56,383.43,397.89,386.35,399.16Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.695px 399.702px"
    },
    id: "el71b9tmzx47g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55,407.38a2.41,2.41,0,0,0-1.24-1.12A8.07,8.07,0,0,0,386.4,409a.42.42,0,0,0,.13.59.52.52,0,0,0,.27.07.48.48,0,0,0,.35-.19C387.6,408.84,390.67,406.26,393.55,407.38Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "389.94px 407.96px"
    },
    id: "el7jke67wg5r4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,407.62a.45.45,0,0,0,.35-.19c.43-.62,3.15-2.92,5.86-2.29a1.55,1.55,0,0,0-.94-1,8.14,8.14,0,0,0-5.66,2.78.41.41,0,0,0,.12.59A.54.54,0,0,0,385,407.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.871px 405.88px"
    },
    id: "eltudxml2flsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,332.29a46.21,46.21,0,0,1-4.1,5.18l1.16,1A16.38,16.38,0,0,0,336.52,332.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "334.47px 335.38px"
    },
    id: "elye2ujv8lp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.64,282.23a35.47,35.47,0,0,0-6.8,1s4.06,4.81,1.45,13.35c-1.85,6-3.33,6.31-6.8,7.46,2.39,10.27-.19,24.24-.19,24.24s6.63,5.35,20.76,4.07c12.41-1.13,12.61-8.62,12.61-8.62l-4.33-4.86.6-9.45s4.6-3.25,4.36-10.71c-.28-8.6-7.24-17-7.24-17a21,21,0,0,0-4.38-.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "319.305px 307.021px"
    },
    id: "eljw2lu7i7mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72,329c-6.41,1.11-15.56-.25-18.73-3.52s-4.91-11-3.44-15.53,1.2-13,.27-18l-.55-.19a25.13,25.13,0,0,1-1,4.92c-1.85,6-3.33,6.31-6.8,7.46,2.18,10-.19,24.24-.19,24.24s6.63,5.35,20.76,4.07c4-.37,7.39-1.46,9.66-3.41Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "317.5px 312.204px"
    },
    id: "eln84jd0s2xr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49,245.39a17.3,17.3,0,0,0-19.82,14.34,14.45,14.45,0,0,0,12,16.55l5.65.9c7.88,1.27,13.54-6.48,15.5-14.21C342.08,253.93,335.93,246.9,326.49,245.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.389px 261.245px"
    },
    id: "elwny89qx0inq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.54,281.74h0A11.5,11.5,0,0,0,308,270.23V255.39h0a11.5,11.5,0,0,0-11.5,11.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.25px 268.565px"
    },
    id: "el0hdr9okxqm68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.32,262.6l-3.14-3.07a2.31,2.31,0,0,1,1.57-1.48l3.15,3.23A2.36,2.36,0,0,1,319.32,262.6Z",
    style: {
      fill: "current",
      transformOrigin: "318.54px 260.325px"
    },
    id: "el93jvq5iszgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.69,256.37c1.63,1.36,3.24,4.61,1.5,14.09-1.48,8-4.42,9.61-5.82,10s-3.88-.39-6.28-1.19l-.58,3.33s3,7.56,1.91,11.24c-.67,2.16-5.26-1.1-8.09-3.77a26.3,26.3,0,0,1-4.86-7.29l1.86-11.17s-1.68,1.18-3.79-1.37c-1.74-2.09-1.94-5.19-.11-6.54a3.57,3.57,0,0,1,5.44,2s.52-4.1,6.69-5.18C328.16,259.7,333.3,260.11,335.69,256.37Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "324.043px 275.457px"
    },
    id: "el0g61heu7etq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75,262c-.74.57-1.28,3.37-1.56,5.16a1.66,1.66,0,0,1-1.78,1.39h0l.46-2.84S316.89,261.16,319.75,262Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.08px 265.226px"
    },
    id: "el6u7brtcd8lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.13,264.12l-.49,0a14.89,14.89,0,0,0-4.94.41c-1.6.56-2.2,1.12-3.07,1.17s-1.48-.46-3.12-.85a16.51,16.51,0,0,0-5.26.12l-.53.08a1,1,0,0,0-.65.9,1.79,1.79,0,0,0,.43,1,1.05,1.05,0,0,1,.15.39,16,16,0,0,0,.44,2.76,3.16,3.16,0,0,0,.6,1c.1.1.21.19.32.28l.19.12a3,3,0,0,0,.57.25l.1,0,.16,0,.16,0,.51.05h.5a4.14,4.14,0,0,0,3.76-2.26c.61-1.08.58-2.57,1.58-2.62h.18c.72.13.53,1.51.93,2.47a3.19,3.19,0,0,0,.63,1l.15.16.09.08.09.07.08.06.09.05.07.05,0,0a3,3,0,0,0,.83.3h.08a5,5,0,0,0,1.05.05,3.52,3.52,0,0,0,3.19-2.09,19.39,19.39,0,0,0,.82-2.83,1.09,1.09,0,0,1,.21-.37,2.24,2.24,0,0,0,.53-1.05C340.67,264.54,340.4,264.14,340.13,264.12Zm-10.66,4.48a3.56,3.56,0,0,1-.86,1.52h0a3.44,3.44,0,0,1-2.42,1,2.33,2.33,0,0,1-2.19-1l-.06-.1-.06-.1s0-.07-.05-.1a.2.2,0,0,0,0-.08l0-.07,0-.06a.49.49,0,0,1,0-.11h0a1.71,1.71,0,0,1-.09-.3h0c0-.06,0-.12-.05-.18s0-.21-.05-.3v-.11c-.11-.73-.2-2.17.19-2.52a4.63,4.63,0,0,1,3-.66h.17a5.82,5.82,0,0,1,.73.08l.28.06a5.89,5.89,0,0,1,.7.19l.21.08.23.1.05,0,.08,0a1.2,1.2,0,0,1,.46.36A3.31,3.31,0,0,1,329.47,268.6Zm9.41-.79a3.67,3.67,0,0,1-1.69,2.44,3,3,0,0,1-1.21.32,2.31,2.31,0,0,1-2.33-1h0a.43.43,0,0,1,0-.07l0-.07,0,0a.61.61,0,0,1-.05-.12l-.06-.13a.14.14,0,0,1,0-.06l0,0s0,0,0-.06l0,0a3,3,0,0,1-.11-.54,3.57,3.57,0,0,1,.21-2.24,5.07,5.07,0,0,1,2.71-1.22c.27-.05.52-.08.75-.1h.85l.36,0,.09,0h0l.06,0,.09,0,.1,0a.49.49,0,0,1,.17.06h0a1.19,1.19,0,0,1,.38.23C339.39,265.6,339.09,267.06,338.88,267.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "331.328px 267.934px"
    },
    id: "elddlpgh4ran5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,265.12l-8-1.9a3.62,3.62,0,0,1,2.2,1.94l5.56,1.34Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "318.49px 264.86px"
    },
    id: "el5qhja7qtyil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83,267.52a1,1,0,0,1-1.14.94,1.07,1.07,0,1,1,1.14-.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.768px 267.396px"
    },
    id: "elhovpcrfa5zq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,274l2.73,1.38a1.49,1.49,0,0,1-2,.73A1.6,1.6,0,0,1,327.24,274Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "328.529px 275.128px"
    },
    id: "elb7wz8ijy37g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.3,263.43l-2.59-.73a1.35,1.35,0,0,1,2.59.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.017px 262.626px"
    },
    id: "ele185d8fh8qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.43,263.06l-2.57.78a1.34,1.34,0,0,1,2.57-.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.117px 262.976px"
    },
    id: "elzremlp27wha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,267.52a1,1,0,0,1-1.13.94,1.07,1.07,0,1,1,1.13-.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.938px 267.395px"
    },
    id: "elrtc0chd82g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,267l-.29,6.32,3.29-.89L331.7,267Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "332.845px 270.16px"
    },
    id: "elvd9p9hz4ow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.09,279.24c-2.54-.76-7.63-3.15-8.12-5.39a5.48,5.48,0,0,0,1.44,3c1.37,1.62,6.42,4,6.42,4Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "321.03px 277.35px"
    },
    id: "elto5lwrdyk3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,346.61v.72a2,2,0,0,0,1,1.77l19.51,11.23a2,2,0,0,0,1,.27,2,2,0,0,0,1-.27l35.79-20.66a2.05,2.05,0,0,0,1-1.77v-.5l-37.83,21.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "343.65px 349px"
    },
    id: "el0whqwkrs4xu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.35,337.4l-21.22-12.25a1.21,1.21,0,0,0-1.22,0L314.1,346.41a.27.27,0,0,0,0,.47l21.42,12.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "343.656px 342.112px"
    },
    id: "eliyvtnlb4qoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,328c1.75.67,1.68,1.18,3.1,2a7.16,7.16,0,0,0,4.35,1.2,24.63,24.63,0,0,0,2.49,2.06c1.87,1.28,3.74,2.26,6,1.53,2.52-.79.74-3.28,0-4.51s-4.8-4.82-5.59-5.55-4.24-1.24-7.25-2.19Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "350.622px 328.79px"
    },
    id: "eljugy685ox4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.32 357.44 323.88 350.84 357.34 331.52 368.85 338.09 335.32 357.44",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "346.365px 344.48px"
    },
    id: "el1qa61nhhos4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.7 339.08 329.91 339.2 335.52 342.44 345.5 336.68 345.7 336.56 339.88 333.2 329.7 339.08",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.7px 337.82px"
    },
    id: "elrcgk2ctspkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.91 339.2 335.52 342.44 345.5 336.68 339.88 333.44 329.91 339.2",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "337.705px 337.94px"
    },
    id: "el3hmxtcpw40a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.52,359.24v1.36a2,2,0,0,0,1-.27l35.79-20.66a2.05,2.05,0,0,0,1-1.77v-.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "354.415px 349px"
    },
    id: "eled4o90sqqgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elas8w5folq8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      transformOrigin: "354.415px 349px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.52,359.24v1.36a2,2,0,0,0,1-.27l35.79-20.66a2.05,2.05,0,0,0,1-1.77v-.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "354.415px 349px"
    },
    id: "elqq2y0nu80qf",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.1,359.54a2.35,2.35,0,0,0,2.08-.16l35.63-20.57a2.41,2.41,0,0,0,1.18-1.69l3.9-23.26a2.85,2.85,0,0,0,0-.4,2.4,2.4,0,0,0-.72-1.72l-37,21.38a1.79,1.79,0,0,0-.87,1.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "357.499px 335.725px"
    },
    id: "el1om5lj1wgqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.52,359.24l.24.14a2.11,2.11,0,0,0,.34.16l4.21-25.17a1.79,1.79,0,0,1,.87-1.25l37-21.38a2.13,2.13,0,0,0-.5-.38l-37.1,21.42a1.82,1.82,0,0,0-.87,1.25Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "356.85px 335.45px"
    },
    id: "elyadikr1pjkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.16,338.07a7.85,7.85,0,0,1,3.59-4.62c1.73-1,2.91-.54,2.65,1a7.85,7.85,0,0,1-3.59,4.62C357.09,340.08,355.9,339.63,356.16,338.07Z",
    style: {
      fill: "current",
      transformOrigin: "359.28px 336.265px"
    },
    id: "ele7ucp56k23c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,338.05c-4.22-2.14-19.37-8-23.93-10.49-3.18-1.73-4.86-2.85-4.39-5.79.43-2.74,7.65-25.89,10.15-31.1,2.19-4.57,5.54-6.09,10.55-7.24,3.47,4,1,16-2.43,20.39-2.49,5.39-6.92,15.25-6.92,15.25s7.85,5.33,14.11,9.17a55.55,55.55,0,0,0,9.68,4.77c2,.72,5.64,2.55,6.29,3.42a66.44,66.44,0,0,1,3.87,7.22c.5,1.35,1.78,4.12-.84,4.44-2.39.29-4.05-1-5.65-2.63a24.33,24.33,0,0,1-2.06-2.48,9.15,9.15,0,0,1-5.1-2.05C317.92,339.87,315.84,338.05,315.84,338.05Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "310.509px 315.78px"
    },
    id: "elq1sd110s3nb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,283s-5.5.52-8.66,3.73-3.29,5.12-4.85,9.22-4.73,14.1-4.73,14.1a11.79,11.79,0,0,0,11.85,4.51l4.18-10.08a24,24,0,0,0,4.07-10C311.52,288.53,311.1,285.08,308.69,283Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "300.742px 298.902px"
    },
    id: "ele9ms4wuqpka",
    className: "animable"
  }))), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoon);
export default __webpack_public_path__ + "static/media/comingsoon.8d5c8401.svg";
export { ForwardRef as ReactComponent };